import { cloneElement } from "react";

export const IconSvg = ({ tag, ...rest }) => {
  const icons = {
    // landing_hero
    btnPlay: (
      <svg
        width="11"
        height="14"
        viewBox="0 0 11 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 6.13398C11.1667 6.51888 11.1667 7.48113 10.5 7.86603L1.5 13.0622C0.833332 13.4471 -6.10471e-07 12.966 -5.76822e-07 12.1962L-1.2256e-07 1.80385C-8.8911e-08 1.03405 0.833333 0.552922 1.5 0.937822L10.5 6.13398Z"
          fill="currentColor"
        />
      </svg>
    ),
    heroImg: (
      <svg
        // width="708"
        // height="530"
        viewBox="0 125 708 530"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="landing_hero__line landing_hero__line--1"
          d="M13.5 346C10.3 344.4 12.1667 342.667 13.5 342L147 264C149.8 262.4 152 263 154 264L238 312.5C240 313.7 239.5 315 238 316L104.5 394C101.7 395.6 99.8462 395.647 97 394C70.5 378.667 16.7 347.6 13.5 346Z"
          stroke="#B4CFBF"
          strokeWidth="1.5"
        />
        <path
          className="landing_hero__line landing_hero__line--5"
          d="M124.5 450C118.9 453.2 120 456 123.5 458L314.5 568C320 571.5 325.1 571.6 331.5 568L521.5 458.5C526.5 455.5 525.9 452.4 521.5 450L329.5 339.5C325 337 319.5 337.5 315.5 340L124.5 450Z"
          stroke="#B4CFBF"
          strokeWidth="1.5"
        />
        <path
          d="M45 409L1.5 434.5L45 459.5L88.5 434.5L45 409Z"
          stroke="#B4CFBF"
        />
        <path
          d="M474.5 602L431 627.5L474.5 652.5L518 627.5L474.5 602Z"
          stroke="#B4CFBF"
          strokeWidth="1.5"
        />
        <path
          d="M662.5 513L619 538.5L662.5 563.5L706 538.5L662.5 513Z"
          stroke="#B4CFBF"
          strokeWidth="1.5"
        />
        <path
          d="M571.5 400L528 425.5L571.5 450.5L615 425.5L571.5 400Z"
          stroke="#B4CFBF"
          strokeWidth="1.5"
        />
        <path
          className="landing_hero__line landing_hero__line--4"
          d="M486.5 371L520.5 391C523.3 392.6 525.5 392.5 528 391L569.75 367L674 427.5C676 428.5 676.5 430 673.5 431.5L452.5 559C450.5 560 448 561.5 445 559L396 530.5"
          stroke="#B4CFBF"
        />
        <path
          className="landing_hero__line landing_hero__line--2"
          d="M199 257.5L408 133L649 272.5L573 316.5"
          stroke="#B4CFBF"
        />
        <path
          className="landing_hero__line landing_hero__line--3"
          d="M437 339C435 340 434.5 342 437 343L521 391.5C523 392.5 525 392.5 527 391.5L611.5 343C614 341.5 614 340 611 338.5L527.5 290.5C525 289 522.5 289.3 520.5 290.5L437 339Z"
          stroke="#B4CFBF"
        />
        <path
          d="M525.289 376.319C524.628 376.319 523.996 376.187 523.524 375.914L489.902 356.498L505.977 347.217L510.101 344.834L523.524 352.586C523.996 352.858 524.628 352.992 525.289 352.992C526.087 352.992 526.93 352.797 527.588 352.417L543.069 343.476L549.546 347.217L563.269 355.141L527.588 375.745C526.93 376.125 526.088 376.319 525.289 376.319ZM489.198 356.091L462.633 340.752C461.591 340.15 461.722 339.1 462.925 338.405L480.946 327.998L509.396 344.426L505.272 346.808L489.198 356.091ZM563.974 354.733L550.251 346.808L543.775 343.069L569.87 327.999L588.185 338.575C589.226 339.176 589.095 340.226 587.893 340.921L563.974 354.733Z"
          fill="#B0C1B8"
        />
        <path
          d="M330.049 548.33C329.388 548.33 328.757 548.197 328.284 547.925L326.195 546.718L336.913 540.528L394.036 507.593L398.011 509.888L332.348 547.756C331.69 548.135 330.849 548.33 330.049 548.33ZM325.49 546.311L281.921 521.15L292.638 514.962L302.119 509.486L328.284 524.596C328.757 524.868 329.388 525.002 330.049 525.002C330.849 525.002 331.69 524.808 332.348 524.427L377.812 498.222L393.33 507.184L393.328 507.185L336.208 540.121L325.49 546.311ZM398.718 509.479L394.744 507.185L394.742 507.184L456.422 471.633L466.092 466.048L468.181 467.254C469.223 467.856 469.092 468.906 467.889 469.601L398.718 509.479ZM394.036 506.776L378.517 497.816L449.868 456.679L465.387 465.641L455.717 471.225L394.036 506.776ZM281.214 520.743L164.83 452.464C164.83 452.464 163.919 450.811 165.122 450.116C166.324 449.421 183.144 439.71 183.144 439.71L301.415 509.079L291.933 514.555L281.214 520.743Z"
          fill="#B0C1B8"
        />
        <path
          d="M100.653 380.58C99.9923 380.58 99.3608 380.448 98.8886 380.175L96.7995 378.969L107.517 372.779L129.3 360.201L133.276 362.496L102.953 380.006C102.294 380.386 101.453 380.58 100.653 380.58ZM96.0947 378.561L52.5252 353.401L63.2428 347.213L72.7241 341.736L98.8886 356.847C99.3608 357.119 99.9923 357.253 100.653 357.253C101.453 357.253 102.294 357.058 102.953 356.678L113.077 350.831L128.594 359.792L128.593 359.793L106.812 372.371L96.0947 378.561ZM133.982 362.087L130.008 359.793L130.007 359.792L203.692 317.296L213.362 311.712L215.451 312.917C216.493 313.519 216.362 314.57 215.159 315.265L133.982 362.087ZM129.3 359.385L113.782 350.424L197.138 302.343L212.657 311.304L202.987 316.889L129.3 359.385ZM51.819 352.993L37.9978 345.013C36.9566 344.411 37.0872 343.361 38.2897 342.666L56.3115 332.259L72.0193 341.329L62.538 346.805L51.819 352.993Z"
          fill="#B0C1B8"
        />
        <g className="landing_hero__modems">
          <g className="landing_hero__stand--modem">
            <path
              d="M100.654 357.253C99.9933 357.253 99.3617 357.119 98.8895 356.847L72.725 341.736L72.0216 341.33L72.0202 341.329L56.3124 332.259L43.992 325.144L42.6638 324.377L37.9987 321.683C37.5462 321.422 37.3276 321.074 37.31 320.709H37.2995L37.2967 311.062V310.248V310.247L37.2961 308.937C37.2967 308.957 37.2978 308.978 37.2995 308.998V309.068L37.3094 309.074C37.3644 309.394 37.5891 309.694 37.9894 309.928C37.9926 309.93 37.996 309.933 37.9987 309.934L98.8895 345.096C98.8994 345.102 98.9092 345.108 98.9191 345.113C98.9261 345.117 98.9318 345.12 98.9388 345.124C99.4026 345.377 100.01 345.502 100.646 345.502C100.649 345.502 100.652 345.502 100.654 345.502H100.66C101.442 345.502 102.267 345.313 102.918 344.948C102.93 344.941 102.941 344.934 102.954 344.928L229.033 272.042C229.062 272.027 229.09 272.01 229.117 271.993C229.121 271.991 229.124 271.988 229.127 271.987C229.129 271.986 229.132 271.983 229.132 271.983L229.135 271.981C229.626 271.674 229.917 271.305 230.002 270.938L230.019 270.93V282.533C229.988 282.973 229.659 283.431 229.033 283.792L158.886 324.379L157.558 325.146L157.35 325.266L145.237 332.26L113.782 350.424L113.078 350.83L102.954 356.677C102.295 357.058 101.454 357.253 100.654 357.253Z"
              fill="url(#paint2_linear_101_2)"
            />
            <path
              d="M100.655 345.503C100.652 345.503 100.649 345.503 100.646 345.503C100.01 345.501 99.4029 345.377 98.9391 345.125C98.9321 345.121 98.9264 345.118 98.9194 345.114C98.9095 345.108 98.8996 345.102 98.8898 345.097L37.999 309.934C37.9963 309.933 37.9929 309.93 37.9897 309.929C37.591 309.696 37.3713 309.396 37.3152 309.077L37.3097 309.074C37.3053 309.049 37.3019 309.024 37.2998 308.998V308.832C37.3377 308.396 37.6725 307.945 38.2909 307.588L164.213 235.073C164.871 234.694 165.713 234.5 166.511 234.5C167.155 234.5 167.77 234.626 168.236 234.883C168.25 234.892 168.263 234.899 168.276 234.906L229.167 270.068C229.639 270.34 229.87 270.705 229.87 271.087C229.87 271.132 229.867 271.177 229.86 271.221C229.856 271.251 229.851 271.28 229.844 271.31L229.831 271.319C229.743 271.682 229.463 272.049 228.977 272.353L228.974 272.355C228.974 272.355 228.971 272.358 228.968 272.359C228.965 272.36 228.962 272.363 228.958 272.365C228.931 272.382 228.903 272.399 228.875 272.414L102.954 344.929C102.941 344.935 102.93 344.942 102.919 344.949C102.267 345.314 101.443 345.503 100.66 345.503H100.655ZM166.498 238.665C165.79 238.665 165.043 238.837 164.46 239.174L45.3887 307.731C44.3227 308.347 44.2071 309.277 45.1298 309.81L99.104 340.98C99.5227 341.221 100.082 341.339 100.669 341.339C101.376 341.339 102.124 341.167 102.706 340.83L221.778 272.272C222.843 271.655 222.959 270.725 222.035 270.192L168.063 239.024C167.644 238.782 167.085 238.665 166.498 238.665Z"
              fill="url(#paint3_linear_101_2)"
            />
            <path
              d="M100.668 341.339C100.082 341.339 99.5224 341.22 99.1038 340.979L45.1296 309.81C44.2068 309.277 44.3224 308.347 45.3884 307.73L164.05 239.066C164.633 238.729 165.38 238.557 166.088 238.557C166.674 238.557 167.234 238.674 167.653 238.917L221.625 270.085C222.549 270.618 222.433 271.548 221.367 272.165L102.705 340.83C102.123 341.167 101.376 341.339 100.668 341.339ZM166.08 241.197C165.428 241.197 164.743 241.356 164.208 241.665L49.8901 307.822C48.9104 308.387 48.8041 309.242 49.6519 309.732L99.2391 338.368C99.6239 338.59 100.137 338.698 100.677 338.698C101.327 338.698 102.013 338.54 102.549 338.23L216.866 272.074C217.846 271.508 217.952 270.653 217.105 270.162L167.516 241.528C167.133 241.305 166.618 241.197 166.08 241.197Z"
              fill="#808E88"
            />
            <path
              d="M100.676 338.698C100.136 338.698 99.6229 338.59 99.2381 338.368L49.6509 309.733C48.8031 309.242 48.9094 308.388 49.8891 307.822L164.607 241.428C165.143 241.12 165.828 240.96 166.479 240.96C167.018 240.96 167.532 241.069 167.916 241.292L217.504 269.926C218.352 270.416 218.246 271.271 217.266 271.838L102.548 338.23C102.012 338.54 101.326 338.698 100.676 338.698Z"
              fill="#AEC7B9"
            />
          </g>
          <g className="landing_hero__modem landing_hero__modem--4">
            <path
              d="M199.248 272.369V163.491L191.775 159.505L172.964 148.235C172.125 147.75 170.656 147.81 169.686 148.371L165.994 150.25L150.631 150.261L150.634 259.661H150.642C150.657 259.957 150.833 260.237 151.198 260.448L185.298 279.863C186.139 280.349 187.608 280.287 188.578 279.727L198.452 273.385C198.958 273.094 199.223 272.725 199.248 272.369Z"
              fill="url(#paint4_linear_101_2)"
            />
            <path
              d="M185.299 201.632L188.288 279.863C187.052 280.307 186.399 280.296 185.299 279.863L185.299 201.632Z"
              fill="url(#paint5_linear_101_2)"
            />
            <path
              d="M159.901 202.682L165.087 205.646C165.828 206.14 165.581 206.634 165.581 206.634L164.593 207.622L163.111 206.758C162.865 206.634 163.111 207.375 163.111 207.375L164.593 211.697C164.593 211.697 168.174 206.511 168.421 206.017C168.791 205.523 168.297 205.276 168.297 205.276L157.062 198.731C156.568 198.484 156.938 199.348 156.938 199.348L166.569 225.776L167.556 224.788V223.923L159.901 202.682Z"
              fill="#35BE70"
            />
            <path
              d="M167.804 215.526L170.643 211.821C170.643 211.821 170.89 211.327 170.52 211.08L168.668 209.969L165.581 214.414L168.668 222.565L169.532 221.454V220.713L167.804 216.02V215.526Z"
              fill="#35BE70"
            />
            <path
              d="M176.569 210.092L170.766 206.758L170.395 207.252L170.025 207.746C169.654 208.363 170.148 208.61 170.148 208.61L173.358 210.463C173.976 210.833 173.605 211.327 173.605 211.327L170.025 216.514L169.901 217.378L170.766 219.601C170.766 219.601 176.322 211.451 176.815 210.957C177.309 210.463 176.569 210.092 176.569 210.092Z"
              fill="#35BE70"
            />
            <path
              d="M185.797 170.984L151.199 151.555C150.358 151.07 150.464 150.222 151.434 149.661L160.887 143.578C161.858 143.018 163.326 142.957 164.166 143.443L198.765 162.871C199.605 163.356 199.499 164.203 198.529 164.764L189.076 170.847C188.106 171.408 186.637 171.47 185.797 170.984Z"
              fill="url(#paint6_linear_101_2)"
            />
          </g>
          <g className="landing_hero__modem landing_hero__modem--3">
            <path
              d="M169.615 287.188V178.31L162.142 174.324L143.332 163.054C142.492 162.569 141.024 162.63 140.053 163.19L136.362 165.069L120.999 165.08L121.002 274.48H121.01C121.024 274.776 121.2 275.056 121.566 275.267L155.666 294.682C156.507 295.168 157.975 295.106 158.946 294.546L168.82 288.204C169.325 287.913 169.59 287.544 169.615 287.188Z"
              fill="url(#paint7_linear_101_2)"
            />
            <path
              d="M155.667 216.451L158.656 294.682C157.419 295.126 156.767 295.115 155.667 294.682L155.667 216.451Z"
              fill="url(#paint8_linear_101_2)"
            />
            <path
              d="M130.269 217.502L135.455 220.465C136.195 220.959 135.948 221.453 135.948 221.453L134.961 222.441L133.479 221.577C133.232 221.453 133.479 222.194 133.479 222.194L134.961 226.516C134.961 226.516 138.541 221.33 138.788 220.836C139.159 220.342 138.665 220.095 138.665 220.095L127.429 213.55C126.935 213.303 127.306 214.167 127.306 214.167L136.936 240.595L137.924 239.607V238.742L130.269 217.502Z"
              fill="#35BE70"
            />
            <path
              d="M138.171 230.345L141.011 226.64C141.011 226.64 141.258 226.146 140.888 225.899L139.036 224.788L135.949 229.234L139.036 237.384L139.9 236.273V235.532L138.171 230.839V230.345Z"
              fill="#35BE70"
            />
            <path
              d="M146.936 224.911L141.133 221.577L140.763 222.071L140.392 222.565C140.022 223.182 140.516 223.429 140.516 223.429L143.726 225.282C144.343 225.652 143.973 226.146 143.973 226.146L140.392 231.333L140.269 232.197L141.133 234.42C141.133 234.42 146.689 226.27 147.183 225.776C147.677 225.282 146.936 224.911 146.936 224.911Z"
              fill="#35BE70"
            />
            <path
              d="M156.165 185.803L121.566 166.375C120.726 165.889 120.831 165.041 121.802 164.48L131.255 158.397C132.225 157.837 133.694 157.776 134.534 158.262L169.132 177.69C169.973 178.175 169.867 179.022 168.897 179.583L159.444 185.666C158.474 186.227 157.005 186.289 156.165 185.803Z"
              fill="url(#paint9_linear_101_2)"
            />
          </g>
          <g className="landing_hero__modem landing_hero__modem--2">
            <path
              d="M143.687 304.477V195.599L136.214 191.612L117.403 180.343C116.564 179.858 115.095 179.918 114.125 180.479L110.434 182.358L95.0706 182.369L95.0733 291.769H95.0817C95.0959 292.065 95.2719 292.345 95.6375 292.556L129.738 311.971C130.578 312.457 132.047 312.395 133.017 311.835L142.892 305.493C143.397 305.202 143.662 304.833 143.687 304.477Z"
              fill="url(#paint10_linear_101_2)"
            />
            <path
              d="M129.738 233.74L132.727 311.971C131.491 312.415 130.838 312.403 129.738 311.971L129.738 233.74Z"
              fill="url(#paint11_linear_101_2)"
            />
            <path
              d="M104.34 234.791L109.526 237.754C110.267 238.248 110.02 238.742 110.02 238.742L109.032 239.73L107.551 238.866C107.304 238.742 107.551 239.483 107.551 239.483L109.032 243.806C109.032 243.806 112.613 238.619 112.86 238.125C113.23 237.631 112.736 237.384 112.736 237.384L101.501 230.839C101.007 230.592 101.377 231.456 101.377 231.456L111.008 257.884L111.995 256.896V256.031L104.34 234.791Z"
              fill="#35BE70"
            />
            <path
              d="M112.243 247.634L115.083 243.929C115.083 243.929 115.33 243.435 114.959 243.188L113.107 242.077L110.021 246.522L113.107 254.673L113.971 253.561V252.821L112.243 248.128V247.634Z"
              fill="#35BE70"
            />
            <path
              d="M121.008 242.2L115.205 238.866L114.834 239.36L114.464 239.854C114.094 240.471 114.587 240.718 114.587 240.718L117.798 242.571C118.415 242.941 118.045 243.435 118.045 243.435L114.464 248.622L114.34 249.486L115.205 251.709C115.205 251.709 120.761 243.558 121.255 243.064C121.749 242.571 121.008 242.2 121.008 242.2Z"
              fill="#35BE70"
            />
            <path
              d="M130.236 203.092L95.6378 183.664C94.7976 183.178 94.9029 182.33 95.8734 181.769L105.327 175.686C106.297 175.126 107.766 175.065 108.605 175.551L143.204 194.979C144.044 195.464 143.939 196.311 142.968 196.872L133.516 202.955C132.545 203.516 131.077 203.578 130.236 203.092Z"
              fill="url(#paint12_linear_101_2)"
            />
          </g>
          <g className="landing_hero__modem landing_hero__modem--1">
            <path
              d="M114.054 319.296V210.418L106.582 206.432L87.771 195.162C86.9314 194.677 85.4628 194.737 84.4925 195.298L80.8013 197.177L65.4382 197.188L65.441 306.588H65.4494C65.4636 306.884 65.6396 307.164 66.0052 307.375L100.105 326.79C100.946 327.276 102.414 327.214 103.385 326.654L113.259 320.312C113.764 320.021 114.029 319.652 114.054 319.296Z"
              fill="url(#paint13_linear_101_2)"
            />
            <path
              d="M100.106 248.559L103.095 326.79C101.859 327.234 101.206 327.223 100.106 326.79L100.106 248.559Z"
              fill="url(#paint14_linear_101_2)"
            />
            <path
              d="M74.7082 249.61L79.8938 252.573C80.6346 253.067 80.3877 253.561 80.3877 253.561L79.3999 254.549L77.9183 253.685C77.6714 253.561 77.9183 254.302 77.9183 254.302L79.3999 258.625C79.3999 258.625 82.9805 253.438 83.2275 252.944C83.5979 252.45 83.104 252.203 83.104 252.203L71.8684 245.658C71.3745 245.411 71.7449 246.275 71.7449 246.275L81.3754 272.703L82.3632 271.715V270.85L74.7082 249.61Z"
              fill="#35BE70"
            />
            <path
              d="M82.6106 262.453L85.4504 258.748C85.4504 258.748 85.6973 258.254 85.3269 258.007L83.4749 256.896L80.3882 261.341L83.4749 269.492L84.3392 268.381V267.64L82.6106 262.947V262.453Z"
              fill="#35BE70"
            />
            <path
              d="M91.3754 257.019L85.5724 253.685L85.202 254.179L84.8316 254.673C84.4612 255.29 84.9551 255.537 84.9551 255.537L88.1652 257.39C88.7826 257.76 88.4122 258.254 88.4122 258.254L84.8316 263.441L84.7081 264.305L85.5724 266.528C85.5724 266.528 91.1285 258.378 91.6223 257.884C92.1162 257.39 91.3754 257.019 91.3754 257.019Z"
              fill="#35BE70"
            />
            <path
              d="M100.604 217.911L66.0055 198.483C65.1652 197.997 65.2706 197.149 66.241 196.588L75.6943 190.505C76.6646 189.945 78.1332 189.884 78.9728 190.37L113.571 209.798C114.412 210.283 114.306 211.13 113.336 211.691L103.883 217.774C102.913 218.335 101.444 218.397 100.604 217.911Z"
              fill="url(#paint15_linear_101_2)"
            />
          </g>
        </g>
        <g className="landing_hero__processors">
          <g className="landing_hero__processor landing_hero__processor--1">
            <path
              d="M525.289 352.992C524.628 352.992 523.997 352.858 523.524 352.586L510.102 344.834L509.398 344.428L509.397 344.426L480.946 327.998L468.626 320.883L467.298 320.116L465.827 319.268L465.123 318.86H465.121L462.633 317.423C462.181 317.161 461.962 316.813 461.945 316.448H461.934L461.93 304.669C461.931 304.69 461.933 304.711 461.934 304.733V304.807L461.944 304.813C461.999 305.13 462.22 305.429 462.615 305.662C462.615 305.662 462.615 305.663 462.616 305.663C462.619 305.665 462.62 305.666 462.623 305.667C462.627 305.669 462.63 305.672 462.633 305.673L523.524 340.835C523.536 340.842 523.548 340.849 523.56 340.856C523.567 340.859 523.572 340.863 523.579 340.866C523.581 340.868 523.582 340.868 523.584 340.869C523.593 340.873 523.603 340.879 523.612 340.883C523.615 340.885 523.616 340.886 523.617 340.887C523.629 340.892 523.639 340.897 523.65 340.903C524.033 341.095 524.505 341.203 525.006 341.233C525.099 341.238 525.193 341.241 525.288 341.241H525.289C526.087 341.241 526.93 341.047 527.588 340.667L587.893 305.842C587.911 305.832 587.93 305.821 587.948 305.81C587.948 305.81 587.949 305.81 587.949 305.808C587.954 305.807 587.957 305.806 587.959 305.803C587.962 305.801 587.964 305.801 587.966 305.8C587.968 305.799 587.969 305.797 587.971 305.797C588.475 305.486 588.776 305.11 588.862 304.738L588.878 304.73V316.334C588.85 316.737 588.571 317.156 588.043 317.501C588.043 317.501 588.043 317.501 588.041 317.501C587.995 317.532 587.945 317.563 587.893 317.593L587.342 317.91L583.52 320.118L582.191 320.885L569.871 327.999L543.775 343.069L543.774 343.07L543.069 343.476L527.588 352.416C526.93 352.797 526.087 352.992 525.289 352.992Z"
              fill="url(#paint16_linear_101_2)"
            />
            <path
              d="M525.288 341.241C525.194 341.241 525.1 341.239 525.006 341.233C524.506 341.203 524.034 341.095 523.65 340.903C523.639 340.897 523.629 340.892 523.618 340.888C523.617 340.886 523.615 340.885 523.612 340.883C523.604 340.879 523.594 340.873 523.584 340.869C523.583 340.868 523.581 340.868 523.58 340.866C523.573 340.864 523.567 340.859 523.56 340.857C523.549 340.849 523.536 340.842 523.525 340.835L462.634 305.673C462.631 305.672 462.628 305.669 462.624 305.667C462.621 305.666 462.62 305.665 462.617 305.663C462.615 305.663 462.615 305.662 462.615 305.662C462.222 305.429 462.006 305.133 461.95 304.816L461.944 304.813C461.94 304.786 461.936 304.76 461.935 304.733V304.575C461.971 304.138 462.305 303.685 462.926 303.327L523.232 268.502C523.889 268.122 524.732 267.928 525.529 267.928C525.933 267.928 526.325 267.977 526.676 268.079C526.901 268.142 527.11 268.228 527.294 268.334L588.186 303.496C588.654 303.767 588.885 304.126 588.889 304.506V304.525C588.888 304.566 588.885 304.607 588.879 304.65C588.875 304.679 588.869 304.709 588.862 304.738L588.85 304.745C588.761 305.116 588.472 305.488 587.971 305.797C587.97 305.797 587.968 305.799 587.967 305.8C587.964 305.801 587.963 305.801 587.96 305.803C587.957 305.806 587.954 305.807 587.95 305.808C587.95 305.81 587.949 305.81 587.949 305.81C587.93 305.821 587.912 305.832 587.894 305.842L527.589 340.668C526.931 341.047 526.088 341.241 525.288 341.241ZM525.517 272.093C524.808 272.093 524.062 272.265 523.478 272.602L470.023 303.469C468.957 304.086 468.842 305.016 469.765 305.549L523.739 336.718C524.158 336.96 524.716 337.078 525.303 337.078C526.01 337.078 526.757 336.906 527.341 336.569L580.796 305.7C581.862 305.085 581.977 304.153 581.054 303.62L527.08 272.452C526.663 272.211 526.103 272.093 525.517 272.093Z"
              fill="url(#paint17_linear_101_2)"
            />
            <path
              d="M525.302 337.078C524.716 337.078 524.158 336.959 523.739 336.718L469.765 305.549C468.841 305.016 468.957 304.086 470.023 303.469L523.478 272.602C524.062 272.265 524.807 272.093 525.516 272.093C526.103 272.093 526.662 272.211 527.08 272.452L581.054 303.62C581.977 304.153 581.862 305.085 580.796 305.7L527.341 336.569C526.757 336.906 526.01 337.078 525.302 337.078ZM525.507 274.732C524.857 274.732 524.172 274.892 523.636 275.2L474.524 303.561C473.545 304.126 473.438 304.981 474.287 305.471L523.874 334.107C524.259 334.329 524.772 334.437 525.311 334.437C525.962 334.437 526.648 334.279 527.184 333.969L576.295 305.61C577.275 305.044 577.38 304.188 576.533 303.698L526.944 275.064C526.56 274.841 526.046 274.732 525.507 274.732Z"
              fill="#B7CDC4"
            />
            <path
              d="M525.311 334.437C524.773 334.437 524.26 334.328 523.875 334.107L474.288 305.471C473.439 304.981 473.546 304.126 474.524 303.561L523.637 275.2C524.172 274.891 524.857 274.732 525.507 274.732C526.047 274.732 526.56 274.841 526.945 275.063L576.534 303.698C577.381 304.188 577.275 305.044 576.295 305.61L527.185 333.969C526.649 334.279 525.963 334.437 525.311 334.437ZM524.766 304.527L521.6 306.354L530.73 311.627L533.896 309.798L524.766 304.527ZM531.882 300.418L526.082 303.767L529.248 305.595L535.048 302.247L531.882 300.418ZM519.788 301.652L516.621 303.479L519.788 305.308L522.954 303.481L519.788 301.652ZM521.638 297.543L518.472 299.372L524.271 302.719L527.437 300.892L521.638 297.543Z"
              fill="#AEC7B9"
            />
          </g>
          <g className="landing_hero__processor landing_hero__processor--2">
            <path
              d="M588.878 290.301V278.553L569.745 278.566L527.294 254.051C526.252 253.451 524.434 253.526 523.231 254.221L480.968 278.625L461.93 278.638L461.934 290.415H461.945C461.962 290.782 462.181 291.128 462.633 291.391L523.524 326.553C524.566 327.155 526.386 327.079 527.588 326.385L587.893 291.56C588.519 291.199 588.847 290.742 588.878 290.301Z"
              fill="url(#paint18_linear_101_2)"
            />
            <path
              d="M523.525 314.804L462.634 279.642C461.592 279.04 461.723 277.989 462.926 277.295L523.232 242.47C524.434 241.776 526.254 241.7 527.295 242.302L588.186 277.465C589.228 278.067 589.096 279.117 587.894 279.811L527.589 314.635C526.387 315.33 524.567 315.406 523.525 314.804Z"
              fill="url(#paint19_linear_101_2)"
            />
            <path
              d="M523.739 310.685L469.765 279.518C468.841 278.985 468.957 278.053 470.023 277.438L523.478 246.569C524.544 245.954 526.156 245.886 527.08 246.419L581.054 277.587C581.977 278.122 581.862 279.052 580.796 279.668L527.341 310.536C526.275 311.152 524.662 311.218 523.739 310.685Z"
              fill="#AAD5BC"
            />
            <path
              d="M523.875 308.074L474.288 279.438C473.439 278.949 473.546 278.093 474.524 277.528L523.637 249.169C524.615 248.603 526.096 248.541 526.945 249.03L576.532 277.666C577.381 278.157 577.275 279.013 576.295 279.577L527.185 307.937C526.205 308.503 524.723 308.565 523.875 308.074Z"
              fill="#AEC7B9"
            />

            <path
              d="M523.505 269.868L528.69 272.832C529.431 273.326 528.814 273.573 528.814 273.573L526.962 274.19L525.48 273.326C525.233 273.202 525.233 273.696 525.233 273.696L524.863 277.031C524.863 277.031 532.271 274.067 533.012 273.943C533.629 273.696 533.259 273.449 533.259 273.449L521.776 266.657C521.406 266.41 521.282 267.151 521.282 267.151L519.801 286.91L521.653 286.416L522.147 285.799L523.505 269.868Z"
              fill="white"
            />
            <path
              d="M527.086 280.118L532.765 278.142C532.765 278.142 533.383 277.895 532.889 277.648L531.037 276.537L524.74 279.007L524.369 285.181L526.098 284.564L526.468 284.07L526.592 280.612L527.086 280.118Z"
              fill="white"
            />
            <path
              d="M541.408 278.019L535.605 274.684L534.988 274.931L534.123 275.302C533.382 275.549 533.753 275.796 533.753 275.796L537.087 277.648C537.704 278.019 536.963 278.266 536.963 278.266L529.431 281.229L528.814 281.847L528.691 283.576C528.691 283.576 540.544 279.007 541.408 278.76C542.149 278.389 541.408 278.019 541.408 278.019Z"
              fill="white"
            />
          </g>
        </g>
        <g className="landing_hero__laptop">
          <path
            d="M504.502 268.362L330.268 167.738C328.242 166.578 326.216 166.288 324.48 166.868H324.19L317.534 169.478L323.322 172.378V172.668L292.354 312.73C290.907 319.109 293.801 326.649 298.721 329.549L468.902 427.853L468.324 435.102L475.27 432.492C477.585 431.333 479.322 429.013 480.19 425.533L510.869 285.471C512.316 278.802 509.422 271.262 504.502 268.362Z"
            fill="#BAD5C9"
          />
          <path
            d="M504.501 268.362L330.268 167.738C328.242 166.578 326.216 166.288 324.48 166.868H324.19L317.534 169.478L323.322 172.378V172.668L302.194 268.942L387.574 335.348L510.29 275.612C508.843 272.422 506.817 269.812 504.501 268.362Z"
            fill="#D1E2D9"
          />
          <path
            d="M497.844 288.371L511.157 282.571C511.447 277.351 509.131 272.132 505.658 269.232L484.53 278.221L497.844 288.371Z"
            fill="#A5BCB2"
          />
          <path
            d="M462.245 434.522L288.012 333.898C283.091 330.998 280.197 323.459 281.644 317.079L312.323 176.727C313.77 170.348 318.98 167.448 323.9 170.058L498.133 270.972C503.054 273.872 505.948 281.411 504.501 287.791L473.822 428.142C472.375 434.522 467.165 437.422 462.245 434.522Z"
            fill="#ECF3F0"
          />
          <path
            d="M499.869 270.392L325.636 169.478C323.321 168.028 320.716 168.028 318.69 169.188C320.426 168.898 322.163 169.188 323.9 170.058L498.133 270.972C503.053 273.872 505.947 281.411 504.5 287.791L473.821 428.143C472.953 431.622 471.216 433.942 469.19 435.102C472.085 434.522 474.689 431.912 475.558 427.563L506.237 287.211C507.684 280.831 504.79 273.002 499.869 270.392Z"
            fill="white"
          />
          <path
            d="M458.482 424.952L294.668 330.128C290.038 327.518 287.433 320.559 288.88 314.759L317.244 185.427C318.401 179.627 323.321 176.727 327.663 179.337L491.477 274.161C496.108 276.771 498.712 283.731 497.265 289.53L468.902 418.863C467.744 424.953 462.824 427.562 458.482 424.952Z"
            fill="white"
          />
          <path
            className="landing_hero__laptop-screen"
            d="M458.482 424.952L294.668 330.128C290.038 327.518 287.433 320.559 288.88 314.759L317.244 185.427C318.401 179.627 323.321 176.727 327.663 179.337L491.477 274.161C496.108 276.771 498.712 283.731 497.265 289.53L468.902 418.863C467.744 424.953 462.824 427.562 458.482 424.952Z"
            fill="#C6D3CC"
          />
          <path
            d="M459.929 424.373L296.115 329.548C291.484 326.939 288.879 319.979 290.326 314.179L318.69 184.847C319.269 181.947 321.005 179.627 322.742 178.467C320.137 179.047 318.111 181.657 317.243 185.427L288.879 314.759C287.722 320.559 290.326 327.519 294.668 330.128L458.482 424.953C460.797 426.113 463.113 426.113 464.849 425.243C463.402 425.533 461.665 425.533 459.929 424.373Z"
            fill="#99BFAF"
          />
          <path
            d="M464.561 439.162L440.828 435.972L287.144 346.947C282.224 344.047 273.541 344.337 268.042 347.817L158.929 410.743L144.458 408.713V416.833C144.458 418.863 145.326 420.603 147.641 421.763L321.875 522.677C326.795 525.577 335.478 525.287 340.977 521.807L459.641 453.081C462.824 451.341 464.561 448.731 464.271 446.701V439.162H464.561Z"
            fill="#D1E2D9"
          />
          <path
            d="M349.081 382.905L338.082 376.525H217.971L158.929 410.743L144.458 408.713V416.833C144.458 418.863 145.326 420.603 147.641 421.763L321.875 522.677C324.479 524.127 328.242 524.707 331.715 524.417L349.081 382.905Z"
            fill="#E2EBE6"
          />
          <path
            d="M150.825 409.583L144.458 408.713V416.833C144.458 418.863 145.326 420.603 147.641 421.763L150.825 423.503V409.583Z"
            fill="#A5BCB2"
          />
          <path
            d="M323.901 523.547C328.532 525.287 335.189 524.997 340.109 522.387V504.118H323.901V523.547Z"
            fill="#A5BCB2"
          />
          <path
            d="M322.164 514.558L147.641 413.934C142.721 411.034 143.3 406.104 149.088 402.914L267.752 334.188C273.541 330.998 281.934 330.418 286.854 333.318L461.088 434.232C466.008 437.132 465.429 442.062 459.64 445.252L340.977 513.978C335.478 517.168 327.084 517.457 322.164 514.558Z"
            fill="#ECF3F0"
          />
          <path
            d="M459.93 442.351L341.266 511.077C335.477 514.267 327.084 514.847 322.164 511.947L147.641 411.033C145.905 410.163 145.036 409.003 144.458 407.553C143.589 409.873 144.747 412.193 147.641 413.933L322.164 514.557C327.084 517.457 335.767 517.167 341.266 513.687L459.93 444.961C463.692 442.641 465.139 439.742 464.271 437.132C463.692 439.162 462.245 440.902 459.93 442.351Z"
            fill="white"
          />
          <path
            d="M222.023 380.585L213.919 375.946C213.34 375.656 213.34 375.076 214.208 374.496L223.47 368.986C224.338 368.696 225.206 368.406 226.075 368.986L233.889 373.626C234.468 373.916 234.468 374.496 233.6 375.076L224.338 380.585C223.759 380.875 222.602 380.875 222.023 380.585Z"
            fill="#808E88"
          />
          <path
            d="M234.179 387.545L226.364 382.905C225.786 382.615 225.786 382.035 226.654 381.455L235.915 375.945C236.784 375.655 237.652 375.365 238.52 375.945L246.335 380.585C246.913 380.875 246.913 381.455 246.045 382.035L236.784 387.545C235.915 387.835 234.758 387.835 234.179 387.545Z"
            fill="#808E88"
          />
          <path
            d="M246.334 394.504L238.52 389.864C237.941 389.575 237.941 388.995 238.809 388.415L248.071 382.905C248.939 382.615 249.807 382.325 250.675 382.905L258.49 387.545C259.069 387.835 259.069 388.415 258.2 388.995L248.649 394.504C248.071 394.794 246.913 395.084 246.334 394.504Z"
            fill="#808E88"
          />
          <path
            d="M263.12 388.705L255.306 384.065C254.727 383.775 254.727 383.195 255.595 382.615L263.12 378.265C263.989 377.975 264.857 377.685 265.725 378.265L273.54 382.905C274.119 383.195 274.119 383.775 273.25 384.355L265.436 388.995C264.857 388.995 263.699 389.285 263.12 388.705Z"
            fill="#808E88"
          />
          <path
            d="M275.277 395.954L267.462 391.315C266.883 391.025 266.883 390.445 267.752 389.865L275.566 385.225C276.434 384.935 277.303 384.645 278.171 385.225L285.985 389.865C286.564 390.155 286.564 390.735 285.696 391.315L277.592 395.664C277.013 396.244 275.856 396.244 275.277 395.954Z"
            fill="#808E88"
          />
          <path
            d="M287.432 402.914L279.617 398.274C279.038 397.984 279.038 397.404 279.907 396.824L287.721 392.184C288.589 391.894 289.458 391.604 290.326 392.184L298.14 396.824C298.719 397.114 298.719 397.694 297.851 398.274L290.037 402.914C289.168 403.204 288.011 403.204 287.432 402.914Z"
            fill="#808E88"
          />
          <path
            d="M299.588 409.874L291.774 405.234C291.195 404.944 291.195 404.364 292.063 403.784L299.877 399.144C300.746 398.854 301.614 398.564 302.482 399.144L310.297 403.784C310.876 404.074 310.876 404.654 310.007 405.234L302.193 409.874C301.325 410.164 300.167 410.164 299.588 409.874Z"
            fill="#808E88"
          />
          <path
            d="M311.744 416.833L303.93 412.193C303.351 411.903 303.351 411.323 304.219 410.743L312.034 406.104C312.902 405.814 313.77 405.524 314.639 406.104L322.453 410.743C323.032 411.033 323.032 411.613 322.164 412.193L314.349 416.833C313.481 417.413 312.323 417.413 311.744 416.833Z"
            fill="#808E88"
          />
          <path
            d="M323.901 424.083L316.086 419.443C315.507 419.153 315.507 418.573 316.376 417.993L324.19 413.353C325.058 413.063 325.927 412.773 326.795 413.353L334.609 417.993C335.188 418.283 335.188 418.863 334.32 419.443L326.506 424.083C325.637 424.373 324.48 424.373 323.901 424.083Z"
            fill="#808E88"
          />
          <path
            d="M336.056 431.042L328.241 426.403C327.662 426.113 327.662 425.533 328.531 424.953L336.345 420.313C337.213 420.023 338.082 419.733 338.95 420.313L346.764 424.953C347.343 425.243 347.343 425.823 346.475 426.403L338.661 431.042C337.792 431.332 336.635 431.332 336.056 431.042Z"
            fill="#808E88"
          />
          <path
            d="M348.212 438.002L340.398 433.362C339.819 433.072 339.819 432.492 340.687 431.912L348.501 427.273C349.37 426.983 350.238 426.693 351.106 427.273L358.921 431.912C359.5 432.202 359.5 432.782 358.631 433.362L350.817 438.002C349.949 438.292 349.08 438.582 348.212 438.002Z"
            fill="#808E88"
          />
          <path
            d="M360.367 445.251L352.553 440.612C351.974 440.322 351.974 439.742 352.842 439.162L360.656 434.522C361.525 434.232 362.393 433.942 363.261 434.522L371.076 439.162C371.655 439.452 371.655 440.032 370.786 440.612L362.972 444.961C362.104 445.541 361.235 445.541 360.367 445.251Z"
            fill="#808E88"
          />
          <path
            d="M372.524 452.211L364.709 447.571C364.13 447.281 364.13 446.701 364.999 446.121L372.813 441.482C373.681 441.192 374.55 440.902 375.418 441.482L383.232 446.121C383.811 446.411 383.811 446.991 382.943 447.571L375.128 452.211C374.26 452.501 373.392 452.501 372.524 452.211Z"
            fill="#808E88"
          />
          <path
            d="M281.066 385.515L273.251 380.875C272.672 380.585 272.672 380.005 273.54 379.425L281.355 374.786C282.223 374.496 283.091 374.206 283.96 374.786L291.774 379.425C292.353 379.715 292.353 380.295 291.485 380.875L283.381 385.225C282.802 385.805 281.644 385.805 281.066 385.515Z"
            fill="#808E88"
          />
          <path
            d="M268.62 378.265L260.805 373.626C260.226 373.336 260.226 372.756 261.095 372.466L268.909 367.826C269.777 367.536 270.646 367.246 271.514 367.826L279.328 372.466C279.907 372.756 279.907 373.336 279.039 373.916L271.225 378.265C270.356 378.555 269.199 378.555 268.62 378.265Z"
            fill="#808E88"
          />
          <path
            d="M256.175 371.016L239.099 361.156C238.521 360.866 238.521 360.286 239.389 359.706L247.203 355.067C248.072 354.777 248.94 354.487 249.808 355.067L266.884 364.926C267.463 365.216 267.463 365.796 266.595 366.376L258.78 371.016C257.912 371.596 257.044 371.596 256.175 371.016Z"
            fill="#808E88"
          />
          <path
            d="M264.858 362.316L250.965 354.487C250.386 354.197 250.386 353.617 251.255 353.037L259.069 348.397C259.937 348.107 260.806 347.817 261.674 348.397L275.566 356.227C276.145 356.517 276.145 357.097 275.277 357.677L267.462 362.316C266.594 362.896 265.436 362.896 264.858 362.316Z"
            fill="#808E88"
          />
          <path
            d="M293.222 392.475L285.407 387.835C284.828 387.545 284.828 386.965 285.697 386.385L293.511 381.745C294.379 381.455 295.248 381.165 296.116 381.745L303.93 386.385C304.509 386.675 304.509 387.255 303.641 387.835L295.827 392.475C294.958 392.765 293.801 392.765 293.222 392.475Z"
            fill="#808E88"
          />
          <path
            d="M305.377 399.434L297.562 394.794C296.984 394.504 296.984 393.924 297.852 393.344L305.666 388.704C306.534 388.414 307.403 388.125 308.271 388.704L316.085 393.344C316.664 393.634 316.664 394.214 315.796 394.794L307.982 399.434C307.113 400.014 305.956 400.014 305.377 399.434Z"
            fill="#808E88"
          />
          <path
            d="M317.533 406.684L309.719 402.044C309.14 401.754 309.14 401.174 310.008 400.594L317.822 395.954C318.691 395.664 319.559 395.374 320.427 395.954L328.242 400.594C328.821 400.884 328.821 401.464 327.952 402.044L320.138 406.684C319.27 406.974 318.112 406.974 317.533 406.684Z"
            fill="#808E88"
          />
          <path
            d="M329.688 413.644L321.874 409.004C321.295 408.714 321.295 408.134 322.163 407.554L329.978 402.914C330.846 402.624 331.714 402.334 332.583 402.914L340.397 407.554C340.976 407.844 340.976 408.424 340.108 409.004L332.293 413.644C331.425 413.934 330.267 413.934 329.688 413.644Z"
            fill="#808E88"
          />
          <path
            d="M341.845 420.603L334.03 415.963C333.451 415.673 333.451 415.093 334.32 414.513L342.134 409.874C343.002 409.584 343.871 409.294 344.739 409.874L352.553 414.513C353.132 414.803 353.132 415.383 352.264 415.963L344.449 420.603C343.581 420.893 342.423 421.183 341.845 420.603Z"
            fill="#808E88"
          />
          <path
            d="M354.001 427.852L346.186 423.213C345.608 422.923 345.608 422.343 346.476 421.763L354.29 417.123C355.159 416.833 356.027 416.543 356.895 417.123L364.42 421.763C364.999 422.053 364.999 422.633 364.131 423.213L356.606 427.562C355.737 428.142 354.58 428.142 354.001 427.852Z"
            fill="#808E88"
          />
          <path
            d="M366.156 434.812L358.341 430.172C357.763 429.882 357.763 429.302 358.631 428.722L366.445 424.083C367.314 423.793 368.182 423.503 369.05 424.083L376.865 428.722C377.443 429.012 377.443 429.592 376.575 430.172L368.761 434.812C367.892 435.102 366.735 435.102 366.156 434.812Z"
            fill="#808E88"
          />
          <path
            d="M378.312 441.772L370.498 437.132C369.919 436.842 369.919 436.262 370.787 435.682L378.602 431.042C379.47 430.752 380.338 430.462 381.206 431.042L389.021 435.682C389.6 435.972 389.6 436.552 388.731 437.132L380.917 441.772C380.049 442.062 379.18 442.062 378.312 441.772Z"
            fill="#808E88"
          />
          <path
            d="M390.467 448.731L382.653 444.091C382.074 443.801 382.074 443.222 382.942 442.642L390.757 438.002C391.625 437.712 392.493 437.422 393.362 438.002L401.176 442.642C401.755 442.932 401.755 443.512 400.887 444.091L393.072 448.731C392.204 449.311 391.336 449.311 390.467 448.731Z"
            fill="#808E88"
          />
          <path
            d="M412.175 461.491L395.098 451.631C394.52 451.341 394.52 450.761 395.388 450.181L403.202 445.542C404.071 445.252 404.939 444.962 405.807 445.542L422.883 455.401C423.462 455.691 423.462 456.271 422.594 456.851L414.779 461.491C413.911 461.781 412.753 461.781 412.175 461.491Z"
            fill="#808E88"
          />
          <path
            d="M435.907 447.571L421.436 439.162C420.857 438.872 420.857 438.292 421.725 437.712L429.54 433.072C430.408 432.782 431.276 432.492 432.144 433.072L446.616 441.482C447.194 441.772 447.194 442.352 446.326 442.932L438.512 447.571C437.643 447.861 436.486 448.151 435.907 447.571Z"
            fill="#808E88"
          />
          <path
            d="M314.638 391.025L306.534 386.675C305.955 386.385 305.955 385.805 306.824 385.225L314.638 380.585C315.506 380.295 316.375 380.005 317.243 380.585L325.057 385.225C325.636 385.515 325.636 386.095 324.768 386.675L316.954 391.315C316.375 391.315 315.217 391.605 314.638 391.025Z"
            fill="#808E88"
          />
          <path
            d="M301.904 383.775L294.09 379.135C293.511 378.845 293.511 378.265 294.379 377.685L302.194 373.046C303.062 372.756 303.93 372.466 304.799 373.046L312.613 377.685C313.192 377.975 313.192 378.555 312.324 379.135L304.509 383.775C303.641 384.355 302.773 384.355 301.904 383.775Z"
            fill="#808E88"
          />
          <path
            d="M289.459 376.815L281.644 372.175C281.065 371.885 281.065 371.306 281.934 370.726L289.748 366.086C290.616 365.796 291.485 365.506 292.353 366.086L300.167 370.726C300.746 371.016 300.746 371.595 299.878 372.175L292.063 376.525C291.195 377.105 290.327 377.105 289.459 376.815Z"
            fill="#808E88"
          />
          <path
            d="M277.013 369.566L269.199 364.926C268.62 364.636 268.62 364.056 269.488 363.477L277.302 358.837C278.171 358.547 279.039 358.257 279.907 358.837L287.722 363.477C288.301 363.767 288.301 364.346 287.432 364.926L279.618 369.566C278.75 369.856 277.592 369.856 277.013 369.566Z"
            fill="#808E88"
          />
          <path
            d="M326.795 398.274L318.98 393.634C318.401 393.344 318.401 392.765 319.27 392.185L327.084 387.545C327.952 387.255 328.821 386.965 329.689 387.545L337.503 392.185C338.082 392.475 338.082 393.055 337.214 393.634L329.399 398.274C328.531 398.564 327.373 398.564 326.795 398.274Z"
            fill="#808E88"
          />
          <path
            d="M338.951 405.233L331.136 400.594C330.557 400.304 330.557 399.724 331.426 399.144L339.24 394.504C340.108 394.214 340.977 393.924 341.845 394.504L349.659 399.144C350.238 399.434 350.238 400.014 349.37 400.594L341.266 405.233C340.687 405.523 339.53 405.523 338.951 405.233Z"
            fill="#808E88"
          />
          <path
            d="M351.106 412.193L343.291 407.554C342.713 407.264 342.713 406.684 343.581 406.104L351.395 401.464C352.264 401.174 353.132 400.884 354 401.464L361.814 406.104C362.393 406.394 362.393 406.974 361.525 407.554L353.711 412.193C352.842 412.483 351.685 412.483 351.106 412.193Z"
            fill="#808E88"
          />
          <path
            d="M363.262 419.443L355.448 414.803C354.869 414.513 354.869 413.933 355.737 413.353L363.551 408.714C364.42 408.424 365.288 408.134 366.156 408.714L373.971 413.353C374.55 413.643 374.55 414.223 373.681 414.803L365.867 419.443C364.999 419.733 363.841 419.733 363.262 419.443Z"
            fill="#808E88"
          />
          <path
            d="M375.417 426.403L367.603 421.763C367.024 421.473 367.024 420.893 367.892 420.313L375.707 415.673C376.575 415.383 377.443 415.094 378.312 415.673L386.126 420.313C386.705 420.603 386.705 421.183 385.837 421.763L378.022 426.403C377.154 426.693 375.996 426.693 375.417 426.403Z"
            fill="#808E88"
          />
          <path
            d="M387.574 433.362L379.759 428.722C379.18 428.432 379.18 427.852 380.049 427.272L387.863 422.633C388.731 422.343 389.6 422.053 390.468 422.633L398.282 427.272C398.861 427.562 398.861 428.142 397.993 428.722L390.178 433.362C389.31 433.652 388.152 433.652 387.574 433.362Z"
            fill="#808E88"
          />
          <path
            d="M399.73 440.322L391.915 435.682C391.337 435.392 391.337 434.812 392.205 434.232L400.019 429.592C400.888 429.302 401.756 429.012 402.624 429.592L410.439 434.232C411.017 434.522 411.017 435.102 410.149 435.682L402.335 440.322C401.466 440.612 400.309 440.902 399.73 440.322Z"
            fill="#808E88"
          />
          <path
            d="M411.885 447.571L404.07 442.932C403.492 442.642 403.492 442.062 404.36 441.482L412.174 436.842C413.043 436.552 413.911 436.262 414.779 436.842L422.594 441.482C423.172 441.772 423.172 442.352 422.304 442.932L414.49 447.571C413.621 447.861 412.464 447.861 411.885 447.571Z"
            fill="#808E88"
          />
          <path
            d="M424.04 454.531L416.226 449.891C415.647 449.601 415.647 449.021 416.515 448.441L424.33 443.801C425.198 443.511 426.066 443.221 426.934 443.801L434.749 448.441C435.328 448.731 435.328 449.311 434.459 449.891L426.645 454.531C425.777 454.821 424.619 454.821 424.04 454.531Z"
            fill="#808E88"
          />
          <path
            d="M307.983 373.626L300.168 368.986C299.589 368.696 299.589 368.116 300.457 367.536L308.272 362.896C309.14 362.606 310.008 362.316 310.877 362.896L318.691 367.536C319.27 367.826 319.27 368.406 318.402 368.986L310.587 373.626C309.719 373.916 308.851 374.206 307.983 373.626Z"
            fill="#808E88"
          />
          <path
            d="M296.116 366.666L288.301 362.026C287.722 361.736 287.722 361.156 288.591 360.576L296.405 355.937C297.273 355.647 298.142 355.357 299.01 355.937L306.824 360.576C307.403 360.866 307.403 361.446 306.535 362.026L298.431 366.666C297.852 366.956 296.694 366.956 296.116 366.666Z"
            fill="#808E88"
          />
          <path
            d="M283.959 359.707L275.856 355.067C275.277 354.777 275.277 354.197 276.145 353.617L283.959 348.977C284.828 348.687 285.696 348.397 286.564 348.977L294.379 353.617C294.958 353.907 294.958 354.487 294.089 355.067L286.275 359.707C285.696 359.997 284.538 359.997 283.959 359.707Z"
            fill="#808E88"
          />
          <path
            d="M271.804 352.747L263.99 348.107C263.411 347.817 263.411 347.237 264.279 346.657L272.093 342.017C272.962 341.727 273.83 341.437 274.698 342.017L282.513 346.657C283.092 346.947 283.092 347.527 282.223 348.107L274.409 352.747C273.541 353.037 272.383 353.037 271.804 352.747Z"
            fill="#808E88"
          />
          <path
            d="M284.249 345.497L276.434 340.857C275.855 340.567 275.855 339.988 276.724 339.408L279.328 337.958C280.197 337.668 281.065 337.378 281.933 337.958L289.748 342.597C290.327 342.887 290.327 343.467 289.458 344.047L286.853 345.497C285.985 345.787 284.827 345.787 284.249 345.497Z"
            fill="#808E88"
          />
          <path
            d="M300.167 354.487L292.063 350.137C291.484 349.847 291.484 349.267 292.353 348.687L294.957 347.237C295.826 346.947 296.694 346.657 297.562 347.237L305.377 351.877C305.955 352.167 305.955 352.747 305.087 353.327L302.482 354.777C301.904 355.067 300.746 355.067 300.167 354.487Z"
            fill="#808E88"
          />
          <path
            d="M312.034 361.736L304.219 357.096C303.64 356.807 303.64 356.227 304.509 355.647L307.114 354.197C307.982 353.907 308.85 353.617 309.718 354.197L317.533 358.836C318.112 359.126 318.112 359.706 317.243 360.286L314.639 361.736C313.77 362.026 312.613 362.026 312.034 361.736Z"
            fill="#808E88"
          />
          <path
            d="M324.189 368.696L316.374 364.056C315.796 363.766 315.796 363.186 316.664 362.606L319.269 361.156C320.137 360.866 321.005 360.576 321.873 361.156L329.688 365.796C330.267 366.086 330.267 366.666 329.398 367.246L326.794 368.696C325.925 368.986 324.768 368.986 324.189 368.696Z"
            fill="#808E88"
          />
          <path
            d="M336.345 375.656L328.531 371.016C327.952 370.726 327.952 370.146 328.82 369.566L331.425 368.116C332.293 367.826 333.162 367.536 334.03 368.116L341.844 372.756C342.423 373.046 342.423 373.626 341.555 374.206L338.661 375.366C338.082 375.946 336.924 375.946 336.345 375.656Z"
            fill="#808E88"
          />
          <path
            d="M403.492 414.513L395.677 409.874C395.099 409.584 395.098 409.004 395.967 408.424L398.572 406.974C399.44 406.684 400.308 406.394 401.176 406.974L408.991 411.613C409.57 411.903 409.57 412.483 408.701 413.063L406.097 414.513C405.228 414.803 404.071 414.803 403.492 414.513Z"
            fill="#808E88"
          />
          <path
            d="M415.648 421.473L407.834 416.833C407.255 416.543 407.255 415.963 408.123 415.383L410.728 413.933C411.596 413.643 412.464 413.353 413.333 413.933L421.147 418.573C421.726 418.863 421.726 419.443 420.858 420.023L418.253 421.473C417.385 421.763 416.227 421.763 415.648 421.473Z"
            fill="#808E88"
          />
          <path
            d="M427.803 428.433L419.989 423.793C419.41 423.503 419.41 422.923 420.278 422.343L422.883 420.893C423.751 420.603 424.619 420.313 425.488 420.893L433.302 425.533C433.881 425.823 433.881 426.403 433.013 426.983L430.408 428.433C429.54 428.723 428.382 428.723 427.803 428.433Z"
            fill="#808E88"
          />
          <path
            d="M439.67 435.392L431.856 430.752C431.277 430.462 431.277 429.882 432.145 429.302L434.75 427.852C435.618 427.562 436.486 427.272 437.355 427.852L445.169 432.492C445.748 432.782 445.748 433.362 444.88 433.942L442.275 435.392C441.407 435.682 440.538 435.682 439.67 435.392Z"
            fill="#808E88"
          />
          <path
            d="M320.138 380.875L312.323 376.236C311.744 375.946 311.744 375.366 312.613 374.786L320.427 370.146C321.295 369.856 322.164 369.566 323.032 370.146L330.846 374.786C331.425 375.076 331.425 375.656 330.557 376.236L322.742 380.875C322.164 381.165 321.006 381.165 320.138 380.875Z"
            fill="#808E88"
          />
          <path
            d="M332.582 387.835L324.768 383.195C324.189 382.905 324.189 382.325 325.057 381.745L332.872 377.105C333.74 376.815 334.608 376.525 335.476 377.105L343.291 381.745C343.87 382.035 343.87 382.615 343.001 383.195L335.187 387.835C334.319 388.125 333.161 388.125 332.582 387.835Z"
            fill="#808E88"
          />
          <path
            d="M344.738 394.794L336.924 390.155C336.345 389.865 336.345 389.285 337.213 388.705L345.028 384.065C345.896 383.775 346.764 383.485 347.633 384.065L355.447 388.705C356.026 388.995 356.026 389.575 355.158 390.155L347.054 394.794C346.475 395.084 345.317 395.084 344.738 394.794Z"
            fill="#808E88"
          />
          <path
            d="M356.895 401.754L349.08 397.114C348.501 396.824 348.501 396.244 349.37 395.664L357.184 391.025C358.052 390.735 358.921 390.445 359.789 391.025L367.603 395.664C368.182 395.954 368.182 396.534 367.314 397.114L359.499 401.754C358.631 402.334 357.473 402.334 356.895 401.754Z"
            fill="#808E88"
          />
          <path
            d="M369.051 409.003L361.236 404.364C360.658 404.074 360.658 403.494 361.526 402.914L369.34 398.274C370.209 397.984 371.077 397.694 371.945 398.274L379.76 402.914C380.338 403.204 380.338 403.784 379.47 404.364L371.656 409.003C370.787 409.293 369.63 409.293 369.051 409.003Z"
            fill="#808E88"
          />
          <path
            d="M381.206 415.963L373.392 411.324C372.813 411.034 372.813 410.454 373.681 409.874L381.496 405.234C382.364 404.944 383.232 404.654 384.1 405.234L391.915 409.874C392.494 410.164 392.494 410.744 391.625 411.324L383.522 415.963C382.943 416.253 381.785 416.253 381.206 415.963Z"
            fill="#808E88"
          />
          <path
            d="M393.361 422.923L385.547 418.283C384.968 417.993 384.968 417.413 385.836 416.833L393.651 412.193C394.519 411.904 395.387 411.614 396.255 412.193L404.07 416.833C404.649 417.123 404.649 417.703 403.78 418.283L395.966 422.923C395.098 423.213 393.94 423.503 393.361 422.923Z"
            fill="#808E88"
          />
          <path
            d="M405.517 430.172L397.703 425.532C397.124 425.242 397.124 424.662 397.992 424.083L405.807 419.443C406.675 419.153 407.543 418.863 408.412 419.443L416.226 424.083C416.805 424.372 416.805 424.952 415.937 425.532L407.833 429.882C407.254 430.462 406.096 430.462 405.517 430.172Z"
            fill="#808E88"
          />
          <path
            d="M417.674 437.132L409.859 432.492C409.28 432.202 409.28 431.622 410.149 431.042L417.963 426.402C418.831 426.112 419.7 425.823 420.568 426.402L428.382 431.042C428.961 431.332 428.961 431.912 428.093 432.492L420.279 437.132C419.41 437.422 418.253 437.422 417.674 437.132Z"
            fill="#808E88"
          />
          <path
            d="M250.676 381.745L227.522 368.406C226.943 368.116 226.943 367.536 227.811 366.956L235.626 362.317C236.494 362.027 237.362 361.737 238.231 362.317L261.385 375.656C261.964 375.946 261.964 376.526 261.095 377.106L253.281 381.745C252.413 382.035 251.255 382.035 250.676 381.745Z"
            fill="#808E88"
          />
          <path
            d="M400.309 468.16L377.155 454.821C376.576 454.531 376.576 453.951 377.444 453.371L385.259 448.731C386.127 448.441 386.995 448.151 387.863 448.731L411.017 462.071C411.596 462.361 411.596 462.94 410.728 463.52L402.913 468.16C402.045 468.45 400.887 468.45 400.309 468.16Z"
            fill="#808E88"
          />
          <path
            d="M351.685 455.401L343.87 450.761C343.291 450.471 343.291 449.891 344.16 449.311L353.421 443.801C354.289 443.511 355.158 443.221 356.026 443.801L363.841 448.441C364.419 448.731 364.419 449.311 363.551 449.891L354.289 455.401C353.421 455.981 352.264 455.981 351.685 455.401Z"
            fill="#808E88"
          />
          <path
            d="M263.121 404.364L250.387 397.114C249.808 396.824 249.808 396.244 250.676 395.664L259.938 390.155C260.806 389.865 261.674 389.575 262.542 390.155L275.277 397.404C275.856 397.694 275.856 398.274 274.988 398.854L265.726 404.364C264.858 404.654 263.7 404.654 263.121 404.364Z"
            fill="#808E88"
          />
          <path
            d="M339.819 448.731L327.084 441.482C326.505 441.192 326.505 440.612 327.373 440.032L336.635 434.522C337.503 434.232 338.371 433.942 339.24 434.522L351.974 441.772C352.553 442.062 352.553 442.642 351.685 443.222L342.423 448.731C341.555 449.021 340.397 449.021 339.819 448.731Z"
            fill="#808E88"
          />
          <path
            d="M280.776 414.513L268.041 407.264C267.462 406.974 267.462 406.394 268.331 405.814L277.592 400.304C278.46 400.014 279.329 399.724 280.197 400.304L292.932 407.554C293.51 407.844 293.51 408.424 292.642 409.004L283.381 414.513C282.512 414.803 281.355 414.803 280.776 414.513Z"
            fill="#808E88"
          />
          <path
            d="M280.197 400.304L334.898 431.912C335.477 432.202 335.477 433.072 334.898 433.362L325.347 439.162C324.769 439.452 323.611 439.452 322.743 439.162L268.042 407.264L280.197 400.304Z"
            fill="#808E88"
          />
          <path
            d="M385.548 468.16L394.23 473.38C394.809 473.67 394.809 474.25 393.941 474.54L390.468 476.86C389.889 477.15 389.021 477.15 388.442 476.86L379.759 471.64C379.18 471.35 379.18 470.77 380.049 470.48L383.811 468.16C384.1 468.16 384.969 467.87 385.548 468.16Z"
            fill="#808E88"
          />
          <path
            d="M373.391 461.201L382.074 466.421C382.653 466.711 382.653 467.291 381.785 467.581L378.022 469.9C377.443 470.19 376.575 470.19 375.996 469.9L367.314 464.681C366.735 464.391 366.735 463.811 367.603 463.521L371.366 461.201C371.944 460.911 372.813 460.911 373.391 461.201Z"
            fill="#808E88"
          />
          <path
            d="M361.235 454.241L369.918 459.461C370.497 459.751 370.497 460.331 369.628 460.621L365.866 462.94C365.287 463.23 364.419 463.23 363.84 462.94L355.157 457.721C354.578 457.431 354.578 456.851 355.447 456.561L359.209 454.241C359.788 453.951 360.656 453.951 361.235 454.241Z"
            fill="#808E88"
          />
          <path
            d="M380.048 457.431L388.731 462.651C389.31 462.941 389.31 463.52 388.442 463.81L384.679 466.13C384.1 466.42 383.232 466.42 382.653 466.13L373.97 460.911C373.391 460.621 373.391 460.041 374.26 459.751L378.022 457.431C378.601 457.141 379.469 457.141 380.048 457.431Z"
            fill="#808E88"
          />
          <g className="landing_hero__laptop-apps">
            <path
              d="M355.448 244.583L335.767 233.274L336.635 228.924L356.316 240.523L355.448 244.583Z"
              fill="#EEFBF3"
            />
            <path
              d="M353.422 254.733L333.741 243.133L334.32 238.784L354.29 250.383L353.422 254.733Z"
              fill="white"
            />
            <path
              d="M450.669 392.185L430.699 380.876L431.567 376.526L451.537 388.125L450.669 392.185Z"
              fill="#EEFBF3"
            />
            <path
              d="M349.08 274.452L329.399 263.142L330.268 258.792L349.948 270.102L349.08 274.452Z"
              fill="#EEFBF3"
            />
            <path
              d="M389.31 295.62L369.34 284.021C367.603 282.861 366.446 280.541 367.025 278.221L371.366 258.793C371.945 256.763 373.681 255.893 375.418 256.763L395.388 268.362C397.125 269.522 398.282 271.842 397.704 274.162L393.362 293.591C392.783 295.62 391.047 296.49 389.31 295.62Z"
              fill="#9BC2BB"
            />
            <path
              d="M424.042 315.629L404.071 304.03C402.335 302.87 401.177 300.55 401.756 298.23L406.097 278.802C406.676 276.772 408.413 275.902 410.149 276.772L430.12 288.371C431.856 289.531 433.014 291.851 432.435 294.171L428.094 313.6C427.804 315.919 425.778 316.789 424.042 315.629Z"
              fill="#83B198"
            />
            <path
              d="M381.496 330.128L361.526 318.529C359.789 317.369 358.631 315.049 359.21 312.729L363.552 293.3C364.13 291.27 365.867 290.401 367.603 291.27L387.574 302.87C389.31 304.03 390.468 306.35 389.889 308.669L385.548 328.098C385.258 330.418 383.522 331.288 381.496 330.128Z"
              fill="white"
            />
            <path
              d="M416.517 350.427L396.546 338.828C394.81 337.668 393.652 335.348 394.231 333.028L398.572 313.599C399.151 311.569 400.888 310.699 402.624 311.569L422.594 323.169C424.331 324.329 425.489 326.648 424.91 328.968L420.568 348.397C419.99 350.427 418.253 351.297 416.517 350.427Z"
              fill="#6C867D"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_101_2"
            x1="693"
            y1="-4.00002"
            x2="57.2467"
            y2="544.265"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#E3ECE6" />
            <stop offset="1" stopColor="#EFF4F1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_101_2"
            x1="152.25"
            y1="8.93309"
            x2="766.75"
            y2="605.434"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="0.5" stopColor="white" stopOpacity="0.05" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_101_2"
            x1="137.123"
            y1="285.862"
            x2="38.1818"
            y2="365.186"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_101_2"
            x1="155.82"
            y1="310.068"
            x2="18.2124"
            y2="267.099"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_101_2"
            x1="231.191"
            y1="231.54"
            x2="151.346"
            y2="295.554"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_101_2"
            x1="190.252"
            y1="230.524"
            x2="182.242"
            y2="229.859"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_101_2"
            x1="231.331"
            y1="160.941"
            x2="222.684"
            y2="193.52"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_101_2"
            x1="201.559"
            y1="246.359"
            x2="121.714"
            y2="310.373"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_101_2"
            x1="160.62"
            y1="245.343"
            x2="152.61"
            y2="244.679"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_101_2"
            x1="201.698"
            y1="175.761"
            x2="193.052"
            y2="208.339"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_101_2"
            x1="175.63"
            y1="263.648"
            x2="95.7852"
            y2="327.662"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_101_2"
            x1="134.691"
            y1="262.632"
            x2="126.682"
            y2="261.967"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_101_2"
            x1="175.77"
            y1="193.05"
            x2="167.123"
            y2="225.628"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_101_2"
            x1="145.998"
            y1="278.467"
            x2="66.1529"
            y2="342.481"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_101_2"
            x1="105.059"
            y1="277.451"
            x2="97.0494"
            y2="276.786"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_101_2"
            x1="146.138"
            y1="207.869"
            x2="137.491"
            y2="240.447"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_101_2"
            x1="527.687"
            y1="313.028"
            x2="471.039"
            y2="366.47"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_101_2"
            x1="580.455"
            y1="305.807"
            x2="442.847"
            y2="262.837"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#E7F0EC" />
            <stop offset="1" stopColor="#C3D9CE" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_101_2"
            x1="527.687"
            y1="266.328"
            x2="450.476"
            y2="314.34"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_101_2"
            x1="580.455"
            y1="279.775"
            x2="517.291"
            y2="243.477"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D9E9E2" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    ),
    dongleKitModems: (
      <svg
        width="135"
        height="153"
        viewBox="0 0 135 153"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M95.9388 152.303C96.3366 152.303 96.7165 152.224 97.0006 152.06L98.2575 151.334L91.8093 147.611L78.7035 140.045L76.3118 141.426L94.5555 151.958C94.9516 152.186 95.4579 152.303 95.9388 152.303ZM98.6816 151.089L124.895 135.954L118.447 132.232L112.742 128.938L97.0006 138.027C96.7165 138.191 96.3366 138.271 95.9388 138.271C95.4579 138.271 94.9516 138.154 94.5555 137.925L88.4644 134.408L79.1284 139.799L92.2334 147.366L98.6816 151.089ZM75.8869 141.18L78.2777 139.8L15.1713 103.38L9.35328 100.021L8.09637 100.746C7.46962 101.108 7.5485 101.74 8.27194 102.158L75.8869 141.18ZM78.7035 139.554L88.0403 134.164L19.1142 94.3852L9.77735 99.7758L15.5954 103.135L78.7035 139.554ZM125.32 135.709L133.635 130.909C134.262 130.547 134.183 129.915 133.46 129.497L122.617 123.237L113.167 128.693L118.871 131.987L125.32 135.709Z"
          fill="#B0C1B8"
        />
        <path
          d="M95.939 138.271C96.3367 138.271 96.7167 138.191 97.0008 138.027L112.743 128.938L113.166 128.694L122.617 123.237L130.03 118.957L130.829 118.496L133.636 116.875C133.908 116.718 134.039 116.509 134.05 116.289H134.056L134.058 110.486V109.997L134.058 109.208C134.058 109.22 134.057 109.233 134.056 109.245V109.287L134.05 109.291C134.017 109.483 133.882 109.664 133.641 109.805L133.636 109.808L97.0008 130.959C96.9949 130.962 96.989 130.966 96.983 130.969C96.9788 130.972 96.9754 130.973 96.9711 130.976C96.6921 131.128 96.3266 131.203 95.9441 131.203H95.939H95.9356C95.4649 131.203 94.9687 131.09 94.5769 130.87C94.5701 130.866 94.8476 130.812 94.8399 130.809L0.593073 76.7436C0.576111 76.7343 0.559159 76.7241 0.543045 76.7139C0.540501 76.7131 0.537102 76.7105 0.537102 76.7105L0.533705 76.708L0.532011 76.7071C0.236868 76.5222 0.061301 76.3 0.0104143 76.0795L0.000242351 76.0744V83.0544C0.0189008 83.319 0.216511 83.5947 0.593073 83.8118L60.9043 118.497L61.7032 118.958L61.8279 119.03L69.1157 123.238L88.0405 134.164L88.4646 134.408L94.5557 137.925C94.9518 138.154 95.4581 138.271 95.939 138.271Z"
          fill="url(#paint0_linear_1049_3418)"
        />
        <path
          d="M95.9391 131.203H95.9442C96.3267 131.202 96.6922 131.128 96.9712 130.976C96.9755 130.973 96.9789 130.972 96.9831 130.969C96.989 130.966 96.995 130.962 97.0009 130.959L133.636 109.808L133.641 109.804C133.881 109.664 134.013 109.484 134.047 109.292L134.05 109.29C134.053 109.275 134.055 109.26 134.056 109.245V109.145C134.034 108.883 133.832 108.611 133.46 108.397L39.5222 54.2975C39.1261 54.0694 38.6198 53.9523 38.1398 53.9523C37.7522 53.9523 37.3824 54.0287 37.1017 54.183C37.0932 54.1881 37.0855 54.1924 37.0779 54.1966L0.442821 75.3477C0.158703 75.5114 0.0196066 75.731 0.0196066 75.9609C0.0196066 75.988 0.021309 76.0151 0.0255495 76.0414C0.0280939 76.0592 0.031491 76.0771 0.0357316 76.0949L0.043358 76.1C0.095941 76.3188 0.26473 76.5393 0.557329 76.7225L0.559012 76.7233L0.562399 76.7259C0.562399 76.7259 0.565798 76.7284 0.568342 76.7293C0.584456 76.7394 0.601428 76.7496 0.61839 76.759L94.5558 130.858C94.5634 130.861 94.5702 130.866 94.577 130.87C94.9688 131.089 95.465 131.203 95.9357 131.203H95.9391ZM38.1474 56.4577C38.5731 56.4577 39.0226 56.5611 39.3737 56.7638L129.19 108.482C129.831 108.853 129.901 109.413 129.345 109.733L96.872 128.482C96.6201 128.627 96.2834 128.699 95.9306 128.699C95.5048 128.699 95.0553 128.595 94.7051 128.392L4.88863 76.6733C4.24745 76.3027 4.17792 75.7429 4.73343 75.4223L37.206 56.6739C37.4579 56.5281 37.7946 56.4577 38.1474 56.4577Z"
          fill="url(#paint1_linear_1049_3418)"
        />
        <path
          d="M95.9303 128.699C96.2831 128.699 96.6198 128.627 96.8717 128.482L129.345 109.733C129.9 109.413 129.831 108.853 129.189 108.482L39.1803 56.917C38.8292 56.7143 38.3797 56.6108 37.9539 56.6108C37.6011 56.6108 37.2644 56.6812 37.0125 56.8271L4.53998 75.5755C3.98447 75.8961 4.05402 76.4558 4.69519 76.8265L94.363 128.669C94.7133 128.872 95.5045 128.699 95.9303 128.699ZM37.959 58.1985C38.3508 58.1985 38.763 58.2943 39.0853 58.4801L126.481 108.537C127.07 108.877 127.134 109.391 126.624 109.687L96.7903 126.912C96.5587 127.045 96.25 127.11 95.9252 127.11C95.5342 127.11 95.1212 127.015 94.7989 126.829L7.40322 76.7722C6.81378 76.4312 6.75017 75.9173 7.25988 75.6221L37.0948 58.3978C37.3255 58.2638 37.635 58.1985 37.959 58.1985Z"
          fill="#808E88"
        />
        <path
          d="M95.9253 127.11C96.2501 127.11 96.5588 127.045 96.7904 126.912L126.624 109.687C127.135 109.392 127.071 108.878 126.481 108.538L38.8576 58.6049C38.5353 58.4192 38.1231 58.3233 37.7313 58.3233C37.4073 58.3233 37.0977 58.3887 36.867 58.5227L7.03212 75.747C6.5224 76.0421 6.58602 76.5561 7.17546 76.897L94.799 126.829C95.1213 127.015 95.5343 127.11 95.9253 127.11Z"
          fill="#AEC7B9"
        />
        <path
          d="M18.0106 77.9064V12.4131L22.5066 10.0152L33.824 3.23616C34.3291 2.9446 35.2127 2.98087 35.7965 3.31829L38.0174 4.44858L47.2605 4.45474L47.2589 70.2622H47.2538C47.2452 70.4401 47.1394 70.6085 46.9194 70.7358L26.4032 82.4141C25.8974 82.7063 25.0138 82.6694 24.43 82.3327L18.489 78.5176C18.1852 78.3424 18.0257 78.1206 18.0106 77.9064Z"
          fill="url(#paint2_linear_1049_3418)"
        />
        <path
          d="M26.4031 35.3562L24.6047 82.4144C25.3484 82.6813 25.7412 82.6745 26.4031 82.4144L26.4031 35.3562Z"
          fill="url(#paint3_linear_1049_3418)"
        />
        <path
          d="M41.6828 35.9883L38.5629 37.7711C38.1172 38.0682 38.2658 38.3654 38.2658 38.3654L38.86 38.9596L39.7515 38.4397C39.9 38.3654 39.7515 38.8111 39.7515 38.8111L38.86 41.411C38.86 41.411 36.7058 38.2911 36.5572 37.9939C36.3344 37.6968 36.6315 37.5482 36.6315 37.5482L43.3914 33.6112C43.6885 33.4626 43.4657 33.9826 43.4657 33.9826L37.6715 49.8794L37.0772 49.2852V48.7652L41.6828 35.9883Z"
          fill="#35BE70"
        />
        <path
          d="M36.9288 43.7139L35.2202 41.4854C35.2202 41.4854 35.0716 41.1882 35.2945 41.0397L36.4088 40.3711L38.2659 43.0453L36.4088 47.9481L35.8888 47.2795V46.8338L36.9288 44.011V43.7139Z"
          fill="#35BE70"
        />
        <path
          d="M31.6544 40.4454L35.1457 38.4397L35.3686 38.7368L35.5914 39.034C35.8143 39.4054 35.5172 39.554 35.5172 39.554L33.5858 40.6682C33.2143 40.8911 33.4372 41.1882 33.4372 41.1882L35.5914 44.3082L35.6657 44.8282L35.1457 46.1653C35.1457 46.1653 31.8029 41.2625 31.5058 40.9654C31.2087 40.6682 31.6544 40.4454 31.6544 40.4454Z"
          fill="#35BE70"
        />
        <path
          d="M26.1033 16.9205L46.9192 5.23385C47.4247 4.94161 47.3614 4.43172 46.7775 4.0943L41.09 0.435129C40.5061 0.0983944 39.6226 0.06144 39.1175 0.353687L18.3013 12.0404C17.7955 12.3319 17.8591 12.8418 18.4429 13.1792L24.1301 16.8384C24.7139 17.1758 25.5975 17.2128 26.1033 16.9205Z"
          fill="url(#paint4_linear_1049_3418)"
        />
        <path
          d="M36.621 87.2111V21.7178L41.117 19.3199L52.4344 12.5408C52.9395 12.2493 53.8231 12.2856 54.4069 12.623L56.6277 13.7533L65.8708 13.7594L65.8692 79.5669H65.8641C65.8556 79.7448 65.7497 79.9132 65.5297 80.0405L45.0135 91.7188C44.5077 92.011 43.6242 91.9741 43.0403 91.6373L37.0994 87.8223C36.7955 87.6471 36.636 87.4253 36.621 87.2111Z"
          fill="url(#paint5_linear_1049_3418)"
        />
        <path
          d="M45.0134 44.6609L43.215 91.7191C43.9588 91.9859 44.3515 91.9792 45.0134 91.7191L45.0134 44.6609Z"
          fill="url(#paint6_linear_1049_3418)"
        />
        <path
          d="M60.2932 45.293L57.1733 47.0758C56.7275 47.3729 56.8761 47.6701 56.8761 47.6701L57.4704 48.2643L58.3618 47.7443C58.5104 47.6701 58.3618 48.1158 58.3618 48.1158L57.4704 50.7157C57.4704 50.7157 55.3161 47.5958 55.1676 47.2986C54.9447 47.0015 55.2419 46.8529 55.2419 46.8529L62.0017 42.9159C62.2989 42.7673 62.076 43.2873 62.076 43.2873L56.2818 59.1841L55.6876 58.5899V58.0699L60.2932 45.293Z"
          fill="#35BE70"
        />
        <path
          d="M55.5391 53.0186L53.8306 50.79C53.8306 50.79 53.682 50.4929 53.9048 50.3443L55.0191 49.6758L56.8762 52.35L55.0191 57.2528L54.4991 56.5842V56.1385L55.5391 53.3157V53.0186Z"
          fill="#35BE70"
        />
        <path
          d="M50.2645 49.7501L53.7558 47.7444L53.9787 48.0415L54.2015 48.3387C54.4244 48.7101 54.1273 48.8587 54.1273 48.8587L52.1959 49.9729C51.8244 50.1958 52.0473 50.4929 52.0473 50.4929L54.2015 53.6128L54.2758 54.1328L53.7558 55.47C53.7558 55.47 50.413 50.5672 50.1159 50.2701C49.8188 49.9729 50.2645 49.7501 50.2645 49.7501Z"
          fill="#35BE70"
        />
        <path
          d="M44.7136 26.2252L65.5296 14.5385C66.0351 14.2463 65.9717 13.7364 65.3878 13.399L59.7003 9.73982C59.1165 9.40308 58.2329 9.36613 57.7278 9.65837L36.9116 21.345C36.4058 21.6366 36.4695 22.1465 37.0533 22.4839L42.7404 26.1431C43.3242 26.4805 44.2078 26.5174 44.7136 26.2252Z"
          fill="url(#paint7_linear_1049_3418)"
        />
        <path
          d="M54.4489 96.1254V30.6321L58.9449 28.2342L70.2623 21.4552C70.7674 21.1636 71.651 21.1999 72.2348 21.5373L74.4556 22.6676L83.6987 22.6737L83.6971 88.4812H83.692C83.6835 88.6591 83.5776 88.8275 83.3576 88.9548L62.8414 100.633C62.3356 100.925 61.452 100.888 60.8682 100.552L54.9273 96.7366C54.6234 96.5614 54.4639 96.3396 54.4489 96.1254Z"
          fill="url(#paint8_linear_1049_3418)"
        />
        <path
          d="M62.8411 53.5752L61.0427 100.633C61.7864 100.9 62.1791 100.893 62.8411 100.633L62.8411 53.5752Z"
          fill="url(#paint9_linear_1049_3418)"
        />
        <path
          d="M78.1208 54.2073L75.0009 55.9901C74.5552 56.2872 74.7038 56.5844 74.7038 56.5844L75.298 57.1786L76.1894 56.6586C76.338 56.5844 76.1894 57.0301 76.1894 57.0301L75.298 59.63C75.298 59.63 73.1438 56.5101 72.9952 56.2129C72.7724 55.9158 73.0695 55.7672 73.0695 55.7672L79.8294 51.8302C80.1265 51.6816 79.9037 52.2016 79.9037 52.2016L74.1095 68.0984L73.5152 67.5042V66.9842L78.1208 54.2073Z"
          fill="#35BE70"
        />
        <path
          d="M73.3667 61.9329L71.6582 59.7044C71.6582 59.7044 71.5096 59.4072 71.7325 59.2586L72.8467 58.5901L74.7039 61.2643L72.8467 66.1671L72.3268 65.4985V65.0528L73.3667 62.23V61.9329Z"
          fill="#35BE70"
        />
        <path
          d="M68.0924 58.6644L71.5837 56.6587L71.8066 56.9558L72.0294 57.253C72.2523 57.6244 71.9551 57.773 71.9551 57.773L70.0237 58.8872C69.6523 59.1101 69.8752 59.4072 69.8752 59.4072L72.0294 62.5272L72.1037 63.0471L71.5837 64.3843C71.5837 64.3843 68.2409 59.4815 67.9438 59.1844C67.6466 58.8872 68.0924 58.6644 68.0924 58.6644Z"
          fill="#35BE70"
        />
        <path
          d="M62.5412 35.1395L83.3572 23.4528C83.8627 23.1606 83.7994 22.6507 83.2155 22.3133L77.5279 18.6541C76.9441 18.3174 76.0606 18.2804 75.5555 18.5727L54.7393 30.2593C54.2335 30.5509 54.2971 31.0608 54.8809 31.3982L60.5681 35.0574C61.1519 35.3948 62.0355 35.4317 62.5412 35.1395Z"
          fill="url(#paint10_linear_1049_3418)"
        />
        <path
          d="M70.0477 106.525V41.032L74.5437 38.6341L85.8611 31.8551C86.3663 31.5635 87.2498 31.5998 87.8336 31.9372L90.0545 33.0675L99.2976 33.0736L99.296 98.8811H99.2909C99.2823 99.059 99.1765 99.2274 98.9565 99.3547L78.4403 111.033C77.9345 111.325 77.0509 111.288 76.4671 110.952L70.5261 107.136C70.2223 106.961 70.0628 106.74 70.0477 106.525Z"
          fill="url(#paint11_linear_1049_3418)"
        />
        <path
          d="M78.4414 63.9751L76.643 111.033C77.3868 111.3 77.7795 111.293 78.4414 111.033L78.4414 63.9751Z"
          fill="url(#paint12_linear_1049_3418)"
        />
        <path
          d="M93.7212 64.6072L90.6012 66.39C90.1555 66.6871 90.3041 66.9843 90.3041 66.9843L90.8984 67.5785L91.7898 67.0585C91.9384 66.9843 91.7898 67.43 91.7898 67.43L90.8984 70.0299C90.8984 70.0299 88.7441 66.91 88.5956 66.6128C88.3727 66.3157 88.6698 66.1671 88.6698 66.1671L95.4297 62.2301C95.7269 62.0815 95.504 62.6015 95.504 62.6015L89.7098 78.4983L89.1155 77.9041V77.3841L93.7212 64.6072Z"
          fill="#35BE70"
        />
        <path
          d="M88.9671 72.3328L87.2585 70.1043C87.2585 70.1043 87.11 69.8071 87.3328 69.6585L88.4471 68.99L90.3042 71.6642L88.4471 76.567L87.9271 75.8984V75.4527L88.9671 72.6299V72.3328Z"
          fill="#35BE70"
        />
        <path
          d="M83.6925 69.0643L87.1838 67.0586L87.4067 67.3557L87.6295 67.6529C87.8524 68.0243 87.5552 68.1729 87.5552 68.1729L85.6238 69.2871C85.2524 69.51 85.4753 69.8071 85.4753 69.8071L87.6295 72.9271L87.7038 73.447L87.1838 74.7842C87.1838 74.7842 83.841 69.8814 83.5439 69.5843C83.2467 69.2871 83.6925 69.0643 83.6925 69.0643Z"
          fill="#35BE70"
        />
        <path
          d="M78.1408 45.5394L98.9568 33.8528C99.4623 33.5605 99.399 33.0506 98.8151 32.7132L93.1276 29.054C92.5437 28.7173 91.6602 28.6803 91.1551 28.9726L70.3389 40.6592C69.8331 40.9508 69.8967 41.4607 70.4805 41.7981L76.1677 45.4573C76.7515 45.7947 77.6351 45.8316 78.1408 45.5394Z"
          fill="url(#paint13_linear_1049_3418)"
        />
        <path
          d="M87.8761 115.439V49.946L92.3721 47.5482L103.69 40.7691C104.195 40.4776 105.078 40.5138 105.662 40.8512L107.883 41.9815L117.126 41.9877L117.124 107.795H117.119C117.111 107.973 117.005 108.141 116.785 108.269L96.2687 119.947C95.7629 120.239 94.8793 120.202 94.2955 119.866L88.3545 116.051C88.0506 115.875 87.8912 115.654 87.8761 115.439Z"
          fill="url(#paint14_linear_1049_3418)"
        />
        <path
          d="M96.2698 72.8892L94.4714 119.947C95.2151 120.214 95.6079 120.207 96.2698 119.947L96.2698 72.8892Z"
          fill="url(#paint15_linear_1049_3418)"
        />
        <path
          d="M111.55 73.5212L108.43 75.3041C107.984 75.6012 108.133 75.8983 108.133 75.8983L108.727 76.4926L109.618 75.9726C109.767 75.8983 109.618 76.344 109.618 76.344L108.727 78.944C108.727 78.944 106.573 75.824 106.424 75.5269C106.201 75.2298 106.498 75.0812 106.498 75.0812L113.258 71.1441C113.555 70.9956 113.333 71.5155 113.333 71.5155L107.538 87.4124L106.944 86.8181V86.2981L111.55 73.5212Z"
          fill="#35BE70"
        />
        <path
          d="M106.796 81.2468L105.087 79.0183C105.087 79.0183 104.939 78.7212 105.161 78.5726L106.276 77.9041L108.133 80.5783L106.276 85.4811L105.756 84.8125V84.3668L106.796 81.544V81.2468Z"
          fill="#35BE70"
        />
        <path
          d="M101.521 77.9783L105.013 75.9727L105.236 76.2698L105.458 76.5669C105.681 76.9384 105.384 77.0869 105.384 77.0869L103.453 78.2012C103.081 78.424 103.304 78.7212 103.304 78.7212L105.458 81.8411L105.533 82.3611L105.013 83.6982C105.013 83.6982 101.67 78.7955 101.373 78.4983C101.076 78.2012 101.521 77.9783 101.521 77.9783Z"
          fill="#35BE70"
        />
        <path
          d="M95.9695 54.4535L116.785 42.7668C117.291 42.4746 117.228 41.9647 116.644 41.6273L110.956 37.9681C110.372 37.6314 109.489 37.5944 108.984 37.8866L88.1675 49.5733C87.6617 49.8649 87.7253 50.3748 88.3092 50.7122L93.9963 54.3713C94.5801 54.7088 95.4637 54.7457 95.9695 54.4535Z"
          fill="url(#paint16_linear_1049_3418)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1049_3418"
            x1="73.9975"
            y1="95.3281"
            x2="133.516"
            y2="143.055"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1049_3418"
            x1="62.749"
            y1="109.888"
            x2="145.537"
            y2="84.0315"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1049_3418"
            x1="-1.20803"
            y1="53.3468"
            x2="46.823"
            y2="91.8622"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1049_3418"
            x1="23.423"
            y1="52.7357"
            x2="28.2419"
            y2="52.3356"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1049_3418"
            x1="-1.29211"
            y1="10.8798"
            x2="3.90819"
            y2="30.4771"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1049_3418"
            x1="17.4023"
            y1="62.6515"
            x2="65.4334"
            y2="101.167"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_1049_3418"
            x1="42.0334"
            y1="62.0403"
            x2="46.8523"
            y2="61.6403"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_1049_3418"
            x1="17.3182"
            y1="20.1845"
            x2="22.5185"
            y2="39.7818"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_1049_3418"
            x1="35.2302"
            y1="71.5658"
            x2="83.2613"
            y2="110.081"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_1049_3418"
            x1="59.861"
            y1="70.9547"
            x2="64.6799"
            y2="70.5546"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_1049_3418"
            x1="35.1459"
            y1="29.0988"
            x2="40.3462"
            y2="48.6961"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_1049_3418"
            x1="50.8291"
            y1="81.9657"
            x2="98.8601"
            y2="120.481"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_1049_3418"
            x1="75.4614"
            y1="81.3546"
            x2="80.2802"
            y2="80.9545"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_1049_3418"
            x1="50.7455"
            y1="39.4987"
            x2="55.9458"
            y2="59.096"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_1049_3418"
            x1="68.6574"
            y1="90.8798"
            x2="116.689"
            y2="129.395"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_1049_3418"
            x1="93.2897"
            y1="90.2686"
            x2="98.1086"
            y2="89.8686"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_1049_3418"
            x1="68.5741"
            y1="48.4127"
            x2="73.7744"
            y2="68.0101"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    ),
    dongleKitModems1: (
      <svg
        width="270"
        height="200"
        viewBox="0 0 270 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M163.939 176.147C164.336 176.147 164.716 176.067 165 175.904L166.257 175.178L159.809 171.454L146.703 163.888L144.312 165.269L162.555 175.802C162.951 176.03 163.458 176.147 163.939 176.147ZM166.681 174.932L192.895 159.798L186.447 156.076L180.742 152.781L165 161.871C164.716 162.034 164.336 162.115 163.939 162.115C163.458 162.115 162.951 161.998 162.555 161.769L156.464 158.252L147.128 163.642L160.233 171.209L166.681 174.932ZM143.887 165.023L146.277 163.643L83.1711 127.224L77.353 123.864L76.0961 124.59C75.4694 124.952 75.5483 125.584 76.2717 126.002L143.887 165.023ZM146.703 163.397L156.04 158.008L87.114 118.229L77.7771 123.619L83.5952 126.979L146.703 163.397ZM193.32 159.553L201.635 154.752C202.262 154.39 202.183 153.759 201.46 153.34L190.617 147.08L181.166 152.536L186.871 155.83L193.32 159.553Z"
          fill="#B0C1B8"
        />
        <path
          d="M163.939 162.115C164.337 162.115 164.716 162.034 165.001 161.871L180.742 152.782L181.166 152.537L190.617 147.08L198.03 142.801L198.829 142.34L201.635 140.719C201.908 140.562 202.039 140.352 202.05 140.133H202.056L202.058 134.33V133.841L202.058 133.052C202.058 133.064 202.057 133.076 202.056 133.088V133.131L202.05 133.134C202.017 133.327 201.882 133.507 201.641 133.648L201.635 133.651L165.001 154.803C164.995 154.806 164.989 154.809 164.983 154.813C164.979 154.815 164.975 154.817 164.971 154.82C164.692 154.971 164.326 155.047 163.944 155.047H163.939H163.935C163.465 155.047 162.968 154.933 162.577 154.714C162.57 154.709 162.847 154.656 162.84 154.652L68.5928 100.587C68.5759 100.578 68.5589 100.568 68.5428 100.557C68.5403 100.557 68.5369 100.554 68.5369 100.554L68.5335 100.551L68.5318 100.551C68.2366 100.366 68.0611 100.144 68.0102 99.923L68 99.9179V106.898C68.0187 107.163 68.2163 107.438 68.5928 107.655L128.904 142.34L129.703 142.802L129.828 142.874L137.115 147.081L156.04 158.008L156.464 158.252L162.555 161.769C162.952 161.998 163.458 162.115 163.939 162.115Z"
          fill="url(#paint0_linear_2364_419)"
        />
        <path
          d="M163.939 155.047H163.944C164.326 155.046 164.692 154.971 164.971 154.819C164.975 154.817 164.979 154.815 164.983 154.813C164.989 154.809 164.995 154.806 165.001 154.802L201.635 133.651L201.641 133.648C201.881 133.508 202.013 133.327 202.047 133.136L202.05 133.134C202.053 133.119 202.055 133.103 202.056 133.088V132.988C202.033 132.726 201.832 132.455 201.46 132.24L107.522 78.141C107.126 77.9129 106.62 77.7958 106.14 77.7958C105.752 77.7958 105.382 77.8722 105.101 78.0265C105.093 78.0316 105.085 78.0359 105.078 78.0401L68.4426 99.1912C68.1585 99.3549 68.0194 99.5745 68.0194 99.8044C68.0194 99.8315 68.0211 99.8586 68.0253 99.8849C68.0278 99.9027 68.0312 99.9206 68.0355 99.9384L68.0431 99.9435C68.0957 100.162 68.2645 100.383 68.5571 100.566L68.5588 100.567L68.5621 100.569C68.5621 100.569 68.5656 100.572 68.5681 100.573C68.5842 100.583 68.6012 100.593 68.6181 100.602L162.556 154.701C162.563 154.705 162.57 154.709 162.577 154.713C162.969 154.933 163.465 155.047 163.935 155.047H163.939ZM106.147 80.3012C106.573 80.3012 107.022 80.4046 107.374 80.6074L197.19 132.326C197.831 132.696 197.9 133.256 197.345 133.577L164.872 152.326C164.62 152.471 164.283 152.542 163.93 152.542C163.505 152.542 163.055 152.439 162.705 152.236L72.8884 100.517C72.2472 100.146 72.1777 99.5864 72.7332 99.2658L105.206 80.5174C105.458 80.3716 105.794 80.3012 106.147 80.3012Z"
          fill="url(#paint1_linear_2364_419)"
        />
        <path
          d="M163.93 152.542C164.283 152.542 164.62 152.471 164.871 152.326L197.345 133.577C197.9 133.256 197.831 132.696 197.189 132.326L107.18 80.7605C106.829 80.5578 106.379 80.4543 105.954 80.4543C105.601 80.4543 105.264 80.5247 105.012 80.6706L72.5397 99.419C71.9842 99.7396 72.0538 100.299 72.6949 100.67L162.363 152.513C162.713 152.715 163.504 152.542 163.93 152.542ZM105.959 82.042C106.351 82.042 106.763 82.1378 107.085 82.3236L194.481 132.381C195.07 132.721 195.134 133.235 194.624 133.53L164.79 150.755C164.558 150.888 164.25 150.954 163.925 150.954C163.534 150.954 163.121 150.859 162.799 150.672L75.403 100.616C74.8135 100.275 74.7499 99.7608 75.2596 99.4656L105.095 82.2413C105.325 82.1073 105.635 82.042 105.959 82.042Z"
          fill="#808E88"
        />
        <path
          d="M163.925 150.954C164.25 150.954 164.559 150.889 164.79 150.755L194.624 133.53C195.134 133.235 195.07 132.721 194.481 132.381L106.857 82.4484C106.535 82.2627 106.123 82.1669 105.731 82.1669C105.407 82.1669 105.097 82.2322 104.867 82.3662L75.0319 99.5905C74.5222 99.8856 74.5858 100.4 75.1752 100.741L162.799 150.672C163.121 150.859 163.534 150.954 163.925 150.954Z"
          fill="#AEC7B9"
        />
        <path
          d="M86.0104 101.75V36.2566L90.5064 33.8587L101.824 27.0797C102.329 26.7881 103.212 26.8244 103.796 27.1618L106.017 28.2921L115.26 28.2982L115.259 94.1057H115.254C115.245 94.2836 115.139 94.452 114.919 94.5793L94.4029 106.258C93.8971 106.55 93.0136 106.513 92.4297 106.176L86.4888 102.361C86.1849 102.186 86.0254 101.964 86.0104 101.75Z"
          fill="url(#paint2_linear_2364_419)"
        />
        <path
          d="M94.4028 59.1997L92.6044 106.258C93.3482 106.525 93.7409 106.518 94.4028 106.258L94.4028 59.1997Z"
          fill="url(#paint3_linear_2364_419)"
        />
        <path
          d="M109.683 59.8318L106.563 61.6146C106.117 61.9117 106.266 62.2089 106.266 62.2089L106.86 62.8031L107.751 62.2832C107.9 62.2089 107.751 62.6546 107.751 62.6546L106.86 65.2545C106.86 65.2545 104.706 62.1346 104.557 61.8375C104.334 61.5403 104.631 61.3917 104.631 61.3917L111.391 57.4547C111.688 57.3061 111.465 57.8261 111.465 57.8261L105.671 73.7229L105.077 73.1287V72.6087L109.683 59.8318Z"
          fill="#35BE70"
        />
        <path
          d="M104.929 67.5574L103.22 65.3289C103.22 65.3289 103.071 65.0317 103.294 64.8832L104.409 64.2146L106.266 66.8888L104.409 71.7916L103.889 71.123V70.6773L104.929 67.8545V67.5574Z"
          fill="#35BE70"
        />
        <path
          d="M99.6541 64.2889L103.145 62.2832L103.368 62.5803L103.591 62.8775C103.814 63.2489 103.517 63.3975 103.517 63.3975L101.586 64.5117C101.214 64.7346 101.437 65.0317 101.437 65.0317L103.591 68.1517L103.665 68.6717L103.145 70.0088C103.145 70.0088 99.8027 65.106 99.5056 64.8089C99.2084 64.5117 99.6541 64.2889 99.6541 64.2889Z"
          fill="#35BE70"
        />
        <path
          d="M94.103 40.764L114.919 29.0774C115.425 28.7851 115.361 28.2752 114.777 27.9378L109.09 24.2786C108.506 23.9419 107.622 23.9049 107.117 24.1972L86.301 35.8839C85.7952 36.1754 85.8589 36.6853 86.4427 37.0227L92.1298 40.6819C92.7136 41.0193 93.5972 41.0563 94.103 40.764Z"
          fill="url(#paint4_linear_2364_419)"
        />
        <path
          d="M104.621 111.055V45.5613L109.117 43.1634L120.434 36.3844C120.939 36.0928 121.823 36.1291 122.407 36.4665L124.627 37.5968L133.871 37.6029L133.869 103.41H133.864C133.855 103.588 133.749 103.757 133.529 103.884L113.013 115.562C112.507 115.855 111.624 115.818 111.04 115.481L105.099 111.666C104.795 111.491 104.636 111.269 104.621 111.055Z"
          fill="url(#paint5_linear_2364_419)"
        />
        <path
          d="M113.013 68.5044L111.215 115.563C111.959 115.829 112.351 115.823 113.013 115.563L113.013 68.5044Z"
          fill="url(#paint6_linear_2364_419)"
        />
        <path
          d="M128.293 69.1365L125.173 70.9193C124.727 71.2164 124.876 71.5136 124.876 71.5136L125.47 72.1078L126.362 71.5878C126.51 71.5136 126.362 71.9593 126.362 71.9593L125.47 74.5592C125.47 74.5592 123.316 71.4393 123.167 71.1421C122.944 70.845 123.242 70.6964 123.242 70.6964L130.001 66.7594C130.299 66.6108 130.076 67.1308 130.076 67.1308L124.282 83.0276L123.687 82.4334V81.9134L128.293 69.1365Z"
          fill="#35BE70"
        />
        <path
          d="M123.539 76.8621L121.83 74.6336C121.83 74.6336 121.682 74.3364 121.905 74.1878L123.019 73.5193L124.876 76.1935L123.019 81.0963L122.499 80.4277V79.982L123.539 77.1592V76.8621Z"
          fill="#35BE70"
        />
        <path
          d="M118.264 73.5936L121.756 71.5879L121.978 71.885L122.201 72.1822C122.424 72.5536 122.127 72.7022 122.127 72.7022L120.196 73.8164C119.824 74.0393 120.047 74.3364 120.047 74.3364L122.201 77.4564L122.276 77.9763L121.756 79.3135C121.756 79.3135 118.413 74.4107 118.116 74.1136C117.819 73.8164 118.264 73.5936 118.264 73.5936Z"
          fill="#35BE70"
        />
        <path
          d="M112.713 50.0687L133.529 38.382C134.035 38.0898 133.971 37.5799 133.388 37.2425L127.7 33.5833C127.116 33.2466 126.233 33.2096 125.728 33.5019L104.911 45.1885C104.406 45.4801 104.469 45.99 105.053 46.3274L110.74 49.9866C111.324 50.324 112.208 50.3609 112.713 50.0687Z"
          fill="url(#paint7_linear_2364_419)"
        />
        <path
          d="M122.449 119.969V54.4756L126.945 52.0777L138.262 45.2987C138.767 45.0071 139.651 45.0434 140.235 45.3808L142.455 46.5111L151.698 46.5172L151.697 112.325H151.692C151.683 112.503 151.577 112.671 151.357 112.798L130.841 124.477C130.335 124.769 129.452 124.732 128.868 124.395L122.927 120.58C122.623 120.405 122.464 120.183 122.449 119.969Z"
          fill="url(#paint8_linear_2364_419)"
        />
        <path
          d="M130.841 77.4187L129.042 124.477C129.786 124.744 130.179 124.737 130.841 124.477L130.841 77.4187Z"
          fill="url(#paint9_linear_2364_419)"
        />
        <path
          d="M146.121 78.0508L143.001 79.8336C142.555 80.1307 142.704 80.4279 142.704 80.4279L143.298 81.0221L144.189 80.5022C144.338 80.4279 144.189 80.8736 144.189 80.8736L143.298 83.4735C143.298 83.4735 141.144 80.3536 140.995 80.0564C140.772 79.7593 141.069 79.6107 141.069 79.6107L147.829 75.6737C148.126 75.5251 147.903 76.0451 147.903 76.0451L142.109 91.9419L141.515 91.3477V90.8277L146.121 78.0508Z"
          fill="#35BE70"
        />
        <path
          d="M141.366 85.7764L139.658 83.5479C139.658 83.5479 139.509 83.2507 139.732 83.1022L140.847 82.4336L142.704 85.1078L140.847 90.0106L140.327 89.342V88.8963L141.366 86.0735V85.7764Z"
          fill="#35BE70"
        />
        <path
          d="M136.092 82.5079L139.583 80.5022L139.806 80.7993L140.029 81.0965C140.252 81.4679 139.955 81.6165 139.955 81.6165L138.024 82.7307C137.652 82.9536 137.875 83.2507 137.875 83.2507L140.029 86.3707L140.103 86.8907L139.583 88.2278C139.583 88.2278 136.241 83.325 135.944 83.0279C135.646 82.7307 136.092 82.5079 136.092 82.5079Z"
          fill="#35BE70"
        />
        <path
          d="M130.541 58.983L151.357 47.2964C151.862 47.0041 151.799 46.4942 151.215 46.1568L145.528 42.4976C144.944 42.1609 144.06 42.1239 143.555 42.4162L122.739 54.1029C122.233 54.3944 122.297 54.9043 122.881 55.2417L128.568 58.9009C129.152 59.2383 130.035 59.2753 130.541 58.983Z"
          fill="url(#paint10_linear_2364_419)"
        />
        <path
          d="M138.047 130.369V64.8755L142.543 62.4776L153.861 55.6986C154.366 55.407 155.25 55.4433 155.833 55.7807L158.054 56.911L167.297 56.9171L167.296 122.725H167.291C167.282 122.903 167.176 123.071 166.956 123.198L146.44 134.876C145.934 135.169 145.051 135.132 144.467 134.795L138.526 130.98C138.222 130.805 138.063 130.583 138.047 130.369Z"
          fill="url(#paint11_linear_2364_419)"
        />
        <path
          d="M146.441 87.8186L144.643 134.877C145.387 135.144 145.779 135.137 146.441 134.877L146.441 87.8186Z"
          fill="url(#paint12_linear_2364_419)"
        />
        <path
          d="M161.721 88.4507L158.601 90.2335C158.155 90.5306 158.304 90.8278 158.304 90.8278L158.898 91.422L159.79 90.9021C159.938 90.8278 159.79 91.2735 159.79 91.2735L158.898 93.8734C158.898 93.8734 156.744 90.7535 156.595 90.4563C156.372 90.1592 156.67 90.0106 156.67 90.0106L163.429 86.0736C163.727 85.925 163.504 86.445 163.504 86.445L157.71 102.342L157.115 101.748V101.228L161.721 88.4507Z"
          fill="#35BE70"
        />
        <path
          d="M156.967 96.1763L155.258 93.9478C155.258 93.9478 155.11 93.6506 155.333 93.5021L156.447 92.8335L158.304 95.5077L156.447 100.411L155.927 99.7419V99.2962L156.967 96.4734V96.1763Z"
          fill="#35BE70"
        />
        <path
          d="M151.692 92.9078L155.184 90.9021L155.406 91.1992L155.629 91.4964C155.852 91.8678 155.555 92.0164 155.555 92.0164L153.624 93.1306C153.252 93.3535 153.475 93.6506 153.475 93.6506L155.629 96.7706L155.704 97.2906L155.184 98.6277C155.184 98.6277 151.841 93.7249 151.544 93.4278C151.247 93.1306 151.692 92.9078 151.692 92.9078Z"
          fill="#35BE70"
        />
        <path
          d="M146.141 69.3829L166.957 57.6963C167.462 57.404 167.399 56.8941 166.815 56.5567L161.127 52.8975C160.543 52.5608 159.66 52.5238 159.155 52.8161L138.339 64.5028C137.833 64.7943 137.896 65.3042 138.48 65.6416L144.167 69.3008C144.751 69.6382 145.635 69.6752 146.141 69.3829Z"
          fill="url(#paint13_linear_2364_419)"
        />
        <path
          d="M155.876 139.283V73.7895L160.372 71.3917L171.689 64.6126C172.194 64.3211 173.078 64.3573 173.662 64.6947L175.883 65.8251L185.126 65.8312L185.124 131.639H185.119C185.11 131.817 185.005 131.985 184.785 132.112L164.268 143.791C163.763 144.083 162.879 144.046 162.295 143.709L156.354 139.894C156.05 139.719 155.891 139.497 155.876 139.283Z"
          fill="url(#paint14_linear_2364_419)"
        />
        <path
          d="M164.27 96.7327L162.471 143.791C163.215 144.058 163.608 144.051 164.27 143.791L164.27 96.7327Z"
          fill="url(#paint15_linear_2364_419)"
        />
        <path
          d="M179.55 97.3647L176.43 99.1476C175.984 99.4447 176.132 99.7418 176.132 99.7418L176.727 100.336L177.618 99.8161C177.767 99.7418 177.618 100.188 177.618 100.188L176.727 102.787C176.727 102.787 174.572 99.6675 174.424 99.3704C174.201 99.0733 174.498 98.9247 174.498 98.9247L181.258 94.9876C181.555 94.8391 181.332 95.3591 181.332 95.3591L175.538 111.256L174.944 110.662V110.142L179.55 97.3647Z"
          fill="#35BE70"
        />
        <path
          d="M174.795 105.09L173.087 102.862C173.087 102.862 172.938 102.565 173.161 102.416L174.275 101.748L176.133 104.422L174.275 109.325L173.755 108.656V108.21L174.795 105.387V105.09Z"
          fill="#35BE70"
        />
        <path
          d="M169.521 101.822L173.012 99.8162L173.235 100.113L173.458 100.41C173.681 100.782 173.384 100.93 173.384 100.93L171.452 102.045C171.081 102.268 171.304 102.565 171.304 102.565L173.458 105.685L173.532 106.205L173.012 107.542C173.012 107.542 169.67 102.639 169.372 102.342C169.075 102.045 169.521 101.822 169.521 101.822Z"
          fill="#35BE70"
        />
        <path
          d="M163.969 78.297L184.785 66.6103C185.291 66.3181 185.227 65.8082 184.643 65.4708L178.956 61.8116C178.372 61.4749 177.489 61.4379 176.983 61.7302L156.167 73.4168C155.661 73.7084 155.725 74.2183 156.309 74.5557L161.996 78.2148C162.58 78.5523 163.463 78.5892 163.969 78.297Z"
          fill="url(#paint16_linear_2364_419)"
        />
        {/* <rect x="170" y="60" width="80" height="80" rx="40" fill="#35BE70"/> */}
        {/* <path d="M198.729 91.0938L202.475 98.0391L206.221 91.0938H210.91L205.127 100.965L211.061 111H206.33L202.475 103.918L198.619 111H193.861L199.809 100.965L194.012 91.0938H198.729ZM216.42 101.936L213.275 101.184L214.41 91.0938H225.594V94.2793H217.65L217.158 98.6953C217.423 98.5404 217.824 98.3763 218.361 98.2031C218.899 98.0208 219.501 97.9297 220.166 97.9297C221.132 97.9297 221.989 98.0801 222.736 98.3809C223.484 98.6816 224.117 99.1191 224.637 99.6934C225.165 100.268 225.566 100.969 225.84 101.799C226.113 102.628 226.25 103.567 226.25 104.615C226.25 105.499 226.113 106.342 225.84 107.145C225.566 107.938 225.152 108.648 224.596 109.277C224.04 109.897 223.342 110.385 222.504 110.74C221.665 111.096 220.672 111.273 219.523 111.273C218.667 111.273 217.837 111.146 217.035 110.891C216.242 110.635 215.527 110.257 214.889 109.756C214.26 109.255 213.754 108.648 213.371 107.938C212.997 107.217 212.801 106.397 212.783 105.477H216.693C216.748 106.042 216.894 106.529 217.131 106.939C217.377 107.34 217.701 107.65 218.102 107.869C218.503 108.088 218.972 108.197 219.51 108.197C220.011 108.197 220.439 108.102 220.795 107.91C221.15 107.719 221.438 107.454 221.656 107.117C221.875 106.771 222.035 106.37 222.135 105.914C222.244 105.449 222.299 104.948 222.299 104.41C222.299 103.872 222.235 103.385 222.107 102.947C221.98 102.51 221.784 102.132 221.52 101.812C221.255 101.493 220.918 101.247 220.508 101.074C220.107 100.901 219.637 100.814 219.1 100.814C218.37 100.814 217.805 100.928 217.404 101.156C217.012 101.384 216.684 101.644 216.42 101.936Z" fill="white"/> */}
        <defs>
          <linearGradient
            id="paint0_linear_2364_419"
            x1="141.997"
            y1="119.172"
            x2="201.516"
            y2="166.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2364_419"
            x1="130.749"
            y1="133.732"
            x2="213.537"
            y2="107.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2364_419"
            x1="66.7917"
            y1="77.1903"
            x2="114.823"
            y2="115.706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2364_419"
            x1="91.4228"
            y1="76.5792"
            x2="96.2417"
            y2="76.1791"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2364_419"
            x1="66.7076"
            y1="34.7233"
            x2="71.9079"
            y2="54.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2364_419"
            x1="85.4021"
            y1="86.495"
            x2="133.433"
            y2="125.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2364_419"
            x1="110.033"
            y1="85.8839"
            x2="114.852"
            y2="85.4838"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2364_419"
            x1="85.318"
            y1="44.028"
            x2="90.5183"
            y2="63.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2364_419"
            x1="103.23"
            y1="95.4093"
            x2="151.261"
            y2="133.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2364_419"
            x1="127.861"
            y1="94.7982"
            x2="132.68"
            y2="94.3981"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2364_419"
            x1="103.146"
            y1="52.9423"
            x2="108.346"
            y2="72.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2364_419"
            x1="118.829"
            y1="105.809"
            x2="166.86"
            y2="144.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2364_419"
            x1="143.461"
            y1="105.198"
            x2="148.28"
            y2="104.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2364_419"
            x1="118.745"
            y1="63.3422"
            x2="123.946"
            y2="82.9395"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2364_419"
            x1="136.657"
            y1="114.723"
            x2="184.688"
            y2="153.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2364_419"
            x1="161.289"
            y1="114.112"
            x2="166.108"
            y2="113.712"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2364_419"
            x1="136.574"
            y1="72.2562"
            x2="141.774"
            y2="91.8536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    ),
    dongleKitModems2: (
      <svg
        width="270"
        height="200"
        viewBox="0 0 270 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M192.939 170.147C193.336 170.147 193.716 170.067 194 169.904L195.257 169.178L188.809 165.454L175.703 157.888L173.312 159.269L191.555 169.802C191.951 170.03 192.458 170.147 192.939 170.147ZM195.681 168.932L221.895 153.798L215.447 150.076L209.742 146.781L194 155.871C193.716 156.034 193.336 156.115 192.939 156.115C192.458 156.115 191.951 155.998 191.555 155.769L185.464 152.252L176.128 157.642L189.233 165.209L195.681 168.932ZM172.887 159.023L175.277 157.643L112.171 121.224L106.353 117.864L105.096 118.59C104.469 118.952 104.548 119.584 105.272 120.002L172.887 159.023ZM175.703 157.397L185.04 152.008L116.114 112.229L106.777 117.619L112.595 120.979L175.703 157.397ZM222.32 153.553L230.635 148.752C231.262 148.39 231.183 147.759 230.46 147.34L219.617 141.08L210.166 146.536L215.871 149.83L222.32 153.553Z"
          fill="#B0C1B8"
        />
        <path
          d="M192.939 156.115C193.337 156.115 193.716 156.034 194.001 155.871L209.742 146.782L210.166 146.537L219.617 141.08L227.03 136.801L227.829 136.34L230.635 134.719C230.908 134.562 231.039 134.352 231.05 134.133H231.056L231.058 128.33V127.841L231.058 127.052C231.058 127.064 231.057 127.076 231.056 127.088V127.131L231.05 127.134C231.017 127.327 230.882 127.507 230.641 127.648L230.635 127.651L194.001 148.803C193.995 148.806 193.989 148.809 193.983 148.813C193.979 148.815 193.975 148.817 193.971 148.82C193.692 148.971 193.326 149.047 192.944 149.047H192.939H192.935C192.465 149.047 191.968 148.933 191.577 148.714C191.57 148.709 191.847 148.656 191.84 148.652L97.5928 94.5871C97.5759 94.5778 97.5589 94.5676 97.5428 94.5574C97.5403 94.5566 97.5369 94.554 97.5369 94.554L97.5335 94.5515L97.5318 94.5506C97.2366 94.3657 97.0611 94.1435 97.0102 93.923L97 93.9179V100.898C97.0187 101.163 97.2163 101.438 97.5928 101.655L157.904 136.34L158.703 136.802L158.828 136.874L166.115 141.081L185.04 152.008L185.464 152.252L191.555 155.769C191.952 155.998 192.458 156.115 192.939 156.115Z"
          fill="url(#paint0_linear_2364_551)"
        />
        <path
          d="M192.939 149.047H192.944C193.326 149.046 193.692 148.971 193.971 148.819C193.975 148.817 193.979 148.815 193.983 148.813C193.989 148.809 193.995 148.806 194.001 148.802L230.635 127.651L230.641 127.648C230.881 127.508 231.013 127.327 231.047 127.136L231.05 127.134C231.053 127.119 231.055 127.103 231.056 127.088V126.988C231.033 126.726 230.832 126.455 230.46 126.24L136.522 72.141C136.126 71.9129 135.62 71.7958 135.14 71.7958C134.752 71.7958 134.382 71.8722 134.101 72.0265C134.093 72.0316 134.085 72.0359 134.078 72.0401L97.4426 93.1912C97.1585 93.3549 97.0194 93.5745 97.0194 93.8044C97.0194 93.8315 97.0211 93.8586 97.0253 93.8849C97.0278 93.9027 97.0312 93.9206 97.0355 93.9384L97.0431 93.9435C97.0957 94.1623 97.2645 94.3828 97.5571 94.566L97.5588 94.5668L97.5621 94.5694C97.5621 94.5694 97.5656 94.5719 97.5681 94.5728C97.5842 94.5829 97.6012 94.5931 97.6181 94.6025L191.556 148.701C191.563 148.705 191.57 148.709 191.577 148.713C191.969 148.933 192.465 149.047 192.935 149.047H192.939ZM135.147 74.3012C135.573 74.3012 136.022 74.4046 136.374 74.6074L226.19 126.326C226.831 126.696 226.9 127.256 226.345 127.577L193.872 146.326C193.62 146.471 193.283 146.542 192.93 146.542C192.505 146.542 192.055 146.439 191.705 146.236L101.888 94.5168C101.247 94.1462 101.178 93.5864 101.733 93.2658L134.206 74.5174C134.458 74.3716 134.794 74.3012 135.147 74.3012Z"
          fill="url(#paint1_linear_2364_551)"
        />
        <path
          d="M192.93 146.542C193.283 146.542 193.62 146.471 193.871 146.326L226.345 127.577C226.9 127.256 226.831 126.696 226.189 126.326L136.18 74.7605C135.829 74.5578 135.379 74.4543 134.954 74.4543C134.601 74.4543 134.264 74.5247 134.012 74.6706L101.54 93.419C100.984 93.7396 101.054 94.2993 101.695 94.67L191.363 146.513C191.713 146.715 192.504 146.542 192.93 146.542ZM134.959 76.042C135.351 76.042 135.763 76.1378 136.085 76.3236L223.481 126.381C224.07 126.721 224.134 127.235 223.624 127.53L193.79 144.755C193.558 144.888 193.25 144.954 192.925 144.954C192.534 144.954 192.121 144.859 191.799 144.672L104.403 94.6157C103.814 94.2747 103.75 93.7608 104.26 93.4656L134.095 76.2413C134.325 76.1073 134.635 76.042 134.959 76.042Z"
          fill="#808E88"
        />
        <path
          d="M192.925 144.954C193.25 144.954 193.559 144.889 193.79 144.755L223.624 127.53C224.134 127.235 224.07 126.721 223.481 126.381L135.857 76.4484C135.535 76.2627 135.123 76.1669 134.731 76.1669C134.407 76.1669 134.097 76.2322 133.867 76.3662L104.032 93.5905C103.522 93.8856 103.586 94.3996 104.175 94.7405L191.799 144.672C192.121 144.859 192.534 144.954 192.925 144.954Z"
          fill="#AEC7B9"
        />
        <path
          d="M115.01 95.7499V30.2566L119.506 27.8587L130.824 21.0797C131.329 20.7881 132.212 20.8244 132.796 21.1618L135.017 22.2921L144.26 22.2982L144.259 88.1057H144.254C144.245 88.2836 144.139 88.452 143.919 88.5793L123.403 100.258C122.897 100.55 122.014 100.513 121.43 100.176L115.489 96.3611C115.185 96.1859 115.025 95.9641 115.01 95.7499Z"
          fill="url(#paint2_linear_2364_551)"
        />
        <path
          d="M123.403 53.1997L121.604 100.258C122.348 100.525 122.741 100.518 123.403 100.258L123.403 53.1997Z"
          fill="url(#paint3_linear_2364_551)"
        />
        <path
          d="M138.683 53.8318L135.563 55.6146C135.117 55.9117 135.266 56.2089 135.266 56.2089L135.86 56.8031L136.751 56.2832C136.9 56.2089 136.751 56.6546 136.751 56.6546L135.86 59.2545C135.86 59.2545 133.706 56.1346 133.557 55.8375C133.334 55.5403 133.631 55.3917 133.631 55.3917L140.391 51.4547C140.688 51.3061 140.465 51.8261 140.465 51.8261L134.671 67.7229L134.077 67.1287V66.6087L138.683 53.8318Z"
          fill="#35BE70"
        />
        <path
          d="M133.929 61.5574L132.22 59.3289C132.22 59.3289 132.071 59.0317 132.294 58.8832L133.409 58.2146L135.266 60.8888L133.409 65.7916L132.889 65.123V64.6773L133.929 61.8545V61.5574Z"
          fill="#35BE70"
        />
        <path
          d="M128.654 58.2889L132.145 56.2832L132.368 56.5803L132.591 56.8775C132.814 57.2489 132.517 57.3975 132.517 57.3975L130.586 58.5117C130.214 58.7346 130.437 59.0317 130.437 59.0317L132.591 62.1517L132.665 62.6717L132.145 64.0088C132.145 64.0088 128.803 59.106 128.506 58.8089C128.208 58.5117 128.654 58.2889 128.654 58.2889Z"
          fill="#35BE70"
        />
        <path
          d="M123.103 34.764L143.919 23.0774C144.425 22.7851 144.361 22.2752 143.777 21.9378L138.09 18.2786C137.506 17.9419 136.622 17.9049 136.117 18.1972L115.301 29.8839C114.795 30.1754 114.859 30.6853 115.443 31.0227L121.13 34.6819C121.714 35.0193 122.597 35.0563 123.103 34.764Z"
          fill="url(#paint4_linear_2364_551)"
        />
        <path
          d="M133.621 105.055V39.5613L138.117 37.1634L149.434 30.3844C149.939 30.0928 150.823 30.1291 151.407 30.4665L153.627 31.5968L162.871 31.6029L162.869 97.4104H162.864C162.855 97.5883 162.749 97.7567 162.529 97.884L142.013 109.562C141.507 109.855 140.624 109.818 140.04 109.481L134.099 105.666C133.795 105.491 133.636 105.269 133.621 105.055Z"
          fill="url(#paint5_linear_2364_551)"
        />
        <path
          d="M142.013 62.5044L140.215 109.563C140.959 109.829 141.351 109.823 142.013 109.563L142.013 62.5044Z"
          fill="url(#paint6_linear_2364_551)"
        />
        <path
          d="M157.293 63.1365L154.173 64.9193C153.727 65.2164 153.876 65.5136 153.876 65.5136L154.47 66.1078L155.362 65.5878C155.51 65.5136 155.362 65.9593 155.362 65.9593L154.47 68.5592C154.47 68.5592 152.316 65.4393 152.167 65.1421C151.944 64.845 152.242 64.6964 152.242 64.6964L159.001 60.7594C159.299 60.6108 159.076 61.1308 159.076 61.1308L153.282 77.0276L152.687 76.4334V75.9134L157.293 63.1365Z"
          fill="#35BE70"
        />
        <path
          d="M152.539 70.8621L150.83 68.6336C150.83 68.6336 150.682 68.3364 150.905 68.1878L152.019 67.5193L153.876 70.1935L152.019 75.0963L151.499 74.4277V73.982L152.539 71.1592V70.8621Z"
          fill="#35BE70"
        />
        <path
          d="M147.264 67.5936L150.756 65.5879L150.978 65.885L151.201 66.1822C151.424 66.5536 151.127 66.7022 151.127 66.7022L149.196 67.8164C148.824 68.0393 149.047 68.3364 149.047 68.3364L151.201 71.4564L151.276 71.9763L150.756 73.3135C150.756 73.3135 147.413 68.4107 147.116 68.1136C146.819 67.8164 147.264 67.5936 147.264 67.5936Z"
          fill="#35BE70"
        />
        <path
          d="M141.713 44.0687L162.529 32.382C163.035 32.0898 162.971 31.5799 162.388 31.2425L156.7 27.5833C156.116 27.2466 155.233 27.2096 154.728 27.5019L133.911 39.1885C133.406 39.4801 133.469 39.99 134.053 40.3274L139.74 43.9866C140.324 44.324 141.208 44.3609 141.713 44.0687Z"
          fill="url(#paint7_linear_2364_551)"
        />
        <path
          d="M151.449 113.969V48.4756L155.945 46.0777L167.262 39.2987C167.767 39.0071 168.651 39.0434 169.235 39.3808L171.455 40.5111L180.698 40.5172L180.697 106.325H180.692C180.683 106.503 180.577 106.671 180.357 106.798L159.841 118.477C159.335 118.769 158.452 118.732 157.868 118.395L151.927 114.58C151.623 114.405 151.464 114.183 151.449 113.969Z"
          fill="url(#paint8_linear_2364_551)"
        />
        <path
          d="M159.841 71.4187L158.042 118.477C158.786 118.744 159.179 118.737 159.841 118.477L159.841 71.4187Z"
          fill="url(#paint9_linear_2364_551)"
        />
        <path
          d="M175.121 72.0508L172.001 73.8336C171.555 74.1307 171.704 74.4279 171.704 74.4279L172.298 75.0221L173.189 74.5022C173.338 74.4279 173.189 74.8736 173.189 74.8736L172.298 77.4735C172.298 77.4735 170.144 74.3536 169.995 74.0564C169.772 73.7593 170.069 73.6107 170.069 73.6107L176.829 69.6737C177.126 69.5251 176.903 70.0451 176.903 70.0451L171.109 85.9419L170.515 85.3477V84.8277L175.121 72.0508Z"
          fill="#35BE70"
        />
        <path
          d="M170.366 79.7764L168.658 77.5479C168.658 77.5479 168.509 77.2507 168.732 77.1022L169.847 76.4336L171.704 79.1078L169.847 84.0106L169.327 83.342V82.8963L170.366 80.0735V79.7764Z"
          fill="#35BE70"
        />
        <path
          d="M165.092 76.5079L168.583 74.5022L168.806 74.7993L169.029 75.0965C169.252 75.4679 168.955 75.6165 168.955 75.6165L167.024 76.7307C166.652 76.9536 166.875 77.2507 166.875 77.2507L169.029 80.3707L169.103 80.8907L168.583 82.2278C168.583 82.2278 165.241 77.325 164.944 77.0279C164.646 76.7307 165.092 76.5079 165.092 76.5079Z"
          fill="#35BE70"
        />
        <path
          d="M159.541 52.983L180.357 41.2964C180.862 41.0041 180.799 40.4942 180.215 40.1568L174.528 36.4976C173.944 36.1609 173.06 36.1239 172.555 36.4162L151.739 48.1029C151.233 48.3944 151.297 48.9043 151.881 49.2417L157.568 52.9009C158.152 53.2383 159.035 53.2753 159.541 52.983Z"
          fill="url(#paint10_linear_2364_551)"
        />
        <path
          d="M167.047 124.369V58.8755L171.543 56.4776L182.861 49.6986C183.366 49.407 184.25 49.4433 184.833 49.7807L187.054 50.911L196.297 50.9171L196.296 116.725H196.291C196.282 116.903 196.176 117.071 195.956 117.198L175.44 128.876C174.934 129.169 174.051 129.132 173.467 128.795L167.526 124.98C167.222 124.805 167.063 124.583 167.047 124.369Z"
          fill="url(#paint11_linear_2364_551)"
        />
        <path
          d="M175.441 81.8186L173.643 128.877C174.387 129.144 174.779 129.137 175.441 128.877L175.441 81.8186Z"
          fill="url(#paint12_linear_2364_551)"
        />
        <path
          d="M190.721 82.4507L187.601 84.2335C187.155 84.5306 187.304 84.8278 187.304 84.8278L187.898 85.422L188.79 84.9021C188.938 84.8278 188.79 85.2735 188.79 85.2735L187.898 87.8734C187.898 87.8734 185.744 84.7535 185.595 84.4563C185.372 84.1592 185.67 84.0106 185.67 84.0106L192.429 80.0736C192.727 79.925 192.504 80.445 192.504 80.445L186.71 96.3418L186.115 95.7476V95.2276L190.721 82.4507Z"
          fill="#35BE70"
        />
        <path
          d="M185.967 90.1763L184.258 87.9478C184.258 87.9478 184.11 87.6506 184.333 87.5021L185.447 86.8335L187.304 89.5077L185.447 94.4105L184.927 93.7419V93.2962L185.967 90.4734V90.1763Z"
          fill="#35BE70"
        />
        <path
          d="M180.692 86.9078L184.184 84.9021L184.406 85.1992L184.629 85.4964C184.852 85.8678 184.555 86.0164 184.555 86.0164L182.624 87.1306C182.252 87.3535 182.475 87.6506 182.475 87.6506L184.629 90.7706L184.704 91.2906L184.184 92.6277C184.184 92.6277 180.841 87.7249 180.544 87.4278C180.247 87.1306 180.692 86.9078 180.692 86.9078Z"
          fill="#35BE70"
        />
        <path
          d="M175.141 63.3829L195.957 51.6963C196.462 51.404 196.399 50.8941 195.815 50.5567L190.127 46.8975C189.543 46.5608 188.66 46.5238 188.155 46.8161L167.339 58.5028C166.833 58.7943 166.896 59.3042 167.48 59.6416L173.167 63.3008C173.751 63.6382 174.635 63.6752 175.141 63.3829Z"
          fill="url(#paint13_linear_2364_551)"
        />
        <path
          d="M184.876 133.283V67.7895L189.372 65.3917L200.689 58.6126C201.194 58.3211 202.078 58.3573 202.662 58.6947L204.883 59.8251L214.126 59.8312L214.124 125.639H214.119C214.11 125.817 214.005 125.985 213.785 126.112L193.268 137.791C192.763 138.083 191.879 138.046 191.295 137.709L185.354 133.894C185.05 133.719 184.891 133.497 184.876 133.283Z"
          fill="url(#paint14_linear_2364_551)"
        />
        <path
          d="M193.27 90.7327L191.471 137.791C192.215 138.058 192.608 138.051 193.27 137.791L193.27 90.7327Z"
          fill="url(#paint15_linear_2364_551)"
        />
        <path
          d="M208.55 91.3647L205.43 93.1476C204.984 93.4447 205.132 93.7418 205.132 93.7418L205.727 94.3361L206.618 93.8161C206.767 93.7418 206.618 94.1875 206.618 94.1875L205.727 96.7875C205.727 96.7875 203.572 93.6675 203.424 93.3704C203.201 93.0733 203.498 92.9247 203.498 92.9247L210.258 88.9876C210.555 88.8391 210.332 89.3591 210.332 89.3591L204.538 105.256L203.944 104.662V104.142L208.55 91.3647Z"
          fill="#35BE70"
        />
        <path
          d="M203.795 99.0904L202.087 96.8618C202.087 96.8618 201.938 96.5647 202.161 96.4161L203.275 95.7476L205.133 98.4218L203.275 103.325L202.755 102.656V102.21L203.795 99.3875V99.0904Z"
          fill="#35BE70"
        />
        <path
          d="M198.521 95.8218L202.012 93.8162L202.235 94.1133L202.458 94.4104C202.681 94.7819 202.384 94.9304 202.384 94.9304L200.452 96.0447C200.081 96.2675 200.304 96.5647 200.304 96.5647L202.458 99.6846L202.532 100.205L202.012 101.542C202.012 101.542 198.67 96.639 198.372 96.3418C198.075 96.0447 198.521 95.8218 198.521 95.8218Z"
          fill="#35BE70"
        />
        <path
          d="M192.969 72.297L213.785 60.6103C214.291 60.3181 214.227 59.8082 213.643 59.4708L207.956 55.8116C207.372 55.4749 206.489 55.4379 205.983 55.7302L185.167 67.4168C184.661 67.7084 184.725 68.2183 185.309 68.5557L190.996 72.2148C191.58 72.5523 192.463 72.5892 192.969 72.297Z"
          fill="url(#paint16_linear_2364_551)"
        />
        <path
          d="M133.939 181.147C134.336 181.147 134.716 181.067 135 180.904L136.257 180.178L129.809 176.454L116.703 168.888L114.312 170.269L132.555 180.802C132.951 181.03 133.458 181.147 133.939 181.147ZM136.681 179.932L162.895 164.798L156.447 161.076L150.742 157.781L135 166.871C134.716 167.034 134.336 167.115 133.939 167.115C133.458 167.115 132.951 166.998 132.555 166.769L126.464 163.252L117.128 168.642L130.233 176.209L136.681 179.932ZM113.887 170.023L116.277 168.643L53.1711 132.224L47.353 128.864L46.0961 129.59C45.4694 129.952 45.5483 130.584 46.2717 131.002L113.887 170.023ZM116.703 168.397L126.04 163.008L57.114 123.229L47.7771 128.619L53.5952 131.979L116.703 168.397ZM163.32 164.553L171.635 159.752C172.262 159.39 172.183 158.759 171.46 158.34L160.617 152.08L151.166 157.536L156.871 160.83L163.32 164.553Z"
          fill="#B0C1B8"
        />
        <path
          d="M133.939 167.115C134.337 167.115 134.716 167.034 135.001 166.871L150.742 157.782L151.166 157.537L160.617 152.08L168.03 147.801L168.829 147.34L171.635 145.719C171.908 145.562 172.039 145.352 172.05 145.133H172.056L172.058 139.33V138.841L172.058 138.052C172.058 138.064 172.057 138.076 172.056 138.088V138.131L172.05 138.134C172.017 138.327 171.882 138.507 171.641 138.648L171.635 138.651L135.001 159.803C134.995 159.806 134.989 159.809 134.983 159.813C134.979 159.815 134.975 159.817 134.971 159.82C134.692 159.971 134.326 160.047 133.944 160.047H133.939H133.935C133.465 160.047 132.968 159.933 132.577 159.714C132.57 159.709 132.847 159.656 132.84 159.652L38.5928 105.587C38.5759 105.578 38.5589 105.568 38.5428 105.557C38.5403 105.557 38.5369 105.554 38.5369 105.554L38.5335 105.551L38.5318 105.551C38.2366 105.366 38.0611 105.144 38.0102 104.923L38 104.918V111.898C38.0187 112.163 38.2163 112.438 38.5928 112.655L98.904 147.34L99.703 147.802L99.8276 147.874L107.115 152.081L126.04 163.008L126.464 163.252L132.555 166.769C132.952 166.998 133.458 167.115 133.939 167.115Z"
          fill="url(#paint17_linear_2364_551)"
        />
        <path
          d="M133.939 160.047H133.944C134.326 160.046 134.692 159.971 134.971 159.819C134.975 159.817 134.979 159.815 134.983 159.813C134.989 159.809 134.995 159.806 135.001 159.802L171.635 138.651L171.641 138.648C171.881 138.508 172.013 138.327 172.047 138.136L172.05 138.134C172.053 138.119 172.055 138.103 172.056 138.088V137.988C172.033 137.726 171.832 137.455 171.46 137.24L77.5219 83.141C77.1258 82.9129 76.6195 82.7958 76.1395 82.7958C75.7519 82.7958 75.3821 82.8722 75.1014 83.0265C75.0929 83.0316 75.0853 83.0359 75.0777 83.0401L38.4426 104.191C38.1585 104.355 38.0194 104.575 38.0194 104.804C38.0194 104.832 38.0211 104.859 38.0253 104.885C38.0278 104.903 38.0312 104.921 38.0355 104.938L38.0431 104.943C38.0957 105.162 38.2645 105.383 38.5571 105.566L38.5588 105.567L38.5621 105.569C38.5621 105.569 38.5656 105.572 38.5681 105.573C38.5842 105.583 38.6012 105.593 38.6181 105.602L132.556 159.701C132.563 159.705 132.57 159.709 132.577 159.713C132.969 159.933 133.465 160.047 133.935 160.047H133.939ZM76.1471 85.3012C76.5729 85.3012 77.0224 85.4046 77.3735 85.6074L167.19 137.326C167.831 137.696 167.9 138.256 167.345 138.577L134.872 157.326C134.62 157.471 134.283 157.542 133.93 157.542C133.505 157.542 133.055 157.439 132.705 157.236L42.8884 105.517C42.2472 105.146 42.1777 104.586 42.7332 104.266L75.2057 85.5174C75.4576 85.3716 75.7943 85.3012 76.1471 85.3012Z"
          fill="url(#paint18_linear_2364_551)"
        />
        <path
          d="M133.93 157.542C134.283 157.542 134.62 157.471 134.871 157.326L167.345 138.577C167.9 138.256 167.831 137.696 167.189 137.326L77.1801 85.7605C76.8289 85.5578 76.3794 85.4543 75.9537 85.4543C75.6009 85.4543 75.2642 85.5247 75.0123 85.6706L42.5397 104.419C41.9842 104.74 42.0538 105.299 42.6949 105.67L132.363 157.513C132.713 157.715 133.504 157.542 133.93 157.542ZM75.9588 87.042C76.3506 87.042 76.7628 87.1378 77.0851 87.3236L164.481 137.381C165.07 137.721 165.134 138.235 164.624 138.53L134.79 155.755C134.558 155.888 134.25 155.954 133.925 155.954C133.534 155.954 133.121 155.859 132.799 155.672L45.403 105.616C44.8135 105.275 44.7499 104.761 45.2596 104.466L75.0946 87.2413C75.3252 87.1073 75.6348 87.042 75.9588 87.042Z"
          fill="#808E88"
        />
        <path
          d="M133.925 155.954C134.25 155.954 134.559 155.889 134.79 155.755L164.624 138.53C165.134 138.235 165.07 137.721 164.481 137.381L76.8573 87.4484C76.535 87.2627 76.1228 87.1669 75.731 87.1669C75.407 87.1669 75.0975 87.2322 74.8668 87.3662L45.0319 104.59C44.5222 104.886 44.5858 105.4 45.1752 105.741L132.799 155.672C133.121 155.859 133.534 155.954 133.925 155.954Z"
          fill="#AEC7B9"
        />
        <path
          d="M56.0104 106.75V41.2566L60.5064 38.8587L71.8238 32.0797C72.3289 31.7881 73.2125 31.8244 73.7963 32.1618L76.0171 33.2921L85.2603 33.2982L85.2586 99.1057H85.2535C85.245 99.2836 85.1391 99.452 84.9191 99.5793L64.4029 111.258C63.8971 111.55 63.0136 111.513 62.4297 111.176L56.4888 107.361C56.1849 107.186 56.0254 106.964 56.0104 106.75Z"
          fill="url(#paint19_linear_2364_551)"
        />
        <path
          d="M64.4028 64.1997L62.6044 111.258C63.3482 111.525 63.7409 111.518 64.4028 111.258L64.4028 64.1997Z"
          fill="url(#paint20_linear_2364_551)"
        />
        <path
          d="M79.6826 64.8318L76.5627 66.6146C76.117 66.9117 76.2655 67.2089 76.2655 67.2089L76.8598 67.8031L77.7512 67.2832C77.8998 67.2089 77.7512 67.6546 77.7512 67.6546L76.8598 70.2545C76.8598 70.2545 74.7056 67.1346 74.557 66.8375C74.3341 66.5403 74.6313 66.3917 74.6313 66.3917L81.3911 62.4547C81.6883 62.3061 81.4654 62.8261 81.4654 62.8261L75.6712 78.7229L75.077 78.1287V77.6087L79.6826 64.8318Z"
          fill="#35BE70"
        />
        <path
          d="M74.9285 72.5574L73.22 70.3289C73.22 70.3289 73.0714 70.0317 73.2943 69.8832L74.4085 69.2146L76.2656 71.8888L74.4085 76.7916L73.8885 76.123V75.6773L74.9285 72.8545V72.5574Z"
          fill="#35BE70"
        />
        <path
          d="M69.6541 69.2889L73.1455 67.2832L73.3683 67.5803L73.5912 67.8775C73.814 68.2489 73.5169 68.3975 73.5169 68.3975L71.5855 69.5117C71.2141 69.7346 71.4369 70.0317 71.4369 70.0317L73.5912 73.1517L73.6655 73.6717L73.1455 75.0088C73.1455 75.0088 69.8027 70.106 69.5056 69.8089C69.2084 69.5117 69.6541 69.2889 69.6541 69.2889Z"
          fill="#35BE70"
        />
        <path
          d="M64.103 45.764L84.919 34.0774C85.4245 33.7851 85.3611 33.2752 84.7772 32.9378L79.0897 29.2786C78.5059 28.9419 77.6223 28.9049 77.1172 29.1972L56.301 40.8839C55.7952 41.1754 55.8589 41.6853 56.4427 42.0227L62.1298 45.6819C62.7136 46.0193 63.5972 46.0563 64.103 45.764Z"
          fill="url(#paint21_linear_2364_551)"
        />
        <path
          d="M74.6207 116.055V50.5613L79.1167 48.1634L90.4341 41.3844C90.9392 41.0928 91.8228 41.1291 92.4066 41.4665L94.6275 42.5968L103.871 42.6029L103.869 108.41H103.864C103.855 108.588 103.749 108.757 103.529 108.884L83.0133 120.562C82.5075 120.855 81.6239 120.818 81.0401 120.481L75.0991 116.666C74.7953 116.491 74.6358 116.269 74.6207 116.055Z"
          fill="url(#paint22_linear_2364_551)"
        />
        <path
          d="M83.0132 73.5044L81.2148 120.563C81.9586 120.829 82.3513 120.823 83.0132 120.563L83.0132 73.5044Z"
          fill="url(#paint23_linear_2364_551)"
        />
        <path
          d="M98.293 74.1365L95.173 75.9193C94.7273 76.2164 94.8759 76.5136 94.8759 76.5136L95.4701 77.1078L96.3616 76.5878C96.5101 76.5136 96.3616 76.9593 96.3616 76.9593L95.4701 79.5592C95.4701 79.5592 93.3159 76.4393 93.1673 76.1421C92.9445 75.845 93.2416 75.6964 93.2416 75.6964L100.001 71.7594C100.299 71.6108 100.076 72.1308 100.076 72.1308L94.2816 88.0276L93.6873 87.4334V86.9134L98.293 74.1365Z"
          fill="#35BE70"
        />
        <path
          d="M93.5389 81.8621L91.8303 79.6336C91.8303 79.6336 91.6817 79.3364 91.9046 79.1878L93.0189 78.5193L94.876 81.1935L93.0189 86.0963L92.4989 85.4277V84.982L93.5389 82.1592V81.8621Z"
          fill="#35BE70"
        />
        <path
          d="M88.2642 78.5936L91.7556 76.5879L91.9784 76.885L92.2013 77.1822C92.4242 77.5536 92.127 77.7022 92.127 77.7022L90.1956 78.8164C89.8242 79.0393 90.0471 79.3364 90.0471 79.3364L92.2013 82.4564L92.2756 82.9763L91.7556 84.3135C91.7556 84.3135 88.4128 79.4107 88.1157 79.1136C87.8185 78.8164 88.2642 78.5936 88.2642 78.5936Z"
          fill="#35BE70"
        />
        <path
          d="M82.7134 55.0687L103.529 43.382C104.035 43.0898 103.971 42.5799 103.388 42.2425L97.7001 38.5833C97.1163 38.2466 96.2327 38.2096 95.7276 38.5019L74.9114 50.1885C74.4056 50.4801 74.4692 50.99 75.0531 51.3274L80.7402 54.9866C81.324 55.324 82.2076 55.3609 82.7134 55.0687Z"
          fill="url(#paint24_linear_2364_551)"
        />
        <path
          d="M92.4486 124.969V59.4756L96.9446 57.0777L108.262 50.2987C108.767 50.0071 109.651 50.0434 110.235 50.3808L112.455 51.5111L121.698 51.5172L121.697 117.325H121.692C121.683 117.503 121.577 117.671 121.357 117.798L100.841 129.477C100.335 129.769 99.4518 129.732 98.868 129.395L92.927 125.58C92.6231 125.405 92.4637 125.183 92.4486 124.969Z"
          fill="url(#paint25_linear_2364_551)"
        />
        <path
          d="M100.841 82.4187L99.0424 129.477C99.7862 129.744 100.179 129.737 100.841 129.477L100.841 82.4187Z"
          fill="url(#paint26_linear_2364_551)"
        />
        <path
          d="M116.121 83.0508L113.001 84.8336C112.555 85.1307 112.704 85.4279 112.704 85.4279L113.298 86.0221L114.189 85.5022C114.338 85.4279 114.189 85.8736 114.189 85.8736L113.298 88.4735C113.298 88.4735 111.144 85.3536 110.995 85.0564C110.772 84.7593 111.069 84.6107 111.069 84.6107L117.829 80.6737C118.126 80.5251 117.903 81.0451 117.903 81.0451L112.109 96.9419L111.515 96.3477V95.8277L116.121 83.0508Z"
          fill="#35BE70"
        />
        <path
          d="M111.366 90.7764L109.658 88.5479C109.658 88.5479 109.509 88.2507 109.732 88.1022L110.847 87.4336L112.704 90.1078L110.847 95.0106L110.327 94.342V93.8963L111.366 91.0735V90.7764Z"
          fill="#35BE70"
        />
        <path
          d="M106.092 87.5079L109.583 85.5022L109.806 85.7993L110.029 86.0965C110.252 86.4679 109.955 86.6165 109.955 86.6165L108.024 87.7307C107.652 87.9536 107.875 88.2507 107.875 88.2507L110.029 91.3707L110.103 91.8907L109.583 93.2278C109.583 93.2278 106.241 88.325 105.944 88.0279C105.646 87.7307 106.092 87.5079 106.092 87.5079Z"
          fill="#35BE70"
        />
        <path
          d="M100.541 63.983L121.357 52.2964C121.862 52.0041 121.799 51.4942 121.215 51.1568L115.528 47.4976C114.944 47.1609 114.06 47.1239 113.555 47.4162L92.739 59.1029C92.2332 59.3944 92.2969 59.9043 92.8807 60.2417L98.5678 63.9009C99.1516 64.2383 100.035 64.2753 100.541 63.983Z"
          fill="url(#paint27_linear_2364_551)"
        />
        <path
          d="M108.047 135.369V69.8755L112.543 67.4776L123.861 60.6986C124.366 60.407 125.25 60.4433 125.833 60.7807L128.054 61.911L137.297 61.9171L137.296 127.725H137.291C137.282 127.903 137.176 128.071 136.956 128.198L116.44 139.876C115.934 140.169 115.051 140.132 114.467 139.795L108.526 135.98C108.222 135.805 108.063 135.583 108.047 135.369Z"
          fill="url(#paint28_linear_2364_551)"
        />
        <path
          d="M116.441 92.8186L114.643 139.877C115.387 140.144 115.779 140.137 116.441 139.877L116.441 92.8186Z"
          fill="url(#paint29_linear_2364_551)"
        />
        <path
          d="M131.721 93.4507L128.601 95.2335C128.155 95.5306 128.304 95.8278 128.304 95.8278L128.898 96.422L129.79 95.9021C129.938 95.8278 129.79 96.2735 129.79 96.2735L128.898 98.8734C128.898 98.8734 126.744 95.7535 126.595 95.4563C126.372 95.1592 126.67 95.0106 126.67 95.0106L133.429 91.0736C133.727 90.925 133.504 91.445 133.504 91.445L127.71 107.342L127.115 106.748V106.228L131.721 93.4507Z"
          fill="#35BE70"
        />
        <path
          d="M126.967 101.176L125.258 98.9478C125.258 98.9478 125.11 98.6506 125.333 98.5021L126.447 97.8335L128.304 100.508L126.447 105.411L125.927 104.742V104.296L126.967 101.473V101.176Z"
          fill="#35BE70"
        />
        <path
          d="M121.692 97.9078L125.184 95.9021L125.406 96.1992L125.629 96.4964C125.852 96.8678 125.555 97.0164 125.555 97.0164L123.624 98.1306C123.252 98.3535 123.475 98.6506 123.475 98.6506L125.629 101.771L125.704 102.291L125.184 103.628C125.184 103.628 121.841 98.7249 121.544 98.4278C121.247 98.1306 121.692 97.9078 121.692 97.9078Z"
          fill="#35BE70"
        />
        <path
          d="M116.141 74.3829L136.957 62.6963C137.462 62.404 137.399 61.8941 136.815 61.5567L131.127 57.8975C130.543 57.5608 129.66 57.5238 129.155 57.8161L108.339 69.5028C107.833 69.7943 107.896 70.3042 108.48 70.6416L114.167 74.3008C114.751 74.6382 115.635 74.6752 116.141 74.3829Z"
          fill="url(#paint30_linear_2364_551)"
        />
        <path
          d="M125.876 144.283V78.7895L130.372 76.3917L141.689 69.6126C142.194 69.3211 143.078 69.3573 143.662 69.6947L145.883 70.8251L155.126 70.8312L155.124 136.639H155.119C155.11 136.817 155.005 136.985 154.785 137.112L134.268 148.791C133.763 149.083 132.879 149.046 132.295 148.709L126.354 144.894C126.05 144.719 125.891 144.497 125.876 144.283Z"
          fill="url(#paint31_linear_2364_551)"
        />
        <path
          d="M134.27 101.733L132.471 148.791C133.215 149.058 133.608 149.051 134.27 148.791L134.27 101.733Z"
          fill="url(#paint32_linear_2364_551)"
        />
        <path
          d="M149.55 102.365L146.43 104.148C145.984 104.445 146.132 104.742 146.132 104.742L146.727 105.336L147.618 104.816C147.767 104.742 147.618 105.188 147.618 105.188L146.727 107.787C146.727 107.787 144.572 104.668 144.424 104.37C144.201 104.073 144.498 103.925 144.498 103.925L151.258 99.9876C151.555 99.8391 151.332 100.359 151.332 100.359L145.538 116.256L144.944 115.662V115.142L149.55 102.365Z"
          fill="#35BE70"
        />
        <path
          d="M144.795 110.09L143.087 107.862C143.087 107.862 142.938 107.565 143.161 107.416L144.275 106.748L146.133 109.422L144.275 114.325L143.755 113.656V113.21L144.795 110.387V110.09Z"
          fill="#35BE70"
        />
        <path
          d="M139.521 106.822L143.012 104.816L143.235 105.113L143.458 105.41C143.681 105.782 143.384 105.93 143.384 105.93L141.452 107.045C141.081 107.268 141.304 107.565 141.304 107.565L143.458 110.685L143.532 111.205L143.012 112.542C143.012 112.542 139.67 107.639 139.372 107.342C139.075 107.045 139.521 106.822 139.521 106.822Z"
          fill="#35BE70"
        />
        <path
          d="M133.969 83.297L154.785 71.6103C155.291 71.3181 155.227 70.8082 154.643 70.4708L148.956 66.8116C148.372 66.4749 147.489 66.4379 146.983 66.7302L126.167 78.4168C125.661 78.7084 125.725 79.2183 126.309 79.5557L131.996 83.2148C132.58 83.5523 133.463 83.5892 133.969 83.297Z"
          fill="url(#paint33_linear_2364_551)"
        />
        {/* <rect x="170" y="60" width="80" height="80" rx="40" fill="#35BE70"/> */}
        {/* <path d="M190.689 91.0938L194.436 98.0391L198.182 91.0938H202.871L197.088 100.965L203.021 111H198.291L194.436 103.918L190.58 111H185.822L191.77 100.965L185.973 91.0938H190.689ZM218.293 107.924V111H204.676V108.375L211.115 101.471C211.762 100.751 212.273 100.117 212.646 99.5703C213.02 99.0143 213.289 98.5176 213.453 98.0801C213.626 97.6335 213.713 97.2096 213.713 96.8086C213.713 96.207 213.613 95.6921 213.412 95.2637C213.212 94.8262 212.915 94.4889 212.523 94.252C212.141 94.015 211.667 93.8965 211.102 93.8965C210.5 93.8965 209.98 94.0423 209.543 94.334C209.115 94.6257 208.786 95.0312 208.559 95.5508C208.34 96.0703 208.23 96.6582 208.23 97.3145H204.279C204.279 96.1296 204.562 95.0449 205.127 94.0605C205.692 93.0671 206.49 92.2786 207.52 91.6953C208.549 91.1029 209.771 90.8066 211.184 90.8066C212.578 90.8066 213.754 91.0345 214.711 91.4902C215.677 91.9368 216.406 92.584 216.898 93.4316C217.4 94.2702 217.65 95.2728 217.65 96.4395C217.65 97.0957 217.546 97.7383 217.336 98.3672C217.126 98.987 216.826 99.6068 216.434 100.227C216.051 100.837 215.586 101.457 215.039 102.086C214.492 102.715 213.886 103.367 213.221 104.041L209.762 107.924H218.293ZM234.152 99.2969V102.742C234.152 104.237 233.993 105.527 233.674 106.611C233.355 107.687 232.895 108.571 232.293 109.264C231.701 109.947 230.994 110.453 230.174 110.781C229.354 111.109 228.442 111.273 227.439 111.273C226.637 111.273 225.89 111.173 225.197 110.973C224.505 110.763 223.88 110.439 223.324 110.002C222.777 109.564 222.303 109.013 221.902 108.348C221.51 107.673 221.21 106.871 221 105.941C220.79 105.012 220.686 103.945 220.686 102.742V99.2969C220.686 97.8021 220.845 96.5215 221.164 95.4551C221.492 94.3796 221.952 93.5 222.545 92.8164C223.146 92.1328 223.857 91.6315 224.678 91.3125C225.498 90.9844 226.41 90.8203 227.412 90.8203C228.214 90.8203 228.957 90.9251 229.641 91.1348C230.333 91.3353 230.958 91.6497 231.514 92.0781C232.07 92.5065 232.544 93.0579 232.936 93.7324C233.327 94.3978 233.628 95.1953 233.838 96.125C234.048 97.0456 234.152 98.1029 234.152 99.2969ZM230.201 103.262V98.7637C230.201 98.0436 230.16 97.4147 230.078 96.877C230.005 96.3392 229.891 95.8835 229.736 95.5098C229.581 95.127 229.39 94.8171 229.162 94.5801C228.934 94.3431 228.674 94.1699 228.383 94.0605C228.091 93.9512 227.768 93.8965 227.412 93.8965C226.965 93.8965 226.569 93.9831 226.223 94.1562C225.885 94.3294 225.598 94.6074 225.361 94.9902C225.124 95.3639 224.942 95.8652 224.814 96.4941C224.696 97.1139 224.637 97.8704 224.637 98.7637V103.262C224.637 103.982 224.673 104.615 224.746 105.162C224.828 105.709 224.947 106.178 225.102 106.57C225.266 106.953 225.457 107.268 225.676 107.514C225.904 107.751 226.163 107.924 226.455 108.033C226.756 108.143 227.084 108.197 227.439 108.197C227.877 108.197 228.264 108.111 228.602 107.938C228.948 107.755 229.24 107.473 229.477 107.09C229.723 106.698 229.905 106.188 230.023 105.559C230.142 104.93 230.201 104.164 230.201 103.262Z" fill="white"/> */}
        <defs>
          <linearGradient
            id="paint0_linear_2364_551"
            x1="170.997"
            y1="113.172"
            x2="230.516"
            y2="160.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2364_551"
            x1="159.749"
            y1="127.732"
            x2="242.537"
            y2="101.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2364_551"
            x1="95.7917"
            y1="71.1903"
            x2="143.823"
            y2="109.706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2364_551"
            x1="120.423"
            y1="70.5792"
            x2="125.242"
            y2="70.1791"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2364_551"
            x1="95.7076"
            y1="28.7233"
            x2="100.908"
            y2="48.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2364_551"
            x1="114.402"
            y1="80.495"
            x2="162.433"
            y2="119.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2364_551"
            x1="139.033"
            y1="79.8839"
            x2="143.852"
            y2="79.4838"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2364_551"
            x1="114.318"
            y1="38.028"
            x2="119.518"
            y2="57.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2364_551"
            x1="132.23"
            y1="89.4093"
            x2="180.261"
            y2="127.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2364_551"
            x1="156.861"
            y1="88.7982"
            x2="161.68"
            y2="88.3981"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2364_551"
            x1="132.146"
            y1="46.9423"
            x2="137.346"
            y2="66.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2364_551"
            x1="147.829"
            y1="99.8092"
            x2="195.86"
            y2="138.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2364_551"
            x1="172.461"
            y1="99.1981"
            x2="177.28"
            y2="98.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2364_551"
            x1="147.745"
            y1="57.3422"
            x2="152.946"
            y2="76.9395"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2364_551"
            x1="165.657"
            y1="108.723"
            x2="213.688"
            y2="147.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2364_551"
            x1="190.289"
            y1="108.112"
            x2="195.108"
            y2="107.712"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2364_551"
            x1="165.574"
            y1="66.2562"
            x2="170.774"
            y2="85.8536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_2364_551"
            x1="111.997"
            y1="124.172"
            x2="171.516"
            y2="171.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_2364_551"
            x1="100.749"
            y1="138.732"
            x2="183.537"
            y2="112.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_2364_551"
            x1="36.7917"
            y1="82.1903"
            x2="84.8228"
            y2="120.706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_2364_551"
            x1="61.4228"
            y1="81.5792"
            x2="66.2417"
            y2="81.1791"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_2364_551"
            x1="36.7076"
            y1="39.7233"
            x2="41.9079"
            y2="59.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_2364_551"
            x1="55.4021"
            y1="91.495"
            x2="103.433"
            y2="130.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_2364_551"
            x1="80.0331"
            y1="90.8839"
            x2="84.852"
            y2="90.4838"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_2364_551"
            x1="55.318"
            y1="49.028"
            x2="60.5183"
            y2="68.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_2364_551"
            x1="73.23"
            y1="100.409"
            x2="121.261"
            y2="138.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_2364_551"
            x1="97.8608"
            y1="99.7982"
            x2="102.68"
            y2="99.3981"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_2364_551"
            x1="73.1456"
            y1="57.9423"
            x2="78.3459"
            y2="77.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint28_linear_2364_551"
            x1="88.8288"
            y1="110.809"
            x2="136.86"
            y2="149.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint29_linear_2364_551"
            x1="113.461"
            y1="110.198"
            x2="118.28"
            y2="109.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint30_linear_2364_551"
            x1="88.7452"
            y1="68.3422"
            x2="93.9455"
            y2="87.9395"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint31_linear_2364_551"
            x1="106.657"
            y1="119.723"
            x2="154.688"
            y2="158.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint32_linear_2364_551"
            x1="131.289"
            y1="119.112"
            x2="136.108"
            y2="118.712"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint33_linear_2364_551"
            x1="106.574"
            y1="77.2562"
            x2="111.774"
            y2="96.8536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    ),
    dongleKitModems3: (
      <svg
        width="270"
        height="200"
        viewBox="0 0 270 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2364_764)">
          <rect width="270" height="200" />
          <path
            d="M231.939 152.147C232.336 152.147 232.716 152.067 233 151.904L234.257 151.178L227.809 147.454L214.703 139.888L212.312 141.269L230.555 151.802C230.951 152.03 231.458 152.147 231.939 152.147ZM234.681 150.932L260.895 135.798L254.447 132.076L248.742 128.781L233 137.871C232.716 138.034 232.336 138.115 231.939 138.115C231.458 138.115 230.951 137.998 230.555 137.769L224.464 134.252L215.128 139.642L228.233 147.209L234.681 150.932ZM211.887 141.023L214.277 139.643L151.171 103.224L145.353 99.8644L144.096 100.59C143.469 100.952 143.548 101.584 144.272 102.002L211.887 141.023ZM214.703 139.397L224.04 134.008L155.114 94.2287L145.777 99.6193L151.595 102.979L214.703 139.397ZM261.32 135.553L269.635 130.752C270.262 130.39 270.183 129.759 269.46 129.34L258.617 123.08L249.166 128.536L254.871 131.83L261.32 135.553Z"
            fill="#B0C1B8"
          />
          <path
            d="M231.939 138.115C232.337 138.115 232.716 138.034 233.001 137.871L248.742 128.782L249.166 128.537L258.617 123.08L266.03 118.801L266.829 118.34L269.635 116.719C269.908 116.562 270.039 116.352 270.05 116.133H270.056L270.058 110.33V109.841L270.058 109.052C270.058 109.064 270.057 109.076 270.056 109.088V109.131L270.05 109.134C270.017 109.327 269.882 109.507 269.641 109.648L269.635 109.651L233.001 130.803C232.995 130.806 232.989 130.809 232.983 130.813C232.979 130.815 232.975 130.817 232.971 130.82C232.692 130.971 232.326 131.047 231.944 131.047H231.939H231.935C231.465 131.047 230.968 130.933 230.577 130.714C230.57 130.709 230.847 130.656 230.84 130.652L136.593 76.5871C136.576 76.5778 136.559 76.5676 136.543 76.5574C136.54 76.5566 136.537 76.554 136.537 76.554L136.533 76.5515L136.532 76.5506C136.237 76.3657 136.061 76.1435 136.01 75.923L136 75.9179V82.8979C136.019 83.1625 136.216 83.4382 136.593 83.6553L196.904 118.34L197.703 118.802L197.828 118.874L205.115 123.081L224.04 134.008L224.464 134.252L230.555 137.769C230.952 137.998 231.458 138.115 231.939 138.115Z"
            fill="url(#paint0_linear_2364_764)"
          />
          <path
            d="M231.939 131.047H231.944C232.326 131.046 232.692 130.971 232.971 130.819C232.975 130.817 232.979 130.815 232.983 130.813C232.989 130.809 232.995 130.806 233.001 130.802L269.635 109.651L269.641 109.648C269.881 109.508 270.013 109.327 270.047 109.136L270.05 109.134C270.053 109.119 270.055 109.103 270.056 109.088V108.988C270.033 108.726 269.832 108.455 269.46 108.24L175.522 54.141C175.126 53.9129 174.62 53.7958 174.14 53.7958C173.752 53.7958 173.382 53.8722 173.101 54.0265C173.093 54.0316 173.085 54.0359 173.078 54.0401L136.443 75.1912C136.158 75.3549 136.019 75.5745 136.019 75.8044C136.019 75.8315 136.021 75.8586 136.025 75.8849C136.028 75.9027 136.031 75.9206 136.035 75.9384L136.043 75.9435C136.096 76.1623 136.264 76.3828 136.557 76.566L136.559 76.5668L136.562 76.5694C136.562 76.5694 136.566 76.5719 136.568 76.5728C136.584 76.5829 136.601 76.5931 136.618 76.6025L230.556 130.701C230.563 130.705 230.57 130.709 230.577 130.713C230.969 130.933 231.465 131.047 231.935 131.047H231.939ZM174.147 56.3012C174.573 56.3012 175.022 56.4046 175.374 56.6074L265.19 108.326C265.831 108.696 265.9 109.256 265.345 109.577L232.872 128.326C232.62 128.471 232.283 128.542 231.93 128.542C231.505 128.542 231.055 128.439 230.705 128.236L140.888 76.5168C140.247 76.1462 140.178 75.5864 140.733 75.2658L173.206 56.5174C173.458 56.3716 173.794 56.3012 174.147 56.3012Z"
            fill="url(#paint1_linear_2364_764)"
          />
          <path
            d="M231.93 128.542C232.283 128.542 232.62 128.471 232.871 128.326L265.345 109.577C265.9 109.256 265.831 108.696 265.189 108.326L175.18 56.7605C174.829 56.5578 174.379 56.4543 173.954 56.4543C173.601 56.4543 173.264 56.5247 173.012 56.6706L140.54 75.419C139.984 75.7396 140.054 76.2993 140.695 76.67L230.363 128.513C230.713 128.715 231.504 128.542 231.93 128.542ZM173.959 58.042C174.351 58.042 174.763 58.1378 175.085 58.3236L262.481 108.381C263.07 108.721 263.134 109.235 262.624 109.53L232.79 126.755C232.558 126.888 232.25 126.954 231.925 126.954C231.534 126.954 231.121 126.859 230.799 126.672L143.403 76.6157C142.814 76.2747 142.75 75.7608 143.26 75.4656L173.095 58.2413C173.325 58.1073 173.635 58.042 173.959 58.042Z"
            fill="#808E88"
          />
          <path
            d="M231.925 126.954C232.25 126.954 232.559 126.889 232.79 126.755L262.624 109.53C263.134 109.235 263.07 108.721 262.481 108.381L174.857 58.4484C174.535 58.2627 174.123 58.1669 173.731 58.1669C173.407 58.1669 173.097 58.2322 172.867 58.3662L143.032 75.5905C142.522 75.8856 142.586 76.3996 143.175 76.7405L230.799 126.672C231.121 126.859 231.534 126.954 231.925 126.954Z"
            fill="#AEC7B9"
          />
          <path
            d="M154.01 77.7499V12.2566L158.506 9.8587L169.824 3.07967C170.329 2.7881 171.212 2.82437 171.796 3.16179L174.017 4.29209L183.26 4.29825L183.259 70.1057H183.254C183.245 70.2836 183.139 70.452 182.919 70.5793L162.403 82.2576C161.897 82.5498 161.014 82.5129 160.43 82.1762L154.489 78.3611C154.185 78.1859 154.025 77.9641 154.01 77.7499Z"
            fill="url(#paint2_linear_2364_764)"
          />
          <path
            d="M162.403 35.1997L160.604 82.2579C161.348 82.5248 161.741 82.518 162.403 82.2579L162.403 35.1997Z"
            fill="url(#paint3_linear_2364_764)"
          />
          <path
            d="M177.683 35.8318L174.563 37.6146C174.117 37.9117 174.266 38.2089 174.266 38.2089L174.86 38.8031L175.751 38.2832C175.9 38.2089 175.751 38.6546 175.751 38.6546L174.86 41.2545C174.86 41.2545 172.706 38.1346 172.557 37.8375C172.334 37.5403 172.631 37.3917 172.631 37.3917L179.391 33.4547C179.688 33.3061 179.465 33.8261 179.465 33.8261L173.671 49.7229L173.077 49.1287V48.6087L177.683 35.8318Z"
            fill="#35BE70"
          />
          <path
            d="M172.929 43.5574L171.22 41.3289C171.22 41.3289 171.071 41.0317 171.294 40.8832L172.409 40.2146L174.266 42.8888L172.409 47.7916L171.889 47.123V46.6773L172.929 43.8545V43.5574Z"
            fill="#35BE70"
          />
          <path
            d="M167.654 40.2889L171.145 38.2832L171.368 38.5803L171.591 38.8775C171.814 39.2489 171.517 39.3975 171.517 39.3975L169.586 40.5117C169.214 40.7346 169.437 41.0317 169.437 41.0317L171.591 44.1517L171.665 44.6717L171.145 46.0088C171.145 46.0088 167.803 41.106 167.506 40.8089C167.208 40.5117 167.654 40.2889 167.654 40.2889Z"
            fill="#35BE70"
          />
          <path
            d="M162.103 16.764L182.919 5.07736C183.425 4.78511 183.361 4.27523 182.777 3.93781L177.09 0.278635C176.506 -0.0580997 175.622 -0.0950546 175.117 0.197193L154.301 11.8839C153.795 12.1754 153.859 12.6853 154.443 13.0227L160.13 16.6819C160.714 17.0193 161.597 17.0563 162.103 16.764Z"
            fill="url(#paint4_linear_2364_764)"
          />
          <path
            d="M172.621 87.0546V21.5613L177.117 19.1634L188.434 12.3844C188.939 12.0928 189.823 12.1291 190.407 12.4665L192.627 13.5968L201.871 13.6029L201.869 79.4104H201.864C201.855 79.5883 201.749 79.7567 201.529 79.884L181.013 91.5623C180.507 91.8545 179.624 91.8176 179.04 91.4808L173.099 87.6658C172.795 87.4906 172.636 87.2688 172.621 87.0546Z"
            fill="url(#paint5_linear_2364_764)"
          />
          <path
            d="M181.013 44.5044L179.215 91.5626C179.959 91.8295 180.351 91.8227 181.013 91.5626L181.013 44.5044Z"
            fill="url(#paint6_linear_2364_764)"
          />
          <path
            d="M196.293 45.1365L193.173 46.9193C192.727 47.2164 192.876 47.5136 192.876 47.5136L193.47 48.1078L194.362 47.5878C194.51 47.5136 194.362 47.9593 194.362 47.9593L193.47 50.5592C193.47 50.5592 191.316 47.4393 191.167 47.1421C190.944 46.845 191.242 46.6964 191.242 46.6964L198.001 42.7594C198.299 42.6108 198.076 43.1308 198.076 43.1308L192.282 59.0276L191.687 58.4334V57.9134L196.293 45.1365Z"
            fill="#35BE70"
          />
          <path
            d="M191.539 52.8621L189.83 50.6336C189.83 50.6336 189.682 50.3364 189.905 50.1878L191.019 49.5193L192.876 52.1935L191.019 57.0963L190.499 56.4277V55.982L191.539 53.1592V52.8621Z"
            fill="#35BE70"
          />
          <path
            d="M186.264 49.5936L189.756 47.5879L189.978 47.885L190.201 48.1822C190.424 48.5536 190.127 48.7022 190.127 48.7022L188.196 49.8164C187.824 50.0393 188.047 50.3364 188.047 50.3364L190.201 53.4564L190.276 53.9763L189.756 55.3135C189.756 55.3135 186.413 50.4107 186.116 50.1136C185.819 49.8164 186.264 49.5936 186.264 49.5936Z"
            fill="#35BE70"
          />
          <path
            d="M180.713 26.0687L201.529 14.382C202.035 14.0898 201.971 13.5799 201.388 13.2425L195.7 9.58332C195.116 9.24659 194.233 9.20963 193.728 9.50188L172.911 21.1885C172.406 21.4801 172.469 21.99 173.053 22.3274L178.74 25.9866C179.324 26.324 180.208 26.3609 180.713 26.0687Z"
            fill="url(#paint7_linear_2364_764)"
          />
          <path
            d="M190.449 95.9689V30.4756L194.945 28.0777L206.262 21.2987C206.767 21.0071 207.651 21.0434 208.235 21.3808L210.455 22.5111L219.698 22.5172L219.697 88.3247H219.692C219.683 88.5026 219.577 88.671 219.357 88.7983L198.841 100.477C198.335 100.769 197.452 100.732 196.868 100.395L190.927 96.5801C190.623 96.4049 190.464 96.1831 190.449 95.9689Z"
            fill="url(#paint8_linear_2364_764)"
          />
          <path
            d="M198.841 53.4187L197.042 100.477C197.786 100.744 198.179 100.737 198.841 100.477L198.841 53.4187Z"
            fill="url(#paint9_linear_2364_764)"
          />
          <path
            d="M214.121 54.0508L211.001 55.8336C210.555 56.1307 210.704 56.4279 210.704 56.4279L211.298 57.0221L212.189 56.5022C212.338 56.4279 212.189 56.8736 212.189 56.8736L211.298 59.4735C211.298 59.4735 209.144 56.3536 208.995 56.0564C208.772 55.7593 209.069 55.6107 209.069 55.6107L215.829 51.6737C216.126 51.5251 215.903 52.0451 215.903 52.0451L210.109 67.9419L209.515 67.3477V66.8277L214.121 54.0508Z"
            fill="#35BE70"
          />
          <path
            d="M209.366 61.7764L207.658 59.5479C207.658 59.5479 207.509 59.2507 207.732 59.1022L208.847 58.4336L210.704 61.1078L208.847 66.0106L208.327 65.342V64.8963L209.366 62.0735V61.7764Z"
            fill="#35BE70"
          />
          <path
            d="M204.092 58.5079L207.583 56.5022L207.806 56.7993L208.029 57.0965C208.252 57.4679 207.955 57.6165 207.955 57.6165L206.024 58.7307C205.652 58.9536 205.875 59.2507 205.875 59.2507L208.029 62.3707L208.103 62.8907L207.583 64.2278C207.583 64.2278 204.241 59.325 203.944 59.0279C203.646 58.7307 204.092 58.5079 204.092 58.5079Z"
            fill="#35BE70"
          />
          <path
            d="M198.541 34.983L219.357 23.2964C219.862 23.0041 219.799 22.4942 219.215 22.1568L213.528 18.4976C212.944 18.1609 212.06 18.1239 211.555 18.4162L190.739 30.1029C190.233 30.3944 190.297 30.9043 190.881 31.2417L196.568 34.9009C197.152 35.2383 198.035 35.2753 198.541 34.983Z"
            fill="url(#paint10_linear_2364_764)"
          />
          <path
            d="M206.047 106.369V40.8755L210.543 38.4776L221.861 31.6986C222.366 31.407 223.25 31.4433 223.833 31.7807L226.054 32.911L235.297 32.9171L235.296 98.7246H235.291C235.282 98.9025 235.176 99.0709 234.956 99.1982L214.44 110.876C213.934 111.169 213.051 111.132 212.467 110.795L206.526 106.98C206.222 106.805 206.063 106.583 206.047 106.369Z"
            fill="url(#paint11_linear_2364_764)"
          />
          <path
            d="M214.441 63.8186L212.643 110.877C213.387 111.144 213.779 111.137 214.441 110.877L214.441 63.8186Z"
            fill="url(#paint12_linear_2364_764)"
          />
          <path
            d="M229.721 64.4507L226.601 66.2335C226.155 66.5306 226.304 66.8278 226.304 66.8278L226.898 67.422L227.79 66.9021C227.938 66.8278 227.79 67.2735 227.79 67.2735L226.898 69.8734C226.898 69.8734 224.744 66.7535 224.595 66.4563C224.372 66.1592 224.67 66.0106 224.67 66.0106L231.429 62.0736C231.727 61.925 231.504 62.445 231.504 62.445L225.71 78.3418L225.115 77.7476V77.2276L229.721 64.4507Z"
            fill="#35BE70"
          />
          <path
            d="M224.967 72.1763L223.258 69.9478C223.258 69.9478 223.11 69.6506 223.333 69.5021L224.447 68.8335L226.304 71.5077L224.447 76.4105L223.927 75.7419V75.2962L224.967 72.4734V72.1763Z"
            fill="#35BE70"
          />
          <path
            d="M219.692 68.9078L223.184 66.9021L223.406 67.1992L223.629 67.4964C223.852 67.8678 223.555 68.0164 223.555 68.0164L221.624 69.1306C221.252 69.3535 221.475 69.6506 221.475 69.6506L223.629 72.7706L223.704 73.2906L223.184 74.6277C223.184 74.6277 219.841 69.7249 219.544 69.4278C219.247 69.1306 219.692 68.9078 219.692 68.9078Z"
            fill="#35BE70"
          />
          <path
            d="M214.141 45.3829L234.957 33.6963C235.462 33.404 235.399 32.8941 234.815 32.5567L229.127 28.8975C228.543 28.5608 227.66 28.5238 227.155 28.8161L206.339 40.5028C205.833 40.7943 205.896 41.3042 206.48 41.6416L212.167 45.3008C212.751 45.6382 213.635 45.6752 214.141 45.3829Z"
            fill="url(#paint13_linear_2364_764)"
          />
          <path
            d="M223.876 115.283V49.7895L228.372 47.3917L239.689 40.6126C240.194 40.3211 241.078 40.3573 241.662 40.6947L243.883 41.8251L253.126 41.8312L253.124 107.639H253.119C253.11 107.817 253.005 107.985 252.785 108.112L232.268 119.791C231.763 120.083 230.879 120.046 230.295 119.709L224.354 115.894C224.05 115.719 223.891 115.497 223.876 115.283Z"
            fill="url(#paint14_linear_2364_764)"
          />
          <path
            d="M232.27 72.7327L230.471 119.791C231.215 120.058 231.608 120.051 232.27 119.791L232.27 72.7327Z"
            fill="url(#paint15_linear_2364_764)"
          />
          <path
            d="M247.55 73.3647L244.43 75.1476C243.984 75.4447 244.132 75.7418 244.132 75.7418L244.727 76.3361L245.618 75.8161C245.767 75.7418 245.618 76.1875 245.618 76.1875L244.727 78.7875C244.727 78.7875 242.572 75.6675 242.424 75.3704C242.201 75.0733 242.498 74.9247 242.498 74.9247L249.258 70.9876C249.555 70.8391 249.332 71.3591 249.332 71.3591L243.538 87.2559L242.944 86.6616V86.1416L247.55 73.3647Z"
            fill="#35BE70"
          />
          <path
            d="M242.795 81.0904L241.087 78.8618C241.087 78.8618 240.938 78.5647 241.161 78.4161L242.275 77.7476L244.133 80.4218L242.275 85.3246L241.755 84.656V84.2103L242.795 81.3875V81.0904Z"
            fill="#35BE70"
          />
          <path
            d="M237.521 77.8218L241.012 75.8162L241.235 76.1133L241.458 76.4104C241.681 76.7819 241.384 76.9304 241.384 76.9304L239.452 78.0447C239.081 78.2675 239.304 78.5647 239.304 78.5647L241.458 81.6846L241.532 82.2046L241.012 83.5417C241.012 83.5417 237.67 78.639 237.372 78.3418C237.075 78.0447 237.521 77.8218 237.521 77.8218Z"
            fill="#35BE70"
          />
          <path
            d="M231.969 54.297L252.785 42.6103C253.291 42.3181 253.227 41.8082 252.643 41.4708L246.956 37.8116C246.372 37.4749 245.489 37.4379 244.983 37.7302L224.167 49.4168C223.661 49.7084 223.725 50.2183 224.309 50.5557L229.996 54.2148C230.58 54.5523 231.463 54.5892 231.969 54.297Z"
            fill="url(#paint16_linear_2364_764)"
          />
          <path
            d="M163.88 176C164.278 176 164.658 175.92 164.942 175.757L166.199 175.031L159.751 171.307L146.645 163.741L144.253 165.122L162.497 175.655C162.893 175.883 163.4 176 163.88 176ZM166.623 174.786L192.837 159.651L186.389 155.929L180.684 152.634L164.942 161.724C164.658 161.887 164.278 161.968 163.88 161.968C163.4 161.968 162.893 161.851 162.497 161.622L156.406 158.105L147.07 163.495L160.175 171.062L166.623 174.786ZM143.829 164.876L146.219 163.496L83.113 127.077L77.2949 123.717L76.038 124.443C75.4113 124.805 75.4902 125.437 76.2136 125.855L143.829 164.876ZM146.645 163.25L155.982 157.861L87.0559 118.082L77.719 123.472L83.537 126.832L146.645 163.25ZM193.262 159.406L201.577 154.606C202.204 154.243 202.125 153.612 201.401 153.193L190.559 146.933L181.108 152.389L186.813 155.683L193.262 159.406Z"
            fill="#B0C1B8"
          />
          <path
            d="M163.881 161.968C164.278 161.968 164.658 161.887 164.942 161.724L180.684 152.635L181.108 152.39L190.559 146.934L197.971 142.654L198.771 142.193L201.577 140.572C201.85 140.415 201.981 140.205 201.992 139.986H201.998L202 134.183V133.694L202 132.905C202 132.917 201.999 132.929 201.998 132.941V132.984L201.992 132.987C201.959 133.18 201.824 133.36 201.583 133.501L201.577 133.504L164.942 154.656C164.937 154.659 164.931 154.662 164.925 154.666C164.92 154.668 164.917 154.67 164.913 154.673C164.634 154.824 164.268 154.9 163.886 154.9H163.881H163.877C163.407 154.9 162.91 154.786 162.519 154.567C162.512 154.562 162.789 154.509 162.782 154.506L68.5347 100.44C68.5178 100.431 68.5008 100.421 68.4847 100.41C68.4821 100.41 68.4788 100.407 68.4788 100.407L68.4754 100.405L68.4737 100.404C68.1785 100.219 68.0029 99.9966 67.9521 99.7761L67.9419 99.771V106.751C67.9606 107.016 68.1582 107.291 68.5347 107.508L128.846 142.193L129.645 142.655L129.77 142.727L137.057 146.934L155.982 157.861L156.406 158.105L162.497 161.622C162.893 161.851 163.4 161.968 163.881 161.968Z"
            fill="url(#paint17_linear_2364_764)"
          />
          <path
            d="M163.881 154.9H163.886C164.268 154.899 164.634 154.824 164.913 154.672C164.917 154.67 164.921 154.668 164.925 154.666C164.931 154.662 164.937 154.659 164.943 154.655L201.577 133.504L201.583 133.501C201.823 133.361 201.955 133.18 201.989 132.989L201.992 132.987C201.995 132.972 201.997 132.956 201.998 132.941V132.841C201.975 132.579 201.774 132.308 201.402 132.093L107.464 77.9941C107.068 77.7659 106.561 77.6489 106.081 77.6489C105.694 77.6489 105.324 77.7252 105.043 77.8796C105.035 77.8846 105.027 77.8889 105.02 77.8931L68.3845 99.0442C68.1004 99.2079 67.9613 99.4276 67.9613 99.6574C67.9613 99.6845 67.963 99.7117 67.9672 99.738C67.9697 99.7558 67.9731 99.7736 67.9774 99.7914L67.985 99.7965C68.0376 100.015 68.2064 100.236 68.499 100.419L68.5007 100.42L68.504 100.422C68.504 100.422 68.5074 100.425 68.51 100.426C68.5261 100.436 68.5431 100.446 68.56 100.455L162.497 154.554C162.505 154.558 162.512 154.562 162.519 154.566C162.91 154.786 163.407 154.9 163.877 154.9H163.881ZM106.089 80.1542C106.515 80.1542 106.964 80.2577 107.315 80.4604L197.131 132.179C197.773 132.549 197.842 133.109 197.287 133.43L164.814 152.179C164.562 152.324 164.225 152.395 163.872 152.395C163.446 152.395 162.997 152.292 162.647 152.089L72.8303 100.37C72.1891 99.9992 72.1196 99.4394 72.6751 99.1189L105.148 80.3705C105.4 80.2246 105.736 80.1542 106.089 80.1542Z"
            fill="url(#paint18_linear_2364_764)"
          />
          <path
            d="M163.872 152.395C164.225 152.395 164.561 152.324 164.813 152.179L197.287 133.43C197.842 133.109 197.772 132.549 197.131 132.179L107.122 80.6135C106.771 80.4108 106.321 80.3074 105.896 80.3074C105.543 80.3074 105.206 80.3778 104.954 80.5236L72.4816 99.272C71.9261 99.5926 71.9957 100.152 72.6368 100.523L162.305 152.366C162.655 152.568 163.446 152.395 163.872 152.395ZM105.901 81.895C106.292 81.895 106.705 81.9909 107.027 82.1766L194.423 132.234C195.012 132.574 195.076 133.088 194.566 133.383L164.732 150.608C164.5 150.741 164.192 150.807 163.867 150.807C163.476 150.807 163.063 150.712 162.741 150.525L75.3449 100.469C74.7554 100.128 74.6918 99.6138 75.2015 99.3187L105.036 82.0943C105.267 81.9603 105.577 81.895 105.901 81.895Z"
            fill="#808E88"
          />
          <path
            d="M163.867 150.807C164.192 150.807 164.5 150.742 164.732 150.608L194.566 133.383C195.076 133.088 195.012 132.574 194.423 132.234L106.799 82.3015C106.477 82.1157 106.065 82.0199 105.673 82.0199C105.349 82.0199 105.039 82.0852 104.809 82.2192L74.9738 99.4435C74.4641 99.7386 74.5277 100.253 75.1171 100.594L162.741 150.525C163.063 150.712 163.476 150.807 163.867 150.807Z"
            fill="#AEC7B9"
          />
          <path
            d="M85.9523 101.603V36.1096L90.4483 33.7117L101.766 26.9327C102.271 26.6411 103.154 26.6774 103.738 27.0148L105.959 28.1451L115.202 28.1513L115.201 93.9587H115.195C115.187 94.1366 115.081 94.305 114.861 94.4323L94.3448 106.111C93.839 106.403 92.9555 106.366 92.3716 106.029L86.4307 102.214C86.1268 102.039 85.9673 101.817 85.9523 101.603Z"
            fill="url(#paint19_linear_2364_764)"
          />
          <path
            d="M94.3447 59.0527L92.5463 106.111C93.2901 106.378 93.6828 106.371 94.3447 106.111L94.3447 59.0527Z"
            fill="url(#paint20_linear_2364_764)"
          />
          <path
            d="M109.624 59.6848L106.505 61.4676C106.059 61.7648 106.207 62.0619 106.207 62.0619L106.802 62.6562L107.693 62.1362C107.842 62.0619 107.693 62.5076 107.693 62.5076L106.802 65.1076C106.802 65.1076 104.647 61.9876 104.499 61.6905C104.276 61.3933 104.573 61.2448 104.573 61.2448L111.333 57.3077C111.63 57.1591 111.407 57.6791 111.407 57.6791L105.613 73.576L105.019 72.9817V72.4617L109.624 59.6848Z"
            fill="#35BE70"
          />
          <path
            d="M104.87 67.4104L103.162 65.1819C103.162 65.1819 103.013 64.8848 103.236 64.7362L104.35 64.0676L106.208 66.7419L104.35 71.6446L103.83 70.9761V70.5304L104.87 67.7076V67.4104Z"
            fill="#35BE70"
          />
          <path
            d="M99.596 64.1419L103.087 62.1362L103.31 62.4334L103.533 62.7305C103.756 63.1019 103.459 63.2505 103.459 63.2505L101.527 64.3648C101.156 64.5876 101.379 64.8848 101.379 64.8848L103.533 68.0047L103.607 68.5247L103.087 69.8618C103.087 69.8618 99.7446 64.959 99.4474 64.6619C99.1503 64.3648 99.596 64.1419 99.596 64.1419Z"
            fill="#35BE70"
          />
          <path
            d="M94.0449 40.617L114.861 28.9304C115.366 28.6381 115.303 28.1283 114.719 27.7908L109.032 24.1317C108.448 23.7949 107.564 23.758 107.059 24.0502L86.2429 35.7369C85.7371 36.0284 85.8008 36.5383 86.3846 36.8758L92.0717 40.5349C92.6555 40.8723 93.5391 40.9093 94.0449 40.617Z"
            fill="url(#paint21_linear_2364_764)"
          />
          <path
            d="M104.563 110.908V45.4143L109.059 43.0164L120.376 36.2374C120.881 35.9458 121.765 35.9821 122.349 36.3195L124.569 37.4498L133.812 37.456L133.811 103.263H133.806C133.797 103.441 133.691 103.61 133.471 103.737L112.955 115.415C112.449 115.708 111.566 115.671 110.982 115.334L105.041 111.519C104.737 111.344 104.578 111.122 104.563 110.908Z"
            fill="url(#paint22_linear_2364_764)"
          />
          <path
            d="M112.955 68.3574L111.157 115.416C111.9 115.682 112.293 115.676 112.955 115.416L112.955 68.3574Z"
            fill="url(#paint23_linear_2364_764)"
          />
          <path
            d="M128.235 68.9895L125.115 70.7723C124.669 71.0695 124.818 71.3666 124.818 71.3666L125.412 71.9609L126.303 71.4409C126.452 71.3666 126.303 71.8123 126.303 71.8123L125.412 74.4122C125.412 74.4122 123.258 71.2923 123.109 70.9952C122.886 70.698 123.184 70.5495 123.184 70.5495L129.943 66.6124C130.241 66.4638 130.018 66.9838 130.018 66.9838L124.223 82.8807L123.629 82.2864V81.7664L128.235 68.9895Z"
            fill="#35BE70"
          />
          <path
            d="M123.481 76.7151L121.772 74.4866C121.772 74.4866 121.624 74.1894 121.846 74.0409L122.961 73.3723L124.818 76.0466L122.961 80.9493L122.441 80.2808V79.8351L123.481 77.0122V76.7151Z"
            fill="#35BE70"
          />
          <path
            d="M118.206 73.4466L121.697 71.4409L121.92 71.7381L122.143 72.0352C122.366 72.4066 122.069 72.5552 122.069 72.5552L120.138 73.6694C119.766 73.8923 119.989 74.1894 119.989 74.1894L122.143 77.3094L122.217 77.8294L121.697 79.1665C121.697 79.1665 118.355 74.2637 118.058 73.9666C117.76 73.6694 118.206 73.4466 118.206 73.4466Z"
            fill="#35BE70"
          />
          <path
            d="M112.655 49.9217L133.471 38.2351C133.977 37.9428 133.913 37.4329 133.329 37.0955L127.642 33.4363C127.058 33.0996 126.175 33.0627 125.669 33.3549L104.853 45.0416C104.347 45.3331 104.411 45.843 104.995 46.1804L110.682 49.8396C111.266 50.177 112.149 50.214 112.655 49.9217Z"
            fill="url(#paint24_linear_2364_764)"
          />
          <path
            d="M122.391 119.822V54.3286L126.887 51.9307L138.204 45.1517C138.709 44.8601 139.593 44.8964 140.176 45.2338L142.397 46.3641L151.64 46.3703L151.639 112.178H151.634C151.625 112.356 151.519 112.524 151.299 112.651L130.783 124.33C130.277 124.622 129.394 124.585 128.81 124.248L122.869 120.433C122.565 120.258 122.406 120.036 122.391 119.822Z"
            fill="url(#paint25_linear_2364_764)"
          />
          <path
            d="M130.783 77.2717L128.984 124.33C129.728 124.597 130.121 124.59 130.783 124.33L130.783 77.2717Z"
            fill="url(#paint26_linear_2364_764)"
          />
          <path
            d="M146.062 77.9038L142.943 79.6866C142.497 79.9838 142.645 80.2809 142.645 80.2809L143.24 80.8752L144.131 80.3552C144.28 80.2809 144.131 80.7266 144.131 80.7266L143.24 83.3266C143.24 83.3266 141.085 80.2066 140.937 79.9095C140.714 79.6123 141.011 79.4638 141.011 79.4638L147.771 75.5267C148.068 75.3781 147.845 75.8981 147.845 75.8981L142.051 91.795L141.457 91.2007V90.6807L146.062 77.9038Z"
            fill="#35BE70"
          />
          <path
            d="M141.308 85.6294L139.6 83.4009C139.6 83.4009 139.451 83.1037 139.674 82.9552L140.788 82.2866L142.646 84.9609L140.788 89.8636L140.268 89.1951V88.7494L141.308 85.9266V85.6294Z"
            fill="#35BE70"
          />
          <path
            d="M136.034 82.3609L139.525 80.3552L139.748 80.6524L139.971 80.9495C140.194 81.3209 139.897 81.4695 139.897 81.4695L137.965 82.5838C137.594 82.8066 137.817 83.1037 137.817 83.1037L139.971 86.2237L140.045 86.7437L139.525 88.0808C139.525 88.0808 136.183 83.178 135.885 82.8809C135.588 82.5838 136.034 82.3609 136.034 82.3609Z"
            fill="#35BE70"
          />
          <path
            d="M130.483 58.836L151.299 47.1494C151.804 46.8571 151.741 46.3472 151.157 46.0098L145.47 42.3507C144.886 42.0139 144.002 41.977 143.497 42.2692L122.681 53.9559C122.175 54.2474 122.239 54.7573 122.823 55.0947L128.51 58.7539C129.094 59.0913 129.977 59.1283 130.483 58.836Z"
            fill="url(#paint27_linear_2364_764)"
          />
          <path
            d="M137.989 130.222V64.7285L142.485 62.3306L153.803 55.5516C154.308 55.26 155.191 55.2963 155.775 55.6337L157.996 56.764L167.239 56.7702L167.238 122.578H167.233C167.224 122.756 167.118 122.924 166.898 123.051L146.382 134.73C145.876 135.022 144.993 134.985 144.409 134.648L138.468 130.833C138.164 130.658 138.004 130.436 137.989 130.222Z"
            fill="url(#paint28_linear_2364_764)"
          />
          <path
            d="M146.383 87.6716L144.585 134.73C145.328 134.997 145.721 134.99 146.383 134.73L146.383 87.6716Z"
            fill="url(#paint29_linear_2364_764)"
          />
          <path
            d="M161.663 88.3037L158.543 90.0865C158.097 90.3837 158.246 90.6808 158.246 90.6808L158.84 91.2751L159.731 90.7551C159.88 90.6808 159.731 91.1265 159.731 91.1265L158.84 93.7265C158.84 93.7265 156.686 90.6065 156.537 90.3094C156.314 90.0122 156.611 89.8637 156.611 89.8637L163.371 85.9266C163.669 85.778 163.446 86.298 163.446 86.298L157.651 102.195L157.057 101.601V101.081L161.663 88.3037Z"
            fill="#35BE70"
          />
          <path
            d="M156.909 96.0293L155.2 93.8008C155.2 93.8008 155.052 93.5037 155.274 93.3551L156.389 92.6865L158.246 95.3608L156.389 100.264L155.869 99.595V99.1493L156.909 96.3265V96.0293Z"
            fill="#35BE70"
          />
          <path
            d="M151.634 92.7608L155.125 90.7551L155.348 91.0523L155.571 91.3494C155.794 91.7208 155.497 91.8694 155.497 91.8694L153.565 92.9837C153.194 93.2065 153.417 93.5036 153.417 93.5036L155.571 96.6236L155.645 97.1436L155.125 98.4807C155.125 98.4807 151.783 93.5779 151.486 93.2808C151.188 92.9837 151.634 92.7608 151.634 92.7608Z"
            fill="#35BE70"
          />
          <path
            d="M146.082 69.2359L166.898 57.5493C167.404 57.257 167.341 56.7472 166.757 56.4097L161.069 52.7506C160.485 52.4138 159.602 52.3769 159.097 52.6691L138.281 64.3558C137.775 64.6473 137.838 65.1572 138.422 65.4946L144.109 69.1538C144.693 69.4912 145.577 69.5282 146.082 69.2359Z"
            fill="url(#paint30_linear_2364_764)"
          />
          <path
            d="M155.818 139.136V73.6426L160.314 71.2447L171.631 64.4657C172.136 64.1741 173.02 64.2104 173.604 64.5478L175.824 65.6781L185.068 65.6842L185.066 131.492H185.061C185.052 131.67 184.946 131.838 184.727 131.965L164.21 143.644C163.705 143.936 162.821 143.899 162.237 143.562L156.296 139.747C155.992 139.572 155.833 139.35 155.818 139.136Z"
            fill="url(#paint31_linear_2364_764)"
          />
          <path
            d="M164.211 96.5857L162.413 143.644C163.157 143.911 163.55 143.904 164.211 143.644L164.211 96.5857Z"
            fill="url(#paint32_linear_2364_764)"
          />
          <path
            d="M179.491 97.2178L176.371 99.0006C175.926 99.2977 176.074 99.5949 176.074 99.5949L176.669 100.189L177.56 99.6691C177.709 99.5949 177.56 100.041 177.56 100.041L176.669 102.641C176.669 102.641 174.514 99.5206 174.366 99.2234C174.143 98.9263 174.44 98.7777 174.44 98.7777L181.2 94.8407C181.497 94.6921 181.274 95.2121 181.274 95.2121L175.48 111.109L174.886 110.515V109.995L179.491 97.2178Z"
            fill="#35BE70"
          />
          <path
            d="M174.737 104.943L173.029 102.715C173.029 102.715 172.88 102.418 173.103 102.269L174.217 101.601L176.074 104.275L174.217 109.178L173.697 108.509V108.063L174.737 105.241V104.943Z"
            fill="#35BE70"
          />
          <path
            d="M169.463 101.675L172.954 99.6692L173.177 99.9663L173.4 100.263C173.623 100.635 173.326 100.783 173.326 100.783L171.394 101.898C171.023 102.121 171.246 102.418 171.246 102.418L173.4 105.538L173.474 106.058L172.954 107.395C172.954 107.395 169.612 102.492 169.314 102.195C169.017 101.898 169.463 101.675 169.463 101.675Z"
            fill="#35BE70"
          />
          <path
            d="M163.911 78.15L184.727 66.4633C185.233 66.1711 185.169 65.6612 184.585 65.3238L178.898 61.6646C178.314 61.3279 177.43 61.2909 176.925 61.5832L156.109 73.2698C155.603 73.5614 155.667 74.0713 156.251 74.4087L161.938 78.0679C162.522 78.4053 163.405 78.4422 163.911 78.15Z"
            fill="url(#paint33_linear_2364_764)"
          />
          <path
            d="M95.9386 200.147C96.3363 200.147 96.7163 200.067 97.0004 199.904L98.2573 199.178L91.8091 195.454L78.7032 187.888L76.3115 189.269L94.5553 199.802C94.9513 200.03 95.4577 200.147 95.9386 200.147ZM98.6813 198.932L124.895 183.798L118.447 180.076L112.742 176.781L97.0004 185.871C96.7163 186.034 96.3363 186.115 95.9386 186.115C95.4577 186.115 94.9513 185.998 94.5553 185.769L88.4641 182.252L79.1281 187.642L92.2332 195.209L98.6813 198.932ZM75.8866 189.023L78.2775 187.643L15.1711 151.224L9.35303 147.864L8.09613 148.59C7.46938 148.952 7.54826 149.584 8.2717 150.002L75.8866 189.023ZM78.7032 187.397L88.0401 182.008L19.114 142.229L9.7771 147.619L15.5952 150.979L78.7032 187.397ZM125.32 183.553L133.635 178.752C134.262 178.39 134.183 177.759 133.46 177.34L122.617 171.08L113.166 176.536L118.871 179.83L125.32 183.553Z"
            fill="#B0C1B8"
          />
          <path
            d="M95.9387 186.115C96.3365 186.115 96.7165 186.034 97.0006 185.871L112.742 176.782L113.166 176.537L122.617 171.08L130.03 166.801L130.829 166.34L133.635 164.719C133.908 164.562 134.039 164.352 134.05 164.133H134.056L134.058 158.33V157.841L134.058 157.052C134.058 157.064 134.057 157.076 134.056 157.088V157.131L134.05 157.134C134.017 157.327 133.882 157.507 133.641 157.648L133.635 157.651L97.0006 178.803C96.9946 178.806 96.9887 178.809 96.9828 178.813C96.9785 178.815 96.9751 178.817 96.9709 178.82C96.6919 178.971 96.3263 179.047 95.9438 179.047H95.9387H95.9353C95.4646 179.047 94.9685 178.933 94.5767 178.714C94.5699 178.709 94.8473 178.656 94.8397 178.652L0.592834 124.587C0.575867 124.578 0.558914 124.568 0.542801 124.557C0.540253 124.557 0.536865 124.554 0.536865 124.554L0.533463 124.551L0.531769 124.551C0.236618 124.366 0.0610504 124.144 0.0101776 123.923L0 123.918V130.898C0.0186615 131.163 0.216263 131.438 0.592834 131.655L60.904 166.34L61.703 166.802L61.8276 166.874L69.1155 171.081L88.0403 182.008L88.4643 182.252L94.5555 185.769C94.9515 185.998 95.4579 186.115 95.9387 186.115Z"
            fill="url(#paint34_linear_2364_764)"
          />
          <path
            d="M95.9388 179.047H95.9439C96.3264 179.046 96.692 178.971 96.971 178.819C96.9752 178.817 96.9786 178.815 96.9829 178.813C96.9888 178.809 96.9947 178.806 97.0007 178.802L133.635 157.651L133.641 157.648C133.881 157.508 134.013 157.327 134.047 157.136L134.05 157.134C134.053 157.119 134.055 157.103 134.056 157.088V156.988C134.033 156.726 133.832 156.455 133.46 156.24L39.5219 102.141C39.1258 101.913 38.6195 101.796 38.1395 101.796C37.7519 101.796 37.3821 101.872 37.1014 102.027C37.0929 102.032 37.0853 102.036 37.0777 102.04L0.442581 123.191C0.158463 123.355 0.0193634 123.575 0.0193634 123.804C0.0193634 123.832 0.0210724 123.859 0.0252991 123.885C0.0278473 123.903 0.03125 123.921 0.0354919 123.938L0.0431213 123.943C0.0957031 124.162 0.264481 124.383 0.557083 124.566L0.558762 124.567L0.562149 124.569C0.562149 124.569 0.565552 124.572 0.5681 124.573C0.584213 124.583 0.601181 124.593 0.618149 124.602L94.5555 178.701C94.5632 178.705 94.57 178.709 94.5767 178.713C94.9686 178.933 95.4647 179.047 95.9354 179.047H95.9388ZM38.1471 104.301C38.5729 104.301 39.0224 104.405 39.3735 104.607L129.19 156.326C129.831 156.696 129.9 157.256 129.345 157.577L96.8717 176.326C96.6199 176.471 96.2832 176.542 95.9303 176.542C95.5046 176.542 95.0551 176.439 94.7048 176.236L4.88838 124.517C4.24721 124.146 4.17767 123.586 4.73318 123.266L37.2057 104.517C37.4576 104.372 37.7943 104.301 38.1471 104.301Z"
            fill="url(#paint35_linear_2364_764)"
          />
          <path
            d="M95.93 176.542C96.2828 176.542 96.6195 176.471 96.8714 176.326L129.345 157.577C129.9 157.256 129.831 156.696 129.189 156.326L39.1801 104.761C38.8289 104.558 38.3794 104.454 37.9537 104.454C37.6009 104.454 37.2642 104.525 37.0123 104.671L4.53974 123.419C3.98423 123.74 4.05377 124.299 4.69495 124.67L94.3627 176.513C94.713 176.715 95.5043 176.542 95.93 176.542ZM37.9588 106.042C38.3506 106.042 38.7628 106.138 39.0851 106.324L126.481 156.381C127.07 156.721 127.134 157.235 126.624 157.53L96.79 174.755C96.5585 174.888 96.2498 174.954 95.9249 174.954C95.534 174.954 95.1209 174.859 94.7987 174.672L7.40298 124.616C6.81354 124.275 6.74992 123.761 7.25964 123.466L37.0946 106.241C37.3252 106.107 37.6348 106.042 37.9588 106.042Z"
            fill="#808E88"
          />
          <path
            d="M95.9251 174.954C96.2499 174.954 96.5586 174.889 96.7901 174.755L126.624 157.53C127.134 157.235 127.07 156.721 126.481 156.381L38.8573 106.448C38.535 106.263 38.1228 106.167 37.731 106.167C37.407 106.167 37.0975 106.232 36.8668 106.366L7.03187 123.59C6.52216 123.886 6.58577 124.4 7.17521 124.741L94.7988 174.672C95.1211 174.859 95.5341 174.954 95.9251 174.954Z"
            fill="#AEC7B9"
          />
          <path
            d="M18.0104 125.75V60.2566L22.5064 57.8587L33.8238 51.0797C34.3289 50.7881 35.2125 50.8244 35.7963 51.1618L38.0171 52.2921L47.2603 52.2982L47.2586 118.106H47.2535C47.245 118.284 47.1391 118.452 46.9191 118.579L26.4029 130.258C25.8971 130.55 25.0136 130.513 24.4297 130.176L18.4888 126.361C18.1849 126.186 18.0254 125.964 18.0104 125.75Z"
            fill="url(#paint36_linear_2364_764)"
          />
          <path
            d="M26.4028 83.1997L24.6044 130.258C25.3482 130.525 25.7409 130.518 26.4028 130.258L26.4028 83.1997Z"
            fill="url(#paint37_linear_2364_764)"
          />
          <path
            d="M41.6826 83.8318L38.5627 85.6146C38.117 85.9117 38.2655 86.2089 38.2655 86.2089L38.8598 86.8031L39.7512 86.2832C39.8998 86.2089 39.7512 86.6546 39.7512 86.6546L38.8598 89.2545C38.8598 89.2545 36.7056 86.1346 36.557 85.8375C36.3341 85.5403 36.6313 85.3917 36.6313 85.3917L43.3911 81.4547C43.6883 81.3061 43.4654 81.8261 43.4654 81.8261L37.6712 97.7229L37.077 97.1287V96.6087L41.6826 83.8318Z"
            fill="#35BE70"
          />
          <path
            d="M36.9285 91.5574L35.22 89.3289C35.22 89.3289 35.0714 89.0317 35.2943 88.8832L36.4085 88.2146L38.2656 90.8888L36.4085 95.7916L35.8885 95.123V94.6773L36.9285 91.8545V91.5574Z"
            fill="#35BE70"
          />
          <path
            d="M31.6541 88.2889L35.1455 86.2832L35.3683 86.5803L35.5912 86.8775C35.814 87.2489 35.5169 87.3975 35.5169 87.3975L33.5855 88.5117C33.2141 88.7346 33.4369 89.0317 33.4369 89.0317L35.5912 92.1517L35.6655 92.6717L35.1455 94.0088C35.1455 94.0088 31.8027 89.106 31.5056 88.8089C31.2084 88.5117 31.6541 88.2889 31.6541 88.2889Z"
            fill="#35BE70"
          />
          <path
            d="M26.103 64.764L46.919 53.0774C47.4245 52.7851 47.3611 52.2752 46.7772 51.9378L41.0897 48.2786C40.5059 47.9419 39.6223 47.9049 39.1172 48.1972L18.301 59.8839C17.7952 60.1754 17.8589 60.6853 18.4427 61.0227L24.1298 64.6819C24.7136 65.0193 25.5972 65.0563 26.103 64.764Z"
            fill="url(#paint38_linear_2364_764)"
          />
          <path
            d="M36.6207 135.055V69.5613L41.1167 67.1634L52.4341 60.3844C52.9392 60.0928 53.8228 60.1291 54.4066 60.4665L56.6275 61.5968L65.8706 61.6029L65.869 127.41H65.8639C65.8553 127.588 65.7495 127.757 65.5295 127.884L45.0133 139.562C44.5075 139.855 43.6239 139.818 43.0401 139.481L37.0991 135.666C36.7953 135.491 36.6358 135.269 36.6207 135.055Z"
            fill="url(#paint39_linear_2364_764)"
          />
          <path
            d="M45.0132 92.5044L43.2148 139.563C43.9586 139.829 44.3513 139.823 45.0132 139.563L45.0132 92.5044Z"
            fill="url(#paint40_linear_2364_764)"
          />
          <path
            d="M60.293 93.1365L57.173 94.9193C56.7273 95.2164 56.8759 95.5136 56.8759 95.5136L57.4701 96.1078L58.3616 95.5878C58.5101 95.5136 58.3616 95.9593 58.3616 95.9593L57.4701 98.5592C57.4701 98.5592 55.3159 95.4393 55.1673 95.1421C54.9445 94.845 55.2416 94.6964 55.2416 94.6964L62.0015 90.7594C62.2986 90.6108 62.0758 91.1308 62.0758 91.1308L56.2816 107.028L55.6873 106.433V105.913L60.293 93.1365Z"
            fill="#35BE70"
          />
          <path
            d="M55.5389 100.862L53.8303 98.6336C53.8303 98.6336 53.6817 98.3364 53.9046 98.1878L55.0189 97.5193L56.876 100.194L55.0189 105.096L54.4989 104.428V103.982L55.5389 101.159V100.862Z"
            fill="#35BE70"
          />
          <path
            d="M50.2642 97.5936L53.7556 95.5879L53.9784 95.885L54.2013 96.1822C54.4242 96.5536 54.127 96.7022 54.127 96.7022L52.1956 97.8164C51.8242 98.0393 52.0471 98.3364 52.0471 98.3364L54.2013 101.456L54.2756 101.976L53.7556 103.313C53.7556 103.313 50.4128 98.4107 50.1157 98.1136C49.8185 97.8164 50.2642 97.5936 50.2642 97.5936Z"
            fill="#35BE70"
          />
          <path
            d="M44.7134 74.0687L65.5293 62.382C66.0349 62.0898 65.9715 61.5799 65.3876 61.2425L59.7001 57.5833C59.1163 57.2466 58.2327 57.2096 57.7276 57.5019L36.9114 69.1885C36.4056 69.4801 36.4692 69.99 37.0531 70.3274L42.7402 73.9866C43.324 74.324 44.2076 74.3609 44.7134 74.0687Z"
            fill="url(#paint41_linear_2364_764)"
          />
          <path
            d="M54.4486 143.969V78.4756L58.9446 76.0777L70.262 69.2987C70.7671 69.0071 71.6507 69.0434 72.2345 69.3808L74.4553 70.5111L83.6985 70.5172L83.6968 136.325H83.6918C83.6832 136.503 83.5773 136.671 83.3574 136.798L62.8412 148.477C62.3354 148.769 61.4518 148.732 60.868 148.395L54.927 144.58C54.6231 144.405 54.4637 144.183 54.4486 143.969Z"
            fill="url(#paint42_linear_2364_764)"
          />
          <path
            d="M62.8408 101.419L61.0424 148.477C61.7862 148.744 62.1789 148.737 62.8408 148.477L62.8408 101.419Z"
            fill="url(#paint43_linear_2364_764)"
          />
          <path
            d="M78.1206 102.051L75.0006 103.834C74.5549 104.131 74.7035 104.428 74.7035 104.428L75.2978 105.022L76.1892 104.502C76.3378 104.428 76.1892 104.874 76.1892 104.874L75.2978 107.474C75.2978 107.474 73.1435 104.354 72.995 104.056C72.7721 103.759 73.0693 103.611 73.0693 103.611L79.8291 99.6737C80.1263 99.5251 79.9034 100.045 79.9034 100.045L74.1092 115.942L73.515 115.348V114.828L78.1206 102.051Z"
            fill="#35BE70"
          />
          <path
            d="M73.3665 109.776L71.658 107.548C71.658 107.548 71.5094 107.251 71.7322 107.102L72.8465 106.434L74.7036 109.108L72.8465 114.011L72.3265 113.342V112.896L73.3665 110.074V109.776Z"
            fill="#35BE70"
          />
          <path
            d="M68.0921 106.508L71.5835 104.502L71.8063 104.799L72.0292 105.096C72.252 105.468 71.9549 105.616 71.9549 105.616L70.0235 106.731C69.6521 106.954 69.8749 107.251 69.8749 107.251L72.0292 110.371L72.1035 110.891L71.5835 112.228C71.5835 112.228 68.2407 107.325 67.9435 107.028C67.6464 106.731 68.0921 106.508 68.0921 106.508Z"
            fill="#35BE70"
          />
          <path
            d="M62.541 82.983L83.357 71.2964C83.8625 71.0041 83.7991 70.4942 83.2152 70.1568L77.5277 66.4976C76.9439 66.1609 76.0603 66.1239 75.5552 66.4162L54.739 78.1029C54.2332 78.3944 54.2969 78.9043 54.8807 79.2417L60.5678 82.9009C61.1516 83.2383 62.0352 83.2753 62.541 82.983Z"
            fill="url(#paint44_linear_2364_764)"
          />
          <path
            d="M70.0475 154.369V88.8755L74.5435 86.4776L85.8609 79.6986C86.366 79.407 87.2496 79.4433 87.8334 79.7807L90.0542 80.911L99.2974 80.9171L99.2957 146.725H99.2907C99.2821 146.903 99.1762 147.071 98.9562 147.198L78.44 158.876C77.9343 159.169 77.0507 159.132 76.4669 158.795L70.5259 154.98C70.222 154.805 70.0625 154.583 70.0475 154.369Z"
            fill="url(#paint45_linear_2364_764)"
          />
          <path
            d="M78.4412 111.819L76.6428 158.877C77.3865 159.144 77.7792 159.137 78.4412 158.877L78.4412 111.819Z"
            fill="url(#paint46_linear_2364_764)"
          />
          <path
            d="M93.7209 112.451L90.601 114.233C90.1553 114.531 90.3039 114.828 90.3039 114.828L90.8981 115.422L91.7895 114.902C91.9381 114.828 91.7895 115.273 91.7895 115.273L90.8981 117.873C90.8981 117.873 88.7439 114.753 88.5953 114.456C88.3725 114.159 88.6696 114.011 88.6696 114.011L95.4295 110.074C95.7266 109.925 95.5038 110.445 95.5038 110.445L89.7096 126.342L89.1153 125.748V125.228L93.7209 112.451Z"
            fill="#35BE70"
          />
          <path
            d="M88.9668 120.176L87.2583 117.948C87.2583 117.948 87.1097 117.651 87.3326 117.502L88.4468 116.833L90.304 119.508L88.4468 124.411L87.9269 123.742V123.296L88.9668 120.473V120.176Z"
            fill="#35BE70"
          />
          <path
            d="M83.6922 116.908L87.1836 114.902L87.4064 115.199L87.6293 115.496C87.8521 115.868 87.555 116.016 87.555 116.016L85.6236 117.131C85.2522 117.353 85.475 117.651 85.475 117.651L87.6293 120.771L87.7036 121.291L87.1836 122.628C87.1836 122.628 83.8408 117.725 83.5436 117.428C83.2465 117.131 83.6922 116.908 83.6922 116.908Z"
            fill="#35BE70"
          />
          <path
            d="M78.1406 93.3829L98.9566 81.6963C99.4621 81.404 99.3987 80.8941 98.8148 80.5567L93.1273 76.8975C92.5435 76.5608 91.6599 76.5238 91.1548 76.8161L70.3386 88.5028C69.8328 88.7943 69.8965 89.3042 70.4803 89.6416L76.1674 93.3008C76.7512 93.6382 77.6348 93.6752 78.1406 93.3829Z"
            fill="url(#paint47_linear_2364_764)"
          />
          <path
            d="M87.8759 163.283V97.7895L92.3719 95.3917L103.689 88.6126C104.194 88.3211 105.078 88.3573 105.662 88.6947L107.883 89.8251L117.126 89.8312L117.124 155.639H117.119C117.11 155.817 117.005 155.985 116.785 156.112L96.2684 167.791C95.7626 168.083 94.879 168.046 94.2952 167.709L88.3543 163.894C88.0504 163.719 87.8909 163.497 87.8759 163.283Z"
            fill="url(#paint48_linear_2364_764)"
          />
          <path
            d="M96.2695 120.733L94.4711 167.791C95.2149 168.058 95.6076 168.051 96.2695 167.791L96.2695 120.733Z"
            fill="url(#paint49_linear_2364_764)"
          />
          <path
            d="M111.55 121.365L108.43 123.148C107.984 123.445 108.132 123.742 108.132 123.742L108.727 124.336L109.618 123.816C109.767 123.742 109.618 124.188 109.618 124.188L108.727 126.787C108.727 126.787 106.572 123.668 106.424 123.37C106.201 123.073 106.498 122.925 106.498 122.925L113.258 118.988C113.555 118.839 113.332 119.359 113.332 119.359L107.538 135.256L106.944 134.662V134.142L111.55 121.365Z"
            fill="#35BE70"
          />
          <path
            d="M106.795 129.09L105.087 126.862C105.087 126.862 104.938 126.565 105.161 126.416L106.275 125.748L108.133 128.422L106.275 133.325L105.755 132.656V132.21L106.795 129.387V129.09Z"
            fill="#35BE70"
          />
          <path
            d="M101.521 125.822L105.012 123.816L105.235 124.113L105.458 124.41C105.681 124.782 105.384 124.93 105.384 124.93L103.452 126.045C103.081 126.268 103.304 126.565 103.304 126.565L105.458 129.685L105.532 130.205L105.012 131.542C105.012 131.542 101.67 126.639 101.372 126.342C101.075 126.045 101.521 125.822 101.521 125.822Z"
            fill="#35BE70"
          />
          <path
            d="M95.9692 102.297L116.785 90.6103C117.291 90.3181 117.227 89.8082 116.643 89.4708L110.956 85.8116C110.372 85.4749 109.489 85.4379 108.983 85.7302L88.1672 97.4168C87.6614 97.7084 87.7251 98.2183 88.3089 98.5557L93.996 102.215C94.5798 102.552 95.4634 102.589 95.9692 102.297Z"
            fill="url(#paint50_linear_2364_764)"
          />
          {/* <rect x="170" y="60" width="80" height="80" rx="40" fill="#35BE70"/> */}
          {/* <path d="M190.689 91.0938L194.436 98.0391L198.182 91.0938H202.871L197.088 100.965L203.021 111H198.291L194.436 103.918L190.58 111H185.822L191.77 100.965L185.973 91.0938H190.689ZM208.381 101.936L205.236 101.184L206.371 91.0938H217.555V94.2793H209.611L209.119 98.6953C209.383 98.5404 209.785 98.3763 210.322 98.2031C210.86 98.0208 211.462 97.9297 212.127 97.9297C213.093 97.9297 213.95 98.0801 214.697 98.3809C215.445 98.6816 216.078 99.1191 216.598 99.6934C217.126 100.268 217.527 100.969 217.801 101.799C218.074 102.628 218.211 103.567 218.211 104.615C218.211 105.499 218.074 106.342 217.801 107.145C217.527 107.938 217.113 108.648 216.557 109.277C216.001 109.897 215.303 110.385 214.465 110.74C213.626 111.096 212.633 111.273 211.484 111.273C210.628 111.273 209.798 111.146 208.996 110.891C208.203 110.635 207.488 110.257 206.85 109.756C206.221 109.255 205.715 108.648 205.332 107.938C204.958 107.217 204.762 106.397 204.744 105.477H208.654C208.709 106.042 208.855 106.529 209.092 106.939C209.338 107.34 209.661 107.65 210.062 107.869C210.464 108.088 210.933 108.197 211.471 108.197C211.972 108.197 212.4 108.102 212.756 107.91C213.111 107.719 213.398 107.454 213.617 107.117C213.836 106.771 213.995 106.37 214.096 105.914C214.205 105.449 214.26 104.948 214.26 104.41C214.26 103.872 214.196 103.385 214.068 102.947C213.941 102.51 213.745 102.132 213.48 101.812C213.216 101.493 212.879 101.247 212.469 101.074C212.068 100.901 211.598 100.814 211.061 100.814C210.331 100.814 209.766 100.928 209.365 101.156C208.973 101.384 208.645 101.644 208.381 101.936ZM234.152 99.2969V102.742C234.152 104.237 233.993 105.527 233.674 106.611C233.355 107.687 232.895 108.571 232.293 109.264C231.701 109.947 230.994 110.453 230.174 110.781C229.354 111.109 228.442 111.273 227.439 111.273C226.637 111.273 225.89 111.173 225.197 110.973C224.505 110.763 223.88 110.439 223.324 110.002C222.777 109.564 222.303 109.013 221.902 108.348C221.51 107.673 221.21 106.871 221 105.941C220.79 105.012 220.686 103.945 220.686 102.742V99.2969C220.686 97.8021 220.845 96.5215 221.164 95.4551C221.492 94.3796 221.952 93.5 222.545 92.8164C223.146 92.1328 223.857 91.6315 224.678 91.3125C225.498 90.9844 226.41 90.8203 227.412 90.8203C228.214 90.8203 228.957 90.9251 229.641 91.1348C230.333 91.3353 230.958 91.6497 231.514 92.0781C232.07 92.5065 232.544 93.0579 232.936 93.7324C233.327 94.3978 233.628 95.1953 233.838 96.125C234.048 97.0456 234.152 98.1029 234.152 99.2969ZM230.201 103.262V98.7637C230.201 98.0436 230.16 97.4147 230.078 96.877C230.005 96.3392 229.891 95.8835 229.736 95.5098C229.581 95.127 229.39 94.8171 229.162 94.5801C228.934 94.3431 228.674 94.1699 228.383 94.0605C228.091 93.9512 227.768 93.8965 227.412 93.8965C226.965 93.8965 226.569 93.9831 226.223 94.1562C225.885 94.3294 225.598 94.6074 225.361 94.9902C225.124 95.3639 224.942 95.8652 224.814 96.4941C224.696 97.1139 224.637 97.8704 224.637 98.7637V103.262C224.637 103.982 224.673 104.615 224.746 105.162C224.828 105.709 224.947 106.178 225.102 106.57C225.266 106.953 225.457 107.268 225.676 107.514C225.904 107.751 226.163 107.924 226.455 108.033C226.756 108.143 227.084 108.197 227.439 108.197C227.877 108.197 228.264 108.111 228.602 107.938C228.948 107.755 229.24 107.473 229.477 107.09C229.723 106.698 229.905 106.188 230.023 105.559C230.142 104.93 230.201 104.164 230.201 103.262Z" fill="white"/> */}
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2364_764"
            x1="209.997"
            y1="95.1716"
            x2="269.516"
            y2="142.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2364_764"
            x1="198.749"
            y1="109.732"
            x2="281.537"
            y2="83.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2364_764"
            x1="134.792"
            y1="53.1903"
            x2="182.823"
            y2="91.7057"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2364_764"
            x1="159.423"
            y1="52.5792"
            x2="164.242"
            y2="52.1791"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2364_764"
            x1="134.708"
            y1="10.7233"
            x2="139.908"
            y2="30.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2364_764"
            x1="153.402"
            y1="62.495"
            x2="201.433"
            y2="101.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2364_764"
            x1="178.033"
            y1="61.8839"
            x2="182.852"
            y2="61.4838"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2364_764"
            x1="153.318"
            y1="20.028"
            x2="158.518"
            y2="39.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2364_764"
            x1="171.23"
            y1="71.4093"
            x2="219.261"
            y2="109.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2364_764"
            x1="195.861"
            y1="70.7982"
            x2="200.68"
            y2="70.3981"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2364_764"
            x1="171.146"
            y1="28.9423"
            x2="176.346"
            y2="48.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2364_764"
            x1="186.829"
            y1="81.8092"
            x2="234.86"
            y2="120.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2364_764"
            x1="211.461"
            y1="81.1981"
            x2="216.28"
            y2="80.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2364_764"
            x1="186.745"
            y1="39.3422"
            x2="191.946"
            y2="58.9395"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2364_764"
            x1="204.657"
            y1="90.7233"
            x2="252.688"
            y2="129.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2364_764"
            x1="229.289"
            y1="90.1121"
            x2="234.108"
            y2="89.7121"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2364_764"
            x1="204.574"
            y1="48.2562"
            x2="209.774"
            y2="67.8536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_2364_764"
            x1="141.939"
            y1="119.025"
            x2="201.458"
            y2="166.752"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_2364_764"
            x1="130.691"
            y1="133.585"
            x2="213.479"
            y2="107.728"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_2364_764"
            x1="66.7336"
            y1="77.0433"
            x2="114.765"
            y2="115.559"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_2364_764"
            x1="91.3647"
            y1="76.4322"
            x2="96.1836"
            y2="76.0321"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_2364_764"
            x1="66.6495"
            y1="34.5763"
            x2="71.8498"
            y2="54.1737"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_2364_764"
            x1="85.344"
            y1="86.348"
            x2="133.375"
            y2="124.863"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_2364_764"
            x1="109.975"
            y1="85.7369"
            x2="114.794"
            y2="85.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_2364_764"
            x1="85.2599"
            y1="43.881"
            x2="90.4602"
            y2="63.4783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_2364_764"
            x1="103.172"
            y1="95.2623"
            x2="151.203"
            y2="133.778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_2364_764"
            x1="127.803"
            y1="94.6512"
            x2="132.622"
            y2="94.2511"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_2364_764"
            x1="103.088"
            y1="52.7953"
            x2="108.288"
            y2="72.3927"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint28_linear_2364_764"
            x1="118.771"
            y1="105.662"
            x2="166.802"
            y2="144.178"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint29_linear_2364_764"
            x1="143.403"
            y1="105.051"
            x2="148.222"
            y2="104.651"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint30_linear_2364_764"
            x1="118.687"
            y1="63.1952"
            x2="123.887"
            y2="82.7926"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint31_linear_2364_764"
            x1="136.599"
            y1="114.576"
            x2="184.63"
            y2="153.092"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint32_linear_2364_764"
            x1="161.231"
            y1="113.965"
            x2="166.05"
            y2="113.565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint33_linear_2364_764"
            x1="136.516"
            y1="72.1093"
            x2="141.716"
            y2="91.7066"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint34_linear_2364_764"
            x1="73.9973"
            y1="143.172"
            x2="133.516"
            y2="190.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint35_linear_2364_764"
            x1="62.7487"
            y1="157.732"
            x2="145.537"
            y2="131.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint36_linear_2364_764"
            x1="-1.20828"
            y1="101.19"
            x2="46.8228"
            y2="139.706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint37_linear_2364_764"
            x1="23.4228"
            y1="100.579"
            x2="28.2417"
            y2="100.179"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint38_linear_2364_764"
            x1="-1.29236"
            y1="58.7233"
            x2="3.90794"
            y2="78.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint39_linear_2364_764"
            x1="17.4021"
            y1="110.495"
            x2="65.4331"
            y2="149.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint40_linear_2364_764"
            x1="42.0331"
            y1="109.884"
            x2="46.852"
            y2="109.484"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint41_linear_2364_764"
            x1="17.318"
            y1="68.028"
            x2="22.5183"
            y2="87.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint42_linear_2364_764"
            x1="35.23"
            y1="119.409"
            x2="83.261"
            y2="157.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint43_linear_2364_764"
            x1="59.8608"
            y1="118.798"
            x2="64.6796"
            y2="118.398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint44_linear_2364_764"
            x1="35.1456"
            y1="76.9423"
            x2="40.3459"
            y2="96.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint45_linear_2364_764"
            x1="50.8288"
            y1="129.809"
            x2="98.8599"
            y2="168.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint46_linear_2364_764"
            x1="75.4611"
            y1="129.198"
            x2="80.28"
            y2="128.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint47_linear_2364_764"
            x1="50.7452"
            y1="87.3422"
            x2="55.9455"
            y2="106.94"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint48_linear_2364_764"
            x1="68.6572"
            y1="138.723"
            x2="116.688"
            y2="177.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint49_linear_2364_764"
            x1="93.2895"
            y1="138.112"
            x2="98.1084"
            y2="137.712"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint50_linear_2364_764"
            x1="68.5739"
            y1="96.2562"
            x2="73.7742"
            y2="115.854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <clipPath id="clip0_2364_764">
            <rect width="270" height="200" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    dongleKitModems4: (
      <svg
        width="270"
        height="200"
        viewBox="0 0 270 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2364_1056)">
          <rect width="270" height="200" />
          <path
            d="M231.939 152.147C232.336 152.147 232.716 152.067 233 151.904L234.257 151.178L227.809 147.454L214.703 139.888L212.312 141.269L230.555 151.802C230.951 152.03 231.458 152.147 231.939 152.147ZM234.681 150.932L260.895 135.798L254.447 132.076L248.742 128.781L233 137.871C232.716 138.034 232.336 138.115 231.939 138.115C231.458 138.115 230.951 137.998 230.555 137.769L224.464 134.252L215.128 139.642L228.233 147.209L234.681 150.932ZM211.887 141.023L214.277 139.643L151.171 103.224L145.353 99.8644L144.096 100.59C143.469 100.952 143.548 101.584 144.272 102.002L211.887 141.023ZM214.703 139.397L224.04 134.008L155.114 94.2287L145.777 99.6193L151.595 102.979L214.703 139.397ZM261.32 135.553L269.635 130.752C270.262 130.39 270.183 129.759 269.46 129.34L258.617 123.08L249.166 128.536L254.871 131.83L261.32 135.553Z"
            fill="#B0C1B8"
          />
          <path
            d="M231.939 138.115C232.337 138.115 232.716 138.034 233.001 137.871L248.742 128.782L249.166 128.537L258.617 123.08L266.03 118.801L266.829 118.34L269.635 116.719C269.908 116.562 270.039 116.352 270.05 116.133H270.056L270.058 110.33V109.841L270.058 109.052C270.058 109.064 270.057 109.076 270.056 109.088V109.131L270.05 109.134C270.017 109.327 269.882 109.507 269.641 109.648L269.635 109.651L233.001 130.803C232.995 130.806 232.989 130.809 232.983 130.813C232.979 130.815 232.975 130.817 232.971 130.82C232.692 130.971 232.326 131.047 231.944 131.047H231.939H231.935C231.465 131.047 230.968 130.933 230.577 130.714C230.57 130.709 230.847 130.656 230.84 130.652L136.593 76.5871C136.576 76.5778 136.559 76.5676 136.543 76.5574C136.54 76.5566 136.537 76.554 136.537 76.554L136.533 76.5515L136.532 76.5506C136.237 76.3657 136.061 76.1435 136.01 75.923L136 75.9179V82.8979C136.019 83.1625 136.216 83.4382 136.593 83.6553L196.904 118.34L197.703 118.802L197.828 118.874L205.115 123.081L224.04 134.008L224.464 134.252L230.555 137.769C230.952 137.998 231.458 138.115 231.939 138.115Z"
            fill="url(#paint0_linear_2364_1056)"
          />
          <path
            d="M231.939 131.047H231.944C232.326 131.046 232.692 130.971 232.971 130.819C232.975 130.817 232.979 130.815 232.983 130.813C232.989 130.809 232.995 130.806 233.001 130.802L269.635 109.651L269.641 109.648C269.881 109.508 270.013 109.327 270.047 109.136L270.05 109.134C270.053 109.119 270.055 109.103 270.056 109.088V108.988C270.033 108.726 269.832 108.455 269.46 108.24L175.522 54.141C175.126 53.9129 174.62 53.7958 174.14 53.7958C173.752 53.7958 173.382 53.8722 173.101 54.0265C173.093 54.0316 173.085 54.0359 173.078 54.0401L136.443 75.1912C136.158 75.3549 136.019 75.5745 136.019 75.8044C136.019 75.8315 136.021 75.8586 136.025 75.8849C136.028 75.9027 136.031 75.9206 136.035 75.9384L136.043 75.9435C136.096 76.1623 136.264 76.3828 136.557 76.566L136.559 76.5668L136.562 76.5694C136.562 76.5694 136.566 76.5719 136.568 76.5728C136.584 76.5829 136.601 76.5931 136.618 76.6025L230.556 130.701C230.563 130.705 230.57 130.709 230.577 130.713C230.969 130.933 231.465 131.047 231.935 131.047H231.939ZM174.147 56.3012C174.573 56.3012 175.022 56.4046 175.374 56.6074L265.19 108.326C265.831 108.696 265.9 109.256 265.345 109.577L232.872 128.326C232.62 128.471 232.283 128.542 231.93 128.542C231.505 128.542 231.055 128.439 230.705 128.236L140.888 76.5168C140.247 76.1462 140.178 75.5864 140.733 75.2658L173.206 56.5174C173.458 56.3716 173.794 56.3012 174.147 56.3012Z"
            fill="url(#paint1_linear_2364_1056)"
          />
          <path
            d="M231.93 128.542C232.283 128.542 232.62 128.471 232.871 128.326L265.345 109.577C265.9 109.256 265.831 108.696 265.189 108.326L175.18 56.7605C174.829 56.5578 174.379 56.4543 173.954 56.4543C173.601 56.4543 173.264 56.5247 173.012 56.6706L140.54 75.419C139.984 75.7396 140.054 76.2993 140.695 76.67L230.363 128.513C230.713 128.715 231.504 128.542 231.93 128.542ZM173.959 58.042C174.351 58.042 174.763 58.1378 175.085 58.3236L262.481 108.381C263.07 108.721 263.134 109.235 262.624 109.53L232.79 126.755C232.558 126.888 232.25 126.954 231.925 126.954C231.534 126.954 231.121 126.859 230.799 126.672L143.403 76.6157C142.814 76.2747 142.75 75.7608 143.26 75.4656L173.095 58.2413C173.325 58.1073 173.635 58.042 173.959 58.042Z"
            fill="#808E88"
          />
          <path
            d="M231.925 126.954C232.25 126.954 232.559 126.889 232.79 126.755L262.624 109.53C263.134 109.235 263.07 108.721 262.481 108.381L174.857 58.4484C174.535 58.2627 174.123 58.1669 173.731 58.1669C173.407 58.1669 173.097 58.2322 172.867 58.3662L143.032 75.5905C142.522 75.8856 142.586 76.3996 143.175 76.7405L230.799 126.672C231.121 126.859 231.534 126.954 231.925 126.954Z"
            fill="#AEC7B9"
          />
          <path
            d="M154.01 77.7499V12.2566L158.506 9.8587L169.824 3.07967C170.329 2.7881 171.212 2.82437 171.796 3.16179L174.017 4.29209L183.26 4.29825L183.259 70.1057H183.254C183.245 70.2836 183.139 70.452 182.919 70.5793L162.403 82.2576C161.897 82.5498 161.014 82.5129 160.43 82.1762L154.489 78.3611C154.185 78.1859 154.025 77.9641 154.01 77.7499Z"
            fill="url(#paint2_linear_2364_1056)"
          />
          <path
            d="M162.403 35.1997L160.604 82.2579C161.348 82.5248 161.741 82.518 162.403 82.2579L162.403 35.1997Z"
            fill="url(#paint3_linear_2364_1056)"
          />
          <path
            d="M177.683 35.8318L174.563 37.6146C174.117 37.9117 174.266 38.2089 174.266 38.2089L174.86 38.8031L175.751 38.2832C175.9 38.2089 175.751 38.6546 175.751 38.6546L174.86 41.2545C174.86 41.2545 172.706 38.1346 172.557 37.8375C172.334 37.5403 172.631 37.3917 172.631 37.3917L179.391 33.4547C179.688 33.3061 179.465 33.8261 179.465 33.8261L173.671 49.7229L173.077 49.1287V48.6087L177.683 35.8318Z"
            fill="#35BE70"
          />
          <path
            d="M172.929 43.5574L171.22 41.3289C171.22 41.3289 171.071 41.0317 171.294 40.8832L172.409 40.2146L174.266 42.8888L172.409 47.7916L171.889 47.123V46.6773L172.929 43.8545V43.5574Z"
            fill="#35BE70"
          />
          <path
            d="M167.654 40.2889L171.145 38.2832L171.368 38.5803L171.591 38.8775C171.814 39.2489 171.517 39.3975 171.517 39.3975L169.586 40.5117C169.214 40.7346 169.437 41.0317 169.437 41.0317L171.591 44.1517L171.665 44.6717L171.145 46.0088C171.145 46.0088 167.803 41.106 167.506 40.8089C167.208 40.5117 167.654 40.2889 167.654 40.2889Z"
            fill="#35BE70"
          />
          <path
            d="M162.103 16.764L182.919 5.07736C183.425 4.78511 183.361 4.27523 182.777 3.93781L177.09 0.278635C176.506 -0.0580997 175.622 -0.0950546 175.117 0.197193L154.301 11.8839C153.795 12.1754 153.859 12.6853 154.443 13.0227L160.13 16.6819C160.714 17.0193 161.597 17.0563 162.103 16.764Z"
            fill="url(#paint4_linear_2364_1056)"
          />
          <path
            d="M172.621 87.0546V21.5613L177.117 19.1634L188.434 12.3844C188.939 12.0928 189.823 12.1291 190.407 12.4665L192.627 13.5968L201.871 13.6029L201.869 79.4104H201.864C201.855 79.5883 201.749 79.7567 201.529 79.884L181.013 91.5623C180.507 91.8545 179.624 91.8176 179.04 91.4808L173.099 87.6658C172.795 87.4906 172.636 87.2688 172.621 87.0546Z"
            fill="url(#paint5_linear_2364_1056)"
          />
          <path
            d="M181.013 44.5044L179.215 91.5626C179.959 91.8295 180.351 91.8227 181.013 91.5626L181.013 44.5044Z"
            fill="url(#paint6_linear_2364_1056)"
          />
          <path
            d="M196.293 45.1365L193.173 46.9193C192.727 47.2164 192.876 47.5136 192.876 47.5136L193.47 48.1078L194.362 47.5878C194.51 47.5136 194.362 47.9593 194.362 47.9593L193.47 50.5592C193.47 50.5592 191.316 47.4393 191.167 47.1421C190.944 46.845 191.242 46.6964 191.242 46.6964L198.001 42.7594C198.299 42.6108 198.076 43.1308 198.076 43.1308L192.282 59.0276L191.687 58.4334V57.9134L196.293 45.1365Z"
            fill="#35BE70"
          />
          <path
            d="M191.539 52.8621L189.83 50.6336C189.83 50.6336 189.682 50.3364 189.905 50.1878L191.019 49.5193L192.876 52.1935L191.019 57.0963L190.499 56.4277V55.982L191.539 53.1592V52.8621Z"
            fill="#35BE70"
          />
          <path
            d="M186.264 49.5936L189.756 47.5879L189.978 47.885L190.201 48.1822C190.424 48.5536 190.127 48.7022 190.127 48.7022L188.196 49.8164C187.824 50.0393 188.047 50.3364 188.047 50.3364L190.201 53.4564L190.276 53.9763L189.756 55.3135C189.756 55.3135 186.413 50.4107 186.116 50.1136C185.819 49.8164 186.264 49.5936 186.264 49.5936Z"
            fill="#35BE70"
          />
          <path
            d="M180.713 26.0687L201.529 14.382C202.035 14.0898 201.971 13.5799 201.388 13.2425L195.7 9.58332C195.116 9.24659 194.233 9.20963 193.728 9.50188L172.911 21.1885C172.406 21.4801 172.469 21.99 173.053 22.3274L178.74 25.9866C179.324 26.324 180.208 26.3609 180.713 26.0687Z"
            fill="url(#paint7_linear_2364_1056)"
          />
          <path
            d="M190.449 95.9689V30.4756L194.945 28.0777L206.262 21.2987C206.767 21.0071 207.651 21.0434 208.235 21.3808L210.455 22.5111L219.698 22.5172L219.697 88.3247H219.692C219.683 88.5026 219.577 88.671 219.357 88.7983L198.841 100.477C198.335 100.769 197.452 100.732 196.868 100.395L190.927 96.5801C190.623 96.4049 190.464 96.1831 190.449 95.9689Z"
            fill="url(#paint8_linear_2364_1056)"
          />
          <path
            d="M198.841 53.4187L197.042 100.477C197.786 100.744 198.179 100.737 198.841 100.477L198.841 53.4187Z"
            fill="url(#paint9_linear_2364_1056)"
          />
          <path
            d="M214.121 54.0508L211.001 55.8336C210.555 56.1307 210.704 56.4279 210.704 56.4279L211.298 57.0221L212.189 56.5022C212.338 56.4279 212.189 56.8736 212.189 56.8736L211.298 59.4735C211.298 59.4735 209.144 56.3536 208.995 56.0564C208.772 55.7593 209.069 55.6107 209.069 55.6107L215.829 51.6737C216.126 51.5251 215.903 52.0451 215.903 52.0451L210.109 67.9419L209.515 67.3477V66.8277L214.121 54.0508Z"
            fill="#35BE70"
          />
          <path
            d="M209.366 61.7764L207.658 59.5479C207.658 59.5479 207.509 59.2507 207.732 59.1022L208.847 58.4336L210.704 61.1078L208.847 66.0106L208.327 65.342V64.8963L209.366 62.0735V61.7764Z"
            fill="#35BE70"
          />
          <path
            d="M204.092 58.5079L207.583 56.5022L207.806 56.7993L208.029 57.0965C208.252 57.4679 207.955 57.6165 207.955 57.6165L206.024 58.7307C205.652 58.9536 205.875 59.2507 205.875 59.2507L208.029 62.3707L208.103 62.8907L207.583 64.2278C207.583 64.2278 204.241 59.325 203.944 59.0279C203.646 58.7307 204.092 58.5079 204.092 58.5079Z"
            fill="#35BE70"
          />
          <path
            d="M198.541 34.983L219.357 23.2964C219.862 23.0041 219.799 22.4942 219.215 22.1568L213.528 18.4976C212.944 18.1609 212.06 18.1239 211.555 18.4162L190.739 30.1029C190.233 30.3944 190.297 30.9043 190.881 31.2417L196.568 34.9009C197.152 35.2383 198.035 35.2753 198.541 34.983Z"
            fill="url(#paint10_linear_2364_1056)"
          />
          <path
            d="M206.047 106.369V40.8755L210.543 38.4776L221.861 31.6986C222.366 31.407 223.25 31.4433 223.833 31.7807L226.054 32.911L235.297 32.9171L235.296 98.7246H235.291C235.282 98.9025 235.176 99.0709 234.956 99.1982L214.44 110.876C213.934 111.169 213.051 111.132 212.467 110.795L206.526 106.98C206.222 106.805 206.063 106.583 206.047 106.369Z"
            fill="url(#paint11_linear_2364_1056)"
          />
          <path
            d="M214.441 63.8186L212.643 110.877C213.387 111.144 213.779 111.137 214.441 110.877L214.441 63.8186Z"
            fill="url(#paint12_linear_2364_1056)"
          />
          <path
            d="M229.721 64.4507L226.601 66.2335C226.155 66.5306 226.304 66.8278 226.304 66.8278L226.898 67.422L227.79 66.9021C227.938 66.8278 227.79 67.2735 227.79 67.2735L226.898 69.8734C226.898 69.8734 224.744 66.7535 224.595 66.4563C224.372 66.1592 224.67 66.0106 224.67 66.0106L231.429 62.0736C231.727 61.925 231.504 62.445 231.504 62.445L225.71 78.3418L225.115 77.7476V77.2276L229.721 64.4507Z"
            fill="#35BE70"
          />
          <path
            d="M224.967 72.1763L223.258 69.9478C223.258 69.9478 223.11 69.6506 223.333 69.5021L224.447 68.8335L226.304 71.5077L224.447 76.4105L223.927 75.7419V75.2962L224.967 72.4734V72.1763Z"
            fill="#35BE70"
          />
          <path
            d="M219.692 68.9078L223.184 66.9021L223.406 67.1992L223.629 67.4964C223.852 67.8678 223.555 68.0164 223.555 68.0164L221.624 69.1306C221.252 69.3535 221.475 69.6506 221.475 69.6506L223.629 72.7706L223.704 73.2906L223.184 74.6277C223.184 74.6277 219.841 69.7249 219.544 69.4278C219.247 69.1306 219.692 68.9078 219.692 68.9078Z"
            fill="#35BE70"
          />
          <path
            d="M214.141 45.3829L234.957 33.6963C235.462 33.404 235.399 32.8941 234.815 32.5567L229.127 28.8975C228.543 28.5608 227.66 28.5238 227.155 28.8161L206.339 40.5028C205.833 40.7943 205.896 41.3042 206.48 41.6416L212.167 45.3008C212.751 45.6382 213.635 45.6752 214.141 45.3829Z"
            fill="url(#paint13_linear_2364_1056)"
          />
          <path
            d="M223.876 115.283V49.7895L228.372 47.3917L239.689 40.6126C240.194 40.3211 241.078 40.3573 241.662 40.6947L243.883 41.8251L253.126 41.8312L253.124 107.639H253.119C253.11 107.817 253.005 107.985 252.785 108.112L232.268 119.791C231.763 120.083 230.879 120.046 230.295 119.709L224.354 115.894C224.05 115.719 223.891 115.497 223.876 115.283Z"
            fill="url(#paint14_linear_2364_1056)"
          />
          <path
            d="M232.27 72.7327L230.471 119.791C231.215 120.058 231.608 120.051 232.27 119.791L232.27 72.7327Z"
            fill="url(#paint15_linear_2364_1056)"
          />
          <path
            d="M247.55 73.3647L244.43 75.1476C243.984 75.4447 244.132 75.7418 244.132 75.7418L244.727 76.3361L245.618 75.8161C245.767 75.7418 245.618 76.1875 245.618 76.1875L244.727 78.7875C244.727 78.7875 242.572 75.6675 242.424 75.3704C242.201 75.0733 242.498 74.9247 242.498 74.9247L249.258 70.9876C249.555 70.8391 249.332 71.3591 249.332 71.3591L243.538 87.2559L242.944 86.6616V86.1416L247.55 73.3647Z"
            fill="#35BE70"
          />
          <path
            d="M242.795 81.0904L241.087 78.8618C241.087 78.8618 240.938 78.5647 241.161 78.4161L242.275 77.7476L244.133 80.4218L242.275 85.3246L241.755 84.656V84.2103L242.795 81.3875V81.0904Z"
            fill="#35BE70"
          />
          <path
            d="M237.521 77.8218L241.012 75.8162L241.235 76.1133L241.458 76.4104C241.681 76.7819 241.384 76.9304 241.384 76.9304L239.452 78.0447C239.081 78.2675 239.304 78.5647 239.304 78.5647L241.458 81.6846L241.532 82.2046L241.012 83.5417C241.012 83.5417 237.67 78.639 237.372 78.3418C237.075 78.0447 237.521 77.8218 237.521 77.8218Z"
            fill="#35BE70"
          />
          <path
            d="M231.969 54.297L252.785 42.6103C253.291 42.3181 253.227 41.8082 252.643 41.4708L246.956 37.8116C246.372 37.4749 245.489 37.4379 244.983 37.7302L224.167 49.4168C223.661 49.7084 223.725 50.2183 224.309 50.5557L229.996 54.2148C230.58 54.5523 231.463 54.5892 231.969 54.297Z"
            fill="url(#paint16_linear_2364_1056)"
          />
          <path
            d="M115.88 142C116.278 142 116.658 141.92 116.942 141.757L118.199 141.031L111.751 137.307L98.6451 129.741L96.2534 131.122L114.497 141.655C114.893 141.883 115.4 142 115.88 142ZM118.623 140.786L144.837 125.651L138.389 121.929L132.684 118.634L116.942 127.724C116.658 127.887 116.278 127.968 115.88 127.968C115.4 127.968 114.893 127.851 114.497 127.622L108.406 124.105L99.07 129.495L112.175 137.062L118.623 140.786ZM95.8285 130.876L98.2193 129.496L35.113 93.0768L29.2949 89.7174L28.038 90.4426C27.4113 90.8047 27.4902 91.4366 28.2136 91.8547L95.8285 130.876ZM98.6451 129.25L107.982 123.861L39.0559 84.0817L29.719 89.4724L35.537 92.8317L98.6451 129.25ZM145.262 125.406L153.577 120.606C154.204 120.243 154.125 119.612 153.401 119.193L142.559 112.933L133.108 118.389L138.813 121.683L145.262 125.406Z"
            fill="#B0C1B8"
          />
          <path
            d="M115.881 127.968C116.278 127.968 116.658 127.887 116.942 127.724L132.684 118.635L133.108 118.39L142.559 112.934L149.971 108.654L150.771 108.193L153.577 106.572C153.85 106.415 153.981 106.205 153.992 105.986H153.998L154 100.183V99.6936L154 98.9049C154 98.9168 153.999 98.9295 153.998 98.9414V98.9838L153.992 98.9872C153.959 99.1797 153.824 99.3603 153.583 99.5011L153.577 99.5045L116.942 120.656C116.937 120.659 116.931 120.662 116.925 120.666C116.92 120.668 116.917 120.67 116.913 120.673C116.634 120.824 116.268 120.9 115.886 120.9H115.881H115.877C115.407 120.9 114.91 120.786 114.519 120.567C114.512 120.562 114.789 120.509 114.782 120.506L20.5347 66.4401C20.5178 66.4308 20.5008 66.4206 20.4847 66.4105C20.4821 66.4096 20.4788 66.4071 20.4788 66.4071L20.4754 66.4045L20.4737 66.4037C20.1785 66.2188 20.0029 65.9966 19.9521 65.7761L19.9419 65.771V72.7509C19.9606 73.0156 20.1582 73.2912 20.5347 73.5083L80.8459 108.193L81.6449 108.655L81.7695 108.727L89.0574 112.934L107.982 123.861L108.406 124.105L114.497 127.622C114.893 127.851 115.4 127.968 115.881 127.968Z"
            fill="url(#paint17_linear_2364_1056)"
          />
          <path
            d="M115.881 120.9H115.886C116.268 120.899 116.634 120.824 116.913 120.672C116.917 120.67 116.921 120.668 116.925 120.666C116.931 120.662 116.937 120.659 116.943 120.655L153.577 99.5043L153.583 99.5009C153.823 99.361 153.955 99.1804 153.989 98.9887L153.992 98.987C153.995 98.9717 153.997 98.9564 153.998 98.9412V98.8411C153.975 98.579 153.774 98.3076 153.402 98.0931L59.4638 43.9941C59.0677 43.7659 58.5614 43.6489 58.0814 43.6489C57.6938 43.6489 57.324 43.7252 57.0433 43.8796C57.0348 43.8846 57.0272 43.8889 57.0196 43.8931L20.3845 65.0442C20.1004 65.2079 19.9613 65.4276 19.9613 65.6574C19.9613 65.6845 19.963 65.7117 19.9672 65.738C19.9697 65.7558 19.9731 65.7736 19.9774 65.7914L19.985 65.7965C20.0376 66.0153 20.2064 66.2358 20.499 66.419L20.5007 66.4198L20.504 66.4224C20.504 66.4224 20.5074 66.4249 20.51 66.4258C20.5261 66.436 20.5431 66.4462 20.56 66.4555L114.497 120.554C114.505 120.558 114.512 120.562 114.519 120.566C114.91 120.786 115.407 120.9 115.877 120.9H115.881ZM58.089 46.1542C58.5148 46.1542 58.9643 46.2577 59.3154 46.4604L149.131 98.1787C149.773 98.5494 149.842 99.1091 149.287 99.4297L116.814 118.179C116.562 118.324 116.225 118.395 115.872 118.395C115.446 118.395 114.997 118.292 114.647 118.089L24.8303 66.3698C24.1891 65.9992 24.1196 65.4394 24.6751 65.1189L57.1476 46.3705C57.3995 46.2246 57.7362 46.1542 58.089 46.1542Z"
            fill="url(#paint18_linear_2364_1056)"
          />
          <path
            d="M115.872 118.395C116.225 118.395 116.561 118.324 116.813 118.179L149.287 99.4297C149.842 99.1092 149.772 98.5494 149.131 98.1788L59.122 46.6135C58.7708 46.4108 58.3213 46.3074 57.8956 46.3074C57.5428 46.3074 57.2061 46.3778 56.9542 46.5236L24.4816 65.272C23.9261 65.5926 23.9957 66.1524 24.6368 66.523L114.305 118.366C114.655 118.568 115.446 118.395 115.872 118.395ZM57.9007 47.895C58.2925 47.895 58.7047 47.9909 59.027 48.1766L146.423 98.2339C147.012 98.574 147.076 99.0879 146.566 99.3831L116.732 116.608C116.5 116.741 116.192 116.807 115.867 116.807C115.476 116.807 115.063 116.712 114.741 116.525L27.3449 66.4687C26.7554 66.1278 26.6918 65.6138 27.2015 65.3187L57.0364 48.0943C57.2671 47.9603 57.5767 47.895 57.9007 47.895Z"
            fill="#808E88"
          />
          <path
            d="M115.867 116.807C116.192 116.807 116.5 116.742 116.732 116.608L146.566 99.3833C147.076 99.0881 147.012 98.5742 146.423 98.2341L58.7992 48.3015C58.4769 48.1157 58.0647 48.0199 57.6729 48.0199C57.3489 48.0199 57.0394 48.0852 56.8087 48.2192L26.9738 65.4435C26.4641 65.7386 26.5277 66.2526 27.1171 66.5936L114.741 116.525C115.063 116.712 115.476 116.807 115.867 116.807Z"
            fill="#AEC7B9"
          />
          <path
            d="M37.9523 67.6029V2.1096L42.4483 -0.288269L53.7657 -7.06731C54.2708 -7.35887 55.1544 -7.3226 55.7382 -6.98518L57.959 -5.85488L67.2021 -5.84872L67.2005 59.9587H67.1954C67.1869 60.1366 67.081 60.305 66.861 60.4323L46.3448 72.1106C45.839 72.4029 44.9555 72.3659 44.3716 72.0292L38.4307 68.2141C38.1268 68.0389 37.9673 67.8171 37.9523 67.6029Z"
            fill="url(#paint19_linear_2364_1056)"
          />
          <path
            d="M46.3447 25.0527L44.5463 72.111C45.2901 72.3778 45.6828 72.371 46.3447 72.111L46.3447 25.0527Z"
            fill="url(#paint20_linear_2364_1056)"
          />
          <path
            d="M61.6245 25.6848L58.5046 27.4676C58.0588 27.7648 58.2074 28.0619 58.2074 28.0619L58.8017 28.6562L59.6931 28.1362C59.8417 28.0619 59.6931 28.5076 59.6931 28.5076L58.8017 31.1076C58.8017 31.1076 56.6474 27.9876 56.4989 27.6905C56.276 27.3933 56.5732 27.2448 56.5732 27.2448L63.333 23.3077C63.6302 23.1591 63.4073 23.6791 63.4073 23.6791L57.6131 39.576L57.0189 38.9817V38.4617L61.6245 25.6848Z"
            fill="#35BE70"
          />
          <path
            d="M56.8704 33.4104L55.1619 31.1819C55.1619 31.1819 55.0133 30.8848 55.2361 30.7362L56.3504 30.0676L58.2075 32.7419L56.3504 37.6446L55.8304 36.9761V36.5304L56.8704 33.7076V33.4104Z"
            fill="#35BE70"
          />
          <path
            d="M51.596 30.1419L55.0874 28.1362L55.3102 28.4334L55.5331 28.7305C55.7559 29.1019 55.4588 29.2505 55.4588 29.2505L53.5274 30.3648C53.156 30.5876 53.3788 30.8848 53.3788 30.8848L55.5331 34.0047L55.6074 34.5247L55.0874 35.8618C55.0874 35.8618 51.7446 30.959 51.4474 30.6619C51.1503 30.3648 51.596 30.1419 51.596 30.1419Z"
            fill="#35BE70"
          />
          <path
            d="M46.0449 6.61704L66.8609 -5.06961C67.3664 -5.36186 67.303 -5.87175 66.7191 -6.20916L61.0316 -9.86834C60.4478 -10.2051 59.5642 -10.242 59.0591 -9.94978L38.2429 1.73689C37.7371 2.02845 37.8008 2.53833 38.3846 2.87575L44.0717 6.53491C44.6555 6.87233 45.5391 6.90929 46.0449 6.61704Z"
            fill="url(#paint21_linear_2364_1056)"
          />
          <path
            d="M56.5626 76.9076V11.4143L61.0586 9.01642L72.376 2.23738C72.8811 1.94582 73.7647 1.98209 74.3485 2.3195L76.5694 3.44981L85.8125 3.45596L85.8109 69.2634H85.8058C85.7972 69.4413 85.6914 69.6097 85.4714 69.737L64.9552 81.4153C64.4494 81.7076 63.5658 81.6706 62.982 81.3339L57.041 77.5188C56.7372 77.3436 56.5777 77.1218 56.5626 76.9076Z"
            fill="url(#paint22_linear_2364_1056)"
          />
          <path
            d="M64.9551 34.3574L63.1567 81.4156C63.9005 81.6825 64.2932 81.6757 64.9551 81.4156L64.9551 34.3574Z"
            fill="url(#paint23_linear_2364_1056)"
          />
          <path
            d="M80.2348 34.9895L77.1149 36.7723C76.6692 37.0695 76.8178 37.3666 76.8178 37.3666L77.412 37.9609L78.3035 37.4409C78.452 37.3666 78.3035 37.8123 78.3035 37.8123L77.412 40.4122C77.412 40.4122 75.2578 37.2923 75.1092 36.9952C74.8864 36.698 75.1835 36.5495 75.1835 36.5495L81.9434 32.6124C82.2405 32.4638 82.0177 32.9838 82.0177 32.9838L76.2235 48.8807L75.6292 48.2864V47.7664L80.2348 34.9895Z"
            fill="#35BE70"
          />
          <path
            d="M75.4808 42.7151L73.7722 40.4866C73.7722 40.4866 73.6236 40.1894 73.8465 40.0409L74.9608 39.3723L76.8179 42.0466L74.9608 46.9493L74.4408 46.2808V45.8351L75.4808 43.0122V42.7151Z"
            fill="#35BE70"
          />
          <path
            d="M70.2061 39.4466L73.6975 37.4409L73.9203 37.7381L74.1432 38.0352C74.366 38.4066 74.0689 38.5552 74.0689 38.5552L72.1375 39.6694C71.7661 39.8923 71.9889 40.1894 71.9889 40.1894L74.1432 43.3094L74.2175 43.8294L73.6975 45.1665C73.6975 45.1665 70.3547 40.2637 70.0576 39.9666C69.7604 39.6694 70.2061 39.4466 70.2061 39.4466Z"
            fill="#35BE70"
          />
          <path
            d="M64.6553 15.9217L85.4712 4.23507C85.9767 3.94283 85.9134 3.43294 85.3295 3.09552L79.642 -0.56365C79.0581 -0.900385 78.1746 -0.93734 77.6695 -0.645092L56.8533 11.0416C56.3475 11.3331 56.4111 11.843 56.9949 12.1804L62.6821 15.8396C63.2659 16.177 64.1495 16.214 64.6553 15.9217Z"
            fill="url(#paint24_linear_2364_1056)"
          />
          <path
            d="M74.3905 85.8219V20.3286L78.8865 17.9307L90.2039 11.1517C90.709 10.8601 91.5926 10.8964 92.1764 11.2338L94.3972 12.3641L103.64 12.3703L103.639 78.1777H103.634C103.625 78.3556 103.519 78.524 103.299 78.6513L82.7831 90.3296C82.2773 90.6219 81.3937 90.5849 80.8099 90.2482L74.8689 86.4331C74.565 86.2579 74.4056 86.0361 74.3905 85.8219Z"
            fill="url(#paint25_linear_2364_1056)"
          />
          <path
            d="M82.7827 43.2717L80.9843 90.33C81.7281 90.5968 82.1208 90.59 82.7827 90.33L82.7827 43.2717Z"
            fill="url(#paint26_linear_2364_1056)"
          />
          <path
            d="M98.0625 43.9038L94.9425 45.6866C94.4968 45.9838 94.6454 46.2809 94.6454 46.2809L95.2397 46.8752L96.1311 46.3552C96.2797 46.2809 96.1311 46.7266 96.1311 46.7266L95.2397 49.3266C95.2397 49.3266 93.0854 46.2066 92.9369 45.9095C92.714 45.6123 93.0111 45.4638 93.0111 45.4638L99.771 41.5267C100.068 41.3781 99.8453 41.8981 99.8453 41.8981L94.0511 57.795L93.4569 57.2007V56.6807L98.0625 43.9038Z"
            fill="#35BE70"
          />
          <path
            d="M93.3084 51.6294L91.5998 49.4009C91.5998 49.4009 91.4513 49.1037 91.6741 48.9552L92.7884 48.2866L94.6455 50.9609L92.7884 55.8636L92.2684 55.1951V54.7494L93.3084 51.9266V51.6294Z"
            fill="#35BE70"
          />
          <path
            d="M88.034 48.3609L91.5254 46.3552L91.7482 46.6524L91.9711 46.9495C92.1939 47.3209 91.8968 47.4695 91.8968 47.4695L89.9654 48.5838C89.594 48.8066 89.8168 49.1037 89.8168 49.1037L91.9711 52.2237L92.0454 52.7437L91.5254 54.0808C91.5254 54.0808 88.1826 49.178 87.8854 48.8809C87.5883 48.5838 88.034 48.3609 88.034 48.3609Z"
            fill="#35BE70"
          />
          <path
            d="M82.4829 24.836L103.299 13.1494C103.804 12.8571 103.741 12.3472 103.157 12.0098L97.4696 8.35066C96.8858 8.01392 96.0022 7.97697 95.4971 8.26921L74.6809 19.9559C74.1751 20.2474 74.2388 20.7573 74.8226 21.0947L80.5097 24.7539C81.0935 25.0913 81.9771 25.1283 82.4829 24.836Z"
            fill="url(#paint27_linear_2364_1056)"
          />
          <path
            d="M89.9894 96.2218V30.7285L94.4854 28.3306L105.803 21.5516C106.308 21.26 107.191 21.2963 107.775 21.6337L109.996 22.764L119.239 22.7702L119.238 88.5776H119.233C119.224 88.7555 119.118 88.9239 118.898 89.0512L98.3819 100.73C97.8762 101.022 96.9926 100.985 96.4088 100.648L90.4678 96.833C90.1639 96.6578 90.0044 96.436 89.9894 96.2218Z"
            fill="url(#paint28_linear_2364_1056)"
          />
          <path
            d="M98.3831 53.6716L96.5847 100.73C97.3284 100.997 97.7211 100.99 98.3831 100.73L98.3831 53.6716Z"
            fill="url(#paint29_linear_2364_1056)"
          />
          <path
            d="M113.663 54.3037L110.543 56.0865C110.097 56.3837 110.246 56.6808 110.246 56.6808L110.84 57.2751L111.731 56.7551C111.88 56.6808 111.731 57.1265 111.731 57.1265L110.84 59.7265C110.84 59.7265 108.686 56.6065 108.537 56.3094C108.314 56.0122 108.611 55.8637 108.611 55.8637L115.371 51.9266C115.669 51.778 115.446 52.298 115.446 52.298L109.651 68.1949L109.057 67.6006V67.0806L113.663 54.3037Z"
            fill="#35BE70"
          />
          <path
            d="M108.909 62.0293L107.2 59.8008C107.2 59.8008 107.052 59.5037 107.274 59.3551L108.389 58.6865L110.246 61.3608L108.389 66.2635L107.869 65.595V65.1493L108.909 62.3265V62.0293Z"
            fill="#35BE70"
          />
          <path
            d="M103.634 58.7608L107.125 56.7551L107.348 57.0523L107.571 57.3494C107.794 57.7208 107.497 57.8694 107.497 57.8694L105.565 58.9837C105.194 59.2065 105.417 59.5036 105.417 59.5036L107.571 62.6236L107.645 63.1436L107.125 64.4807C107.125 64.4807 103.783 59.5779 103.486 59.2808C103.188 58.9837 103.634 58.7608 103.634 58.7608Z"
            fill="#35BE70"
          />
          <path
            d="M98.0825 35.2359L118.898 23.5493C119.404 23.257 119.341 22.7472 118.757 22.4097L113.069 18.7506C112.485 18.4138 111.602 18.3769 111.097 18.6691L90.2805 30.3558C89.7747 30.6473 89.8384 31.1572 90.4222 31.4946L96.1093 35.1538C96.6931 35.4912 97.5767 35.5282 98.0825 35.2359Z"
            fill="url(#paint30_linear_2364_1056)"
          />
          <path
            d="M107.818 105.136V39.6426L112.314 37.2447L123.631 30.4657C124.136 30.1741 125.02 30.2104 125.604 30.5478L127.824 31.6781L137.068 31.6842L137.066 97.4917H137.061C137.052 97.6696 136.946 97.838 136.727 97.9653L116.21 109.644C115.705 109.936 114.821 109.899 114.237 109.562L108.296 105.747C107.992 105.572 107.833 105.35 107.818 105.136Z"
            fill="url(#paint31_linear_2364_1056)"
          />
          <path
            d="M116.211 62.5857L114.413 109.644C115.157 109.911 115.55 109.904 116.211 109.644L116.211 62.5857Z"
            fill="url(#paint32_linear_2364_1056)"
          />
          <path
            d="M131.491 63.2178L128.371 65.0006C127.926 65.2977 128.074 65.5949 128.074 65.5949L128.669 66.1891L129.56 65.6691C129.709 65.5949 129.56 66.0406 129.56 66.0406L128.669 68.6405C128.669 68.6405 126.514 65.5206 126.366 65.2234C126.143 64.9263 126.44 64.7777 126.44 64.7777L133.2 60.8407C133.497 60.6921 133.274 61.2121 133.274 61.2121L127.48 77.1089L126.886 76.5147V75.9947L131.491 63.2178Z"
            fill="#35BE70"
          />
          <path
            d="M126.737 70.9434L125.029 68.7149C125.029 68.7149 124.88 68.4177 125.103 68.2691L126.217 67.6006L128.074 70.2748L126.217 75.1776L125.697 74.509V74.0633L126.737 71.2405V70.9434Z"
            fill="#35BE70"
          />
          <path
            d="M121.463 67.6749L124.954 65.6692L125.177 65.9663L125.4 66.2635C125.623 66.6349 125.326 66.7835 125.326 66.7835L123.394 67.8977C123.023 68.1206 123.246 68.4177 123.246 68.4177L125.4 71.5377L125.474 72.0576L124.954 73.3948C124.954 73.3948 121.612 68.492 121.314 68.1949C121.017 67.8977 121.463 67.6749 121.463 67.6749Z"
            fill="#35BE70"
          />
          <path
            d="M115.911 44.15L136.727 32.4633C137.233 32.1711 137.169 31.6612 136.585 31.3238L130.898 27.6646C130.314 27.3279 129.43 27.2909 128.925 27.5832L108.109 39.2698C107.603 39.5614 107.667 40.0713 108.251 40.4087L113.938 44.0679C114.522 44.4053 115.405 44.4422 115.911 44.15Z"
            fill="url(#paint33_linear_2364_1056)"
          />
          <path
            d="M211.88 210C212.278 210 212.658 209.92 212.942 209.757L214.199 209.031L207.751 205.307L194.645 197.741L192.253 199.122L210.497 209.655C210.893 209.883 211.4 210 211.88 210ZM214.623 208.786L240.837 193.651L234.389 189.929L228.684 186.634L212.942 195.724C212.658 195.887 212.278 195.968 211.88 195.968C211.4 195.968 210.893 195.851 210.497 195.622L204.406 192.105L195.07 197.495L208.175 205.062L214.623 208.786ZM191.829 198.876L194.219 197.496L131.113 161.077L125.295 157.717L124.038 158.443C123.411 158.805 123.49 159.437 124.214 159.855L191.829 198.876ZM194.645 197.25L203.982 191.861L135.056 152.082L125.719 157.472L131.537 160.832L194.645 197.25ZM241.262 193.406L249.577 188.606C250.204 188.243 250.125 187.612 249.401 187.193L238.559 180.933L229.108 186.389L234.813 189.683L241.262 193.406Z"
            fill="#B0C1B8"
          />
          <path
            d="M211.881 195.968C212.278 195.968 212.658 195.887 212.942 195.724L228.684 186.635L229.108 186.39L238.559 180.934L245.971 176.654L246.771 176.193L249.577 174.572C249.85 174.415 249.981 174.205 249.992 173.986H249.998L250 168.183V167.694L250 166.905C250 166.917 249.999 166.929 249.998 166.941V166.984L249.992 166.987C249.959 167.18 249.824 167.36 249.583 167.501L249.577 167.504L212.942 188.656C212.937 188.659 212.931 188.662 212.925 188.666C212.92 188.668 212.917 188.67 212.913 188.673C212.634 188.824 212.268 188.9 211.886 188.9H211.881H211.877C211.407 188.9 210.91 188.786 210.519 188.567C210.512 188.562 210.789 188.509 210.782 188.506L116.535 134.44C116.518 134.431 116.501 134.421 116.485 134.41C116.482 134.41 116.479 134.407 116.479 134.407L116.475 134.405L116.474 134.404C116.179 134.219 116.003 133.997 115.952 133.776L115.942 133.771V140.751C115.961 141.016 116.158 141.291 116.535 141.508L176.846 176.193L177.645 176.655L177.77 176.727L185.057 180.934L203.982 191.861L204.406 192.105L210.497 195.622C210.893 195.851 211.4 195.968 211.881 195.968Z"
            fill="url(#paint34_linear_2364_1056)"
          />
          <path
            d="M211.881 188.9H211.886C212.268 188.899 212.634 188.824 212.913 188.672C212.917 188.67 212.921 188.668 212.925 188.666C212.931 188.662 212.937 188.659 212.943 188.655L249.577 167.504L249.583 167.501C249.823 167.361 249.955 167.18 249.989 166.989L249.992 166.987C249.995 166.972 249.997 166.956 249.998 166.941V166.841C249.975 166.579 249.774 166.308 249.402 166.093L155.464 111.994C155.068 111.766 154.561 111.649 154.081 111.649C153.694 111.649 153.324 111.725 153.043 111.88C153.035 111.885 153.027 111.889 153.02 111.893L116.384 133.044C116.1 133.208 115.961 133.428 115.961 133.657C115.961 133.685 115.963 133.712 115.967 133.738C115.97 133.756 115.973 133.774 115.977 133.791L115.985 133.796C116.038 134.015 116.206 134.236 116.499 134.419L116.501 134.42L116.504 134.422C116.504 134.422 116.507 134.425 116.51 134.426C116.526 134.436 116.543 134.446 116.56 134.455L210.497 188.554C210.505 188.558 210.512 188.562 210.519 188.566C210.91 188.786 211.407 188.9 211.877 188.9H211.881ZM154.089 114.154C154.515 114.154 154.964 114.258 155.315 114.46L245.131 166.179C245.773 166.549 245.842 167.109 245.287 167.43L212.814 186.179C212.562 186.324 212.225 186.395 211.872 186.395C211.446 186.395 210.997 186.292 210.647 186.089L120.83 134.37C120.189 133.999 120.12 133.439 120.675 133.119L153.148 114.37C153.4 114.225 153.736 114.154 154.089 114.154Z"
            fill="url(#paint35_linear_2364_1056)"
          />
          <path
            d="M211.872 186.395C212.225 186.395 212.561 186.324 212.813 186.179L245.287 167.43C245.842 167.109 245.772 166.549 245.131 166.179L155.122 114.614C154.771 114.411 154.321 114.307 153.896 114.307C153.543 114.307 153.206 114.378 152.954 114.524L120.482 133.272C119.926 133.593 119.996 134.152 120.637 134.523L210.305 186.366C210.655 186.568 211.446 186.395 211.872 186.395ZM153.901 115.895C154.292 115.895 154.705 115.991 155.027 116.177L242.423 166.234C243.012 166.574 243.076 167.088 242.566 167.383L212.732 184.608C212.5 184.741 212.192 184.807 211.867 184.807C211.476 184.807 211.063 184.712 210.741 184.525L123.345 134.469C122.755 134.128 122.692 133.614 123.202 133.319L153.036 116.094C153.267 115.96 153.577 115.895 153.901 115.895Z"
            fill="#808E88"
          />
          <path
            d="M211.867 184.807C212.192 184.807 212.5 184.742 212.732 184.608L242.566 167.383C243.076 167.088 243.012 166.574 242.423 166.234L154.799 116.301C154.477 116.116 154.065 116.02 153.673 116.02C153.349 116.02 153.039 116.085 152.809 116.219L122.974 133.444C122.464 133.739 122.528 134.253 123.117 134.594L210.741 184.525C211.063 184.712 211.476 184.807 211.867 184.807Z"
            fill="#AEC7B9"
          />
          <path
            d="M133.952 135.603V70.1096L138.448 67.7117L149.766 60.9327C150.271 60.6411 151.154 60.6774 151.738 61.0148L153.959 62.1451L163.202 62.1513L163.201 127.959H163.195C163.187 128.137 163.081 128.305 162.861 128.432L142.345 140.111C141.839 140.403 140.955 140.366 140.372 140.029L134.431 136.214C134.127 136.039 133.967 135.817 133.952 135.603Z"
            fill="url(#paint36_linear_2364_1056)"
          />
          <path
            d="M142.345 93.0527L140.546 140.111C141.29 140.378 141.683 140.371 142.345 140.111L142.345 93.0527Z"
            fill="url(#paint37_linear_2364_1056)"
          />
          <path
            d="M157.624 93.6848L154.505 95.4676C154.059 95.7648 154.207 96.0619 154.207 96.0619L154.802 96.6562L155.693 96.1362C155.842 96.0619 155.693 96.5076 155.693 96.5076L154.802 99.1076C154.802 99.1076 152.647 95.9876 152.499 95.6905C152.276 95.3933 152.573 95.2448 152.573 95.2448L159.333 91.3077C159.63 91.1591 159.407 91.6791 159.407 91.6791L153.613 107.576L153.019 106.982V106.462L157.624 93.6848Z"
            fill="#35BE70"
          />
          <path
            d="M152.87 101.41L151.162 99.1819C151.162 99.1819 151.013 98.8848 151.236 98.7362L152.35 98.0676L154.208 100.742L152.35 105.645L151.83 104.976V104.53L152.87 101.708V101.41Z"
            fill="#35BE70"
          />
          <path
            d="M147.596 98.1419L151.087 96.1362L151.31 96.4334L151.533 96.7305C151.756 97.1019 151.459 97.2505 151.459 97.2505L149.527 98.3648C149.156 98.5876 149.379 98.8848 149.379 98.8848L151.533 102.005L151.607 102.525L151.087 103.862C151.087 103.862 147.745 98.959 147.447 98.6619C147.15 98.3648 147.596 98.1419 147.596 98.1419Z"
            fill="#35BE70"
          />
          <path
            d="M142.045 74.617L162.861 62.9304C163.366 62.6381 163.303 62.1283 162.719 61.7908L157.032 58.1317C156.448 57.7949 155.564 57.758 155.059 58.0502L134.243 69.7369C133.737 70.0284 133.801 70.5383 134.385 70.8758L140.072 74.5349C140.656 74.8723 141.539 74.9093 142.045 74.617Z"
            fill="url(#paint38_linear_2364_1056)"
          />
          <path
            d="M152.563 144.908V79.4143L157.059 77.0164L168.376 70.2374C168.881 69.9458 169.765 69.9821 170.349 70.3195L172.569 71.4498L181.812 71.456L181.811 137.263H181.806C181.797 137.441 181.691 137.61 181.471 137.737L160.955 149.415C160.449 149.708 159.566 149.671 158.982 149.334L153.041 145.519C152.737 145.344 152.578 145.122 152.563 144.908Z"
            fill="url(#paint39_linear_2364_1056)"
          />
          <path
            d="M160.955 102.357L159.157 149.416C159.9 149.682 160.293 149.676 160.955 149.416L160.955 102.357Z"
            fill="url(#paint40_linear_2364_1056)"
          />
          <path
            d="M176.235 102.989L173.115 104.772C172.669 105.069 172.818 105.367 172.818 105.367L173.412 105.961L174.303 105.441C174.452 105.367 174.303 105.812 174.303 105.812L173.412 108.412C173.412 108.412 171.258 105.292 171.109 104.995C170.886 104.698 171.184 104.549 171.184 104.549L177.943 100.612C178.241 100.464 178.018 100.984 178.018 100.984L172.223 116.881L171.629 116.286V115.766L176.235 102.989Z"
            fill="#35BE70"
          />
          <path
            d="M171.481 110.715L169.772 108.487C169.772 108.487 169.624 108.189 169.846 108.041L170.961 107.372L172.818 110.047L170.961 114.949L170.441 114.281V113.835L171.481 111.012V110.715Z"
            fill="#35BE70"
          />
          <path
            d="M166.206 107.447L169.697 105.441L169.92 105.738L170.143 106.035C170.366 106.407 170.069 106.555 170.069 106.555L168.138 107.669C167.766 107.892 167.989 108.189 167.989 108.189L170.143 111.309L170.217 111.829L169.697 113.166C169.697 113.166 166.355 108.264 166.058 107.967C165.76 107.669 166.206 107.447 166.206 107.447Z"
            fill="#35BE70"
          />
          <path
            d="M160.655 83.9217L181.471 72.2351C181.977 71.9428 181.913 71.4329 181.329 71.0955L175.642 67.4363C175.058 67.0996 174.175 67.0627 173.669 67.3549L152.853 79.0416C152.347 79.3331 152.411 79.843 152.995 80.1804L158.682 83.8396C159.266 84.177 160.149 84.214 160.655 83.9217Z"
            fill="url(#paint41_linear_2364_1056)"
          />
          <path
            d="M170.391 153.822V88.3286L174.887 85.9307L186.204 79.1517C186.709 78.8601 187.593 78.8964 188.176 79.2338L190.397 80.3641L199.64 80.3703L199.639 146.178H199.634C199.625 146.356 199.519 146.524 199.299 146.651L178.783 158.33C178.277 158.622 177.394 158.585 176.81 158.248L170.869 154.433C170.565 154.258 170.406 154.036 170.391 153.822Z"
            fill="url(#paint42_linear_2364_1056)"
          />
          <path
            d="M178.783 111.272L176.984 158.33C177.728 158.597 178.121 158.59 178.783 158.33L178.783 111.272Z"
            fill="url(#paint43_linear_2364_1056)"
          />
          <path
            d="M194.062 111.904L190.943 113.687C190.497 113.984 190.645 114.281 190.645 114.281L191.24 114.875L192.131 114.355C192.28 114.281 192.131 114.727 192.131 114.727L191.24 117.327C191.24 117.327 189.085 114.207 188.937 113.909C188.714 113.612 189.011 113.464 189.011 113.464L195.771 109.527C196.068 109.378 195.845 109.898 195.845 109.898L190.051 125.795L189.457 125.201V124.681L194.062 111.904Z"
            fill="#35BE70"
          />
          <path
            d="M189.308 119.629L187.6 117.401C187.6 117.401 187.451 117.104 187.674 116.955L188.788 116.287L190.646 118.961L188.788 123.864L188.268 123.195V122.749L189.308 119.927V119.629Z"
            fill="#35BE70"
          />
          <path
            d="M184.034 116.361L187.525 114.355L187.748 114.652L187.971 114.949C188.194 115.321 187.897 115.469 187.897 115.469L185.965 116.584C185.594 116.807 185.817 117.104 185.817 117.104L187.971 120.224L188.045 120.744L187.525 122.081C187.525 122.081 184.183 117.178 183.885 116.881C183.588 116.584 184.034 116.361 184.034 116.361Z"
            fill="#35BE70"
          />
          <path
            d="M178.483 92.836L199.299 81.1494C199.804 80.8571 199.741 80.3472 199.157 80.0098L193.47 76.3507C192.886 76.0139 192.002 75.977 191.497 76.2692L170.681 87.9559C170.175 88.2474 170.239 88.7573 170.823 89.0947L176.51 92.7539C177.094 93.0913 177.977 93.1283 178.483 92.836Z"
            fill="url(#paint44_linear_2364_1056)"
          />
          <path
            d="M185.989 164.222V98.7285L190.485 96.3306L201.803 89.5516C202.308 89.26 203.191 89.2963 203.775 89.6337L205.996 90.764L215.239 90.7702L215.238 156.578H215.233C215.224 156.756 215.118 156.924 214.898 157.051L194.382 168.73C193.876 169.022 192.993 168.985 192.409 168.648L186.468 164.833C186.164 164.658 186.004 164.436 185.989 164.222Z"
            fill="url(#paint45_linear_2364_1056)"
          />
          <path
            d="M194.383 121.672L192.585 168.73C193.328 168.997 193.721 168.99 194.383 168.73L194.383 121.672Z"
            fill="url(#paint46_linear_2364_1056)"
          />
          <path
            d="M209.663 122.304L206.543 124.087C206.097 124.384 206.246 124.681 206.246 124.681L206.84 125.275L207.731 124.755C207.88 124.681 207.731 125.127 207.731 125.127L206.84 127.726C206.84 127.726 204.686 124.607 204.537 124.309C204.314 124.012 204.611 123.864 204.611 123.864L211.371 119.927C211.669 119.778 211.446 120.298 211.446 120.298L205.651 136.195L205.057 135.601V135.081L209.663 122.304Z"
            fill="#35BE70"
          />
          <path
            d="M204.909 130.029L203.2 127.801C203.2 127.801 203.052 127.504 203.274 127.355L204.389 126.687L206.246 129.361L204.389 134.264L203.869 133.595V133.149L204.909 130.326V130.029Z"
            fill="#35BE70"
          />
          <path
            d="M199.634 126.761L203.125 124.755L203.348 125.052L203.571 125.349C203.794 125.721 203.497 125.869 203.497 125.869L201.565 126.984C201.194 127.207 201.417 127.504 201.417 127.504L203.571 130.624L203.645 131.144L203.125 132.481C203.125 132.481 199.783 127.578 199.486 127.281C199.188 126.984 199.634 126.761 199.634 126.761Z"
            fill="#35BE70"
          />
          <path
            d="M194.082 103.236L214.898 91.5493C215.404 91.257 215.341 90.7472 214.757 90.4097L209.069 86.7506C208.485 86.4138 207.602 86.3769 207.097 86.6691L186.281 98.3558C185.775 98.6473 185.838 99.1572 186.422 99.4946L192.109 103.154C192.693 103.491 193.577 103.528 194.082 103.236Z"
            fill="url(#paint47_linear_2364_1056)"
          />
          <path
            d="M203.818 173.136V107.643L208.314 105.245L219.631 98.4657C220.136 98.1741 221.02 98.2104 221.604 98.5478L223.824 99.6781L233.068 99.6842L233.066 165.492H233.061C233.052 165.67 232.946 165.838 232.727 165.965L212.21 177.644C211.705 177.936 210.821 177.899 210.237 177.562L204.296 173.747C203.992 173.572 203.833 173.35 203.818 173.136Z"
            fill="url(#paint48_linear_2364_1056)"
          />
          <path
            d="M212.211 130.586L210.413 177.644C211.157 177.911 211.55 177.904 212.211 177.644L212.211 130.586Z"
            fill="url(#paint49_linear_2364_1056)"
          />
          <path
            d="M227.491 131.218L224.371 133.001C223.926 133.298 224.074 133.595 224.074 133.595L224.669 134.189L225.56 133.669C225.709 133.595 225.56 134.041 225.56 134.041L224.669 136.641C224.669 136.641 222.514 133.521 222.366 133.223C222.143 132.926 222.44 132.778 222.44 132.778L229.2 128.841C229.497 128.692 229.274 129.212 229.274 129.212L223.48 145.109L222.886 144.515V143.995L227.491 131.218Z"
            fill="#35BE70"
          />
          <path
            d="M222.737 138.943L221.029 136.715C221.029 136.715 220.88 136.418 221.103 136.269L222.217 135.601L224.074 138.275L222.217 143.178L221.697 142.509V142.063L222.737 139.241V138.943Z"
            fill="#35BE70"
          />
          <path
            d="M217.463 135.675L220.954 133.669L221.177 133.966L221.4 134.263C221.623 134.635 221.326 134.783 221.326 134.783L219.394 135.898C219.023 136.121 219.246 136.418 219.246 136.418L221.4 139.538L221.474 140.058L220.954 141.395C220.954 141.395 217.612 136.492 217.314 136.195C217.017 135.898 217.463 135.675 217.463 135.675Z"
            fill="#35BE70"
          />
          <path
            d="M211.911 112.15L232.727 100.463C233.233 100.171 233.169 99.6612 232.585 99.3238L226.898 95.6646C226.314 95.3279 225.43 95.2909 224.925 95.5832L204.109 107.27C203.603 107.561 203.667 108.071 204.251 108.409L209.938 112.068C210.522 112.405 211.405 112.442 211.911 112.15Z"
            fill="url(#paint50_linear_2364_1056)"
          />
          <path
            d="M95.9386 200.147C96.3363 200.147 96.7163 200.067 97.0004 199.904L98.2573 199.178L91.8091 195.454L78.7032 187.888L76.3115 189.269L94.5553 199.802C94.9513 200.03 95.4577 200.147 95.9386 200.147ZM98.6813 198.932L124.895 183.798L118.447 180.076L112.742 176.781L97.0004 185.871C96.7163 186.034 96.3363 186.115 95.9386 186.115C95.4577 186.115 94.9513 185.998 94.5553 185.769L88.4641 182.252L79.1281 187.642L92.2332 195.209L98.6813 198.932ZM75.8866 189.023L78.2775 187.643L15.1711 151.224L9.35303 147.864L8.09613 148.59C7.46938 148.952 7.54826 149.584 8.2717 150.002L75.8866 189.023ZM78.7032 187.397L88.0401 182.008L19.114 142.229L9.7771 147.619L15.5952 150.979L78.7032 187.397ZM125.32 183.553L133.635 178.752C134.262 178.39 134.183 177.759 133.46 177.34L122.617 171.08L113.166 176.536L118.871 179.83L125.32 183.553Z"
            fill="#B0C1B8"
          />
          <path
            d="M95.9387 186.115C96.3365 186.115 96.7165 186.034 97.0006 185.871L112.742 176.782L113.166 176.537L122.617 171.08L130.03 166.801L130.829 166.34L133.635 164.719C133.908 164.562 134.039 164.352 134.05 164.133H134.056L134.058 158.33V157.841L134.058 157.052C134.058 157.064 134.057 157.076 134.056 157.088V157.131L134.05 157.134C134.017 157.327 133.882 157.507 133.641 157.648L133.635 157.651L97.0006 178.803C96.9946 178.806 96.9887 178.809 96.9828 178.813C96.9785 178.815 96.9751 178.817 96.9709 178.82C96.6919 178.971 96.3263 179.047 95.9438 179.047H95.9387H95.9353C95.4646 179.047 94.9685 178.933 94.5767 178.714C94.5699 178.709 94.8473 178.656 94.8397 178.652L0.592834 124.587C0.575867 124.578 0.558914 124.568 0.542801 124.557C0.540253 124.557 0.536865 124.554 0.536865 124.554L0.533463 124.551L0.531769 124.551C0.236618 124.366 0.0610504 124.144 0.0101776 123.923L0 123.918V130.898C0.0186615 131.163 0.216263 131.438 0.592834 131.655L60.904 166.34L61.703 166.802L61.8276 166.874L69.1155 171.081L88.0403 182.008L88.4643 182.252L94.5555 185.769C94.9515 185.998 95.4579 186.115 95.9387 186.115Z"
            fill="url(#paint51_linear_2364_1056)"
          />
          <path
            d="M95.9388 179.047H95.9439C96.3264 179.046 96.692 178.971 96.971 178.819C96.9752 178.817 96.9786 178.815 96.9829 178.813C96.9888 178.809 96.9947 178.806 97.0007 178.802L133.635 157.651L133.641 157.648C133.881 157.508 134.013 157.327 134.047 157.136L134.05 157.134C134.053 157.119 134.055 157.103 134.056 157.088V156.988C134.033 156.726 133.832 156.455 133.46 156.24L39.5219 102.141C39.1258 101.913 38.6195 101.796 38.1395 101.796C37.7519 101.796 37.3821 101.872 37.1014 102.027C37.0929 102.032 37.0853 102.036 37.0777 102.04L0.442581 123.191C0.158463 123.355 0.0193634 123.575 0.0193634 123.804C0.0193634 123.832 0.0210724 123.859 0.0252991 123.885C0.0278473 123.903 0.03125 123.921 0.0354919 123.938L0.0431213 123.943C0.0957031 124.162 0.264481 124.383 0.557083 124.566L0.558762 124.567L0.562149 124.569C0.562149 124.569 0.565552 124.572 0.5681 124.573C0.584213 124.583 0.601181 124.593 0.618149 124.602L94.5555 178.701C94.5632 178.705 94.57 178.709 94.5767 178.713C94.9686 178.933 95.4647 179.047 95.9354 179.047H95.9388ZM38.1471 104.301C38.5729 104.301 39.0224 104.405 39.3735 104.607L129.19 156.326C129.831 156.696 129.9 157.256 129.345 157.577L96.8717 176.326C96.6199 176.471 96.2832 176.542 95.9303 176.542C95.5046 176.542 95.0551 176.439 94.7048 176.236L4.88838 124.517C4.24721 124.146 4.17767 123.586 4.73318 123.266L37.2057 104.517C37.4576 104.372 37.7943 104.301 38.1471 104.301Z"
            fill="url(#paint52_linear_2364_1056)"
          />
          <path
            d="M95.93 176.542C96.2828 176.542 96.6195 176.471 96.8714 176.326L129.345 157.577C129.9 157.256 129.831 156.696 129.189 156.326L39.1801 104.761C38.8289 104.558 38.3794 104.454 37.9537 104.454C37.6009 104.454 37.2642 104.525 37.0123 104.671L4.53974 123.419C3.98423 123.74 4.05377 124.299 4.69495 124.67L94.3627 176.513C94.713 176.715 95.5043 176.542 95.93 176.542ZM37.9588 106.042C38.3506 106.042 38.7628 106.138 39.0851 106.324L126.481 156.381C127.07 156.721 127.134 157.235 126.624 157.53L96.79 174.755C96.5585 174.888 96.2498 174.954 95.9249 174.954C95.534 174.954 95.1209 174.859 94.7987 174.672L7.40298 124.616C6.81354 124.275 6.74992 123.761 7.25964 123.466L37.0946 106.241C37.3252 106.107 37.6348 106.042 37.9588 106.042Z"
            fill="#808E88"
          />
          <path
            d="M95.9251 174.954C96.2499 174.954 96.5586 174.889 96.7901 174.755L126.624 157.53C127.134 157.235 127.07 156.721 126.481 156.381L38.8573 106.448C38.535 106.263 38.1228 106.167 37.731 106.167C37.407 106.167 37.0975 106.232 36.8668 106.366L7.03187 123.59C6.52216 123.886 6.58577 124.4 7.17521 124.741L94.7988 174.672C95.1211 174.859 95.5341 174.954 95.9251 174.954Z"
            fill="#AEC7B9"
          />
          <path
            d="M18.0104 125.75V60.2566L22.5064 57.8587L33.8238 51.0797C34.3289 50.7881 35.2125 50.8244 35.7963 51.1618L38.0171 52.2921L47.2603 52.2982L47.2586 118.106H47.2535C47.245 118.284 47.1391 118.452 46.9191 118.579L26.4029 130.258C25.8971 130.55 25.0136 130.513 24.4297 130.176L18.4888 126.361C18.1849 126.186 18.0254 125.964 18.0104 125.75Z"
            fill="url(#paint53_linear_2364_1056)"
          />
          <path
            d="M26.4028 83.1997L24.6044 130.258C25.3482 130.525 25.7409 130.518 26.4028 130.258L26.4028 83.1997Z"
            fill="url(#paint54_linear_2364_1056)"
          />
          <path
            d="M41.6826 83.8318L38.5627 85.6146C38.117 85.9117 38.2655 86.2089 38.2655 86.2089L38.8598 86.8031L39.7512 86.2832C39.8998 86.2089 39.7512 86.6546 39.7512 86.6546L38.8598 89.2545C38.8598 89.2545 36.7056 86.1346 36.557 85.8375C36.3341 85.5403 36.6313 85.3917 36.6313 85.3917L43.3911 81.4547C43.6883 81.3061 43.4654 81.8261 43.4654 81.8261L37.6712 97.7229L37.077 97.1287V96.6087L41.6826 83.8318Z"
            fill="#35BE70"
          />
          <path
            d="M36.9285 91.5574L35.22 89.3289C35.22 89.3289 35.0714 89.0317 35.2943 88.8832L36.4085 88.2146L38.2656 90.8888L36.4085 95.7916L35.8885 95.123V94.6773L36.9285 91.8545V91.5574Z"
            fill="#35BE70"
          />
          <path
            d="M31.6541 88.2889L35.1455 86.2832L35.3683 86.5803L35.5912 86.8775C35.814 87.2489 35.5169 87.3975 35.5169 87.3975L33.5855 88.5117C33.2141 88.7346 33.4369 89.0317 33.4369 89.0317L35.5912 92.1517L35.6655 92.6717L35.1455 94.0088C35.1455 94.0088 31.8027 89.106 31.5056 88.8089C31.2084 88.5117 31.6541 88.2889 31.6541 88.2889Z"
            fill="#35BE70"
          />
          <path
            d="M26.103 64.764L46.919 53.0774C47.4245 52.7851 47.3611 52.2752 46.7772 51.9378L41.0897 48.2786C40.5059 47.9419 39.6223 47.9049 39.1172 48.1972L18.301 59.8839C17.7952 60.1754 17.8589 60.6853 18.4427 61.0227L24.1298 64.6819C24.7136 65.0193 25.5972 65.0563 26.103 64.764Z"
            fill="url(#paint55_linear_2364_1056)"
          />
          <path
            d="M36.6207 135.055V69.5613L41.1167 67.1634L52.4341 60.3844C52.9392 60.0928 53.8228 60.1291 54.4066 60.4665L56.6275 61.5968L65.8706 61.6029L65.869 127.41H65.8639C65.8553 127.588 65.7495 127.757 65.5295 127.884L45.0133 139.562C44.5075 139.855 43.6239 139.818 43.0401 139.481L37.0991 135.666C36.7953 135.491 36.6358 135.269 36.6207 135.055Z"
            fill="url(#paint56_linear_2364_1056)"
          />
          <path
            d="M45.0132 92.5044L43.2148 139.563C43.9586 139.829 44.3513 139.823 45.0132 139.563L45.0132 92.5044Z"
            fill="url(#paint57_linear_2364_1056)"
          />
          <path
            d="M60.293 93.1365L57.173 94.9193C56.7273 95.2164 56.8759 95.5136 56.8759 95.5136L57.4701 96.1078L58.3616 95.5878C58.5101 95.5136 58.3616 95.9593 58.3616 95.9593L57.4701 98.5592C57.4701 98.5592 55.3159 95.4393 55.1673 95.1421C54.9445 94.845 55.2416 94.6964 55.2416 94.6964L62.0015 90.7594C62.2986 90.6108 62.0758 91.1308 62.0758 91.1308L56.2816 107.028L55.6873 106.433V105.913L60.293 93.1365Z"
            fill="#35BE70"
          />
          <path
            d="M55.5389 100.862L53.8303 98.6336C53.8303 98.6336 53.6817 98.3364 53.9046 98.1878L55.0189 97.5193L56.876 100.194L55.0189 105.096L54.4989 104.428V103.982L55.5389 101.159V100.862Z"
            fill="#35BE70"
          />
          <path
            d="M50.2642 97.5936L53.7556 95.5879L53.9784 95.885L54.2013 96.1822C54.4242 96.5536 54.127 96.7022 54.127 96.7022L52.1956 97.8164C51.8242 98.0393 52.0471 98.3364 52.0471 98.3364L54.2013 101.456L54.2756 101.976L53.7556 103.313C53.7556 103.313 50.4128 98.4107 50.1157 98.1136C49.8185 97.8164 50.2642 97.5936 50.2642 97.5936Z"
            fill="#35BE70"
          />
          <path
            d="M44.7134 74.0687L65.5293 62.382C66.0349 62.0898 65.9715 61.5799 65.3876 61.2425L59.7001 57.5833C59.1163 57.2466 58.2327 57.2096 57.7276 57.5019L36.9114 69.1885C36.4056 69.4801 36.4692 69.99 37.0531 70.3274L42.7402 73.9866C43.324 74.324 44.2076 74.3609 44.7134 74.0687Z"
            fill="url(#paint58_linear_2364_1056)"
          />
          <path
            d="M54.4486 143.969V78.4756L58.9446 76.0777L70.262 69.2987C70.7671 69.0071 71.6507 69.0434 72.2345 69.3808L74.4553 70.5111L83.6985 70.5172L83.6968 136.325H83.6918C83.6832 136.503 83.5773 136.671 83.3574 136.798L62.8412 148.477C62.3354 148.769 61.4518 148.732 60.868 148.395L54.927 144.58C54.6231 144.405 54.4637 144.183 54.4486 143.969Z"
            fill="url(#paint59_linear_2364_1056)"
          />
          <path
            d="M62.8408 101.419L61.0424 148.477C61.7862 148.744 62.1789 148.737 62.8408 148.477L62.8408 101.419Z"
            fill="url(#paint60_linear_2364_1056)"
          />
          <path
            d="M78.1206 102.051L75.0006 103.834C74.5549 104.131 74.7035 104.428 74.7035 104.428L75.2978 105.022L76.1892 104.502C76.3378 104.428 76.1892 104.874 76.1892 104.874L75.2978 107.474C75.2978 107.474 73.1435 104.354 72.995 104.056C72.7721 103.759 73.0693 103.611 73.0693 103.611L79.8291 99.6737C80.1263 99.5251 79.9034 100.045 79.9034 100.045L74.1092 115.942L73.515 115.348V114.828L78.1206 102.051Z"
            fill="#35BE70"
          />
          <path
            d="M73.3665 109.776L71.658 107.548C71.658 107.548 71.5094 107.251 71.7322 107.102L72.8465 106.434L74.7036 109.108L72.8465 114.011L72.3265 113.342V112.896L73.3665 110.074V109.776Z"
            fill="#35BE70"
          />
          <path
            d="M68.0921 106.508L71.5835 104.502L71.8063 104.799L72.0292 105.096C72.252 105.468 71.9549 105.616 71.9549 105.616L70.0235 106.731C69.6521 106.954 69.8749 107.251 69.8749 107.251L72.0292 110.371L72.1035 110.891L71.5835 112.228C71.5835 112.228 68.2407 107.325 67.9435 107.028C67.6464 106.731 68.0921 106.508 68.0921 106.508Z"
            fill="#35BE70"
          />
          <path
            d="M62.541 82.983L83.357 71.2964C83.8625 71.0041 83.7991 70.4942 83.2152 70.1568L77.5277 66.4976C76.9439 66.1609 76.0603 66.1239 75.5552 66.4162L54.739 78.1029C54.2332 78.3944 54.2969 78.9043 54.8807 79.2417L60.5678 82.9009C61.1516 83.2383 62.0352 83.2753 62.541 82.983Z"
            fill="url(#paint61_linear_2364_1056)"
          />
          <path
            d="M70.0475 154.369V88.8755L74.5435 86.4776L85.8609 79.6986C86.366 79.407 87.2496 79.4433 87.8334 79.7807L90.0542 80.911L99.2974 80.9171L99.2957 146.725H99.2907C99.2821 146.903 99.1762 147.071 98.9562 147.198L78.44 158.876C77.9343 159.169 77.0507 159.132 76.4669 158.795L70.5259 154.98C70.222 154.805 70.0625 154.583 70.0475 154.369Z"
            fill="url(#paint62_linear_2364_1056)"
          />
          <path
            d="M78.4412 111.819L76.6428 158.877C77.3865 159.144 77.7792 159.137 78.4412 158.877L78.4412 111.819Z"
            fill="url(#paint63_linear_2364_1056)"
          />
          <path
            d="M93.7209 112.451L90.601 114.233C90.1553 114.531 90.3039 114.828 90.3039 114.828L90.8981 115.422L91.7895 114.902C91.9381 114.828 91.7895 115.273 91.7895 115.273L90.8981 117.873C90.8981 117.873 88.7439 114.753 88.5953 114.456C88.3725 114.159 88.6696 114.011 88.6696 114.011L95.4295 110.074C95.7266 109.925 95.5038 110.445 95.5038 110.445L89.7096 126.342L89.1153 125.748V125.228L93.7209 112.451Z"
            fill="#35BE70"
          />
          <path
            d="M88.9668 120.176L87.2583 117.948C87.2583 117.948 87.1097 117.651 87.3326 117.502L88.4468 116.833L90.304 119.508L88.4468 124.411L87.9269 123.742V123.296L88.9668 120.473V120.176Z"
            fill="#35BE70"
          />
          <path
            d="M83.6922 116.908L87.1836 114.902L87.4064 115.199L87.6293 115.496C87.8521 115.868 87.555 116.016 87.555 116.016L85.6236 117.131C85.2522 117.353 85.475 117.651 85.475 117.651L87.6293 120.771L87.7036 121.291L87.1836 122.628C87.1836 122.628 83.8408 117.725 83.5436 117.428C83.2465 117.131 83.6922 116.908 83.6922 116.908Z"
            fill="#35BE70"
          />
          <path
            d="M78.1406 93.3829L98.9566 81.6963C99.4621 81.404 99.3987 80.8941 98.8148 80.5567L93.1273 76.8975C92.5435 76.5608 91.6599 76.5238 91.1548 76.8161L70.3386 88.5028C69.8328 88.7943 69.8965 89.3042 70.4803 89.6416L76.1674 93.3008C76.7512 93.6382 77.6348 93.6752 78.1406 93.3829Z"
            fill="url(#paint64_linear_2364_1056)"
          />
          <path
            d="M87.8759 163.283V97.7895L92.3719 95.3917L103.689 88.6126C104.194 88.3211 105.078 88.3573 105.662 88.6947L107.883 89.8251L117.126 89.8312L117.124 155.639H117.119C117.11 155.817 117.005 155.985 116.785 156.112L96.2684 167.791C95.7626 168.083 94.879 168.046 94.2952 167.709L88.3543 163.894C88.0504 163.719 87.8909 163.497 87.8759 163.283Z"
            fill="url(#paint65_linear_2364_1056)"
          />
          <path
            d="M96.2695 120.733L94.4711 167.791C95.2149 168.058 95.6076 168.051 96.2695 167.791L96.2695 120.733Z"
            fill="url(#paint66_linear_2364_1056)"
          />
          <path
            d="M111.55 121.365L108.43 123.148C107.984 123.445 108.132 123.742 108.132 123.742L108.727 124.336L109.618 123.816C109.767 123.742 109.618 124.188 109.618 124.188L108.727 126.787C108.727 126.787 106.572 123.668 106.424 123.37C106.201 123.073 106.498 122.925 106.498 122.925L113.258 118.988C113.555 118.839 113.332 119.359 113.332 119.359L107.538 135.256L106.944 134.662V134.142L111.55 121.365Z"
            fill="#35BE70"
          />
          <path
            d="M106.795 129.09L105.087 126.862C105.087 126.862 104.938 126.565 105.161 126.416L106.275 125.748L108.133 128.422L106.275 133.325L105.755 132.656V132.21L106.795 129.387V129.09Z"
            fill="#35BE70"
          />
          <path
            d="M101.521 125.822L105.012 123.816L105.235 124.113L105.458 124.41C105.681 124.782 105.384 124.93 105.384 124.93L103.452 126.045C103.081 126.268 103.304 126.565 103.304 126.565L105.458 129.685L105.532 130.205L105.012 131.542C105.012 131.542 101.67 126.639 101.372 126.342C101.075 126.045 101.521 125.822 101.521 125.822Z"
            fill="#35BE70"
          />
          <path
            d="M95.9692 102.297L116.785 90.6103C117.291 90.3181 117.227 89.8082 116.643 89.4708L110.956 85.8116C110.372 85.4749 109.489 85.4379 108.983 85.7302L88.1672 97.4168C87.6614 97.7084 87.7251 98.2183 88.3089 98.5557L93.996 102.215C94.5798 102.552 95.4634 102.589 95.9692 102.297Z"
            fill="url(#paint67_linear_2364_1056)"
          />
          {/* <rect x="170" y="60" width="80" height="80" rx="40" fill="#35BE70"/> */}
          {/* <path d="M182.65 91.0938L186.396 98.0391L190.143 91.0938H194.832L189.049 100.965L194.982 111H190.252L186.396 103.918L182.541 111H177.783L183.73 100.965L177.934 91.0938H182.65ZM206.234 91.0527V111H202.297V95.5918L197.566 97.0957V93.9922L205.811 91.0527H206.234ZM226.113 99.2969V102.742C226.113 104.237 225.954 105.527 225.635 106.611C225.316 107.687 224.855 108.571 224.254 109.264C223.661 109.947 222.955 110.453 222.135 110.781C221.314 111.109 220.403 111.273 219.4 111.273C218.598 111.273 217.851 111.173 217.158 110.973C216.465 110.763 215.841 110.439 215.285 110.002C214.738 109.564 214.264 109.013 213.863 108.348C213.471 107.673 213.171 106.871 212.961 105.941C212.751 105.012 212.646 103.945 212.646 102.742V99.2969C212.646 97.8021 212.806 96.5215 213.125 95.4551C213.453 94.3796 213.913 93.5 214.506 92.8164C215.107 92.1328 215.818 91.6315 216.639 91.3125C217.459 90.9844 218.37 90.8203 219.373 90.8203C220.175 90.8203 220.918 90.9251 221.602 91.1348C222.294 91.3353 222.919 91.6497 223.475 92.0781C224.031 92.5065 224.505 93.0579 224.896 93.7324C225.288 94.3978 225.589 95.1953 225.799 96.125C226.008 97.0456 226.113 98.1029 226.113 99.2969ZM222.162 103.262V98.7637C222.162 98.0436 222.121 97.4147 222.039 96.877C221.966 96.3392 221.852 95.8835 221.697 95.5098C221.542 95.127 221.351 94.8171 221.123 94.5801C220.895 94.3431 220.635 94.1699 220.344 94.0605C220.052 93.9512 219.729 93.8965 219.373 93.8965C218.926 93.8965 218.53 93.9831 218.184 94.1562C217.846 94.3294 217.559 94.6074 217.322 94.9902C217.085 95.3639 216.903 95.8652 216.775 96.4941C216.657 97.1139 216.598 97.8704 216.598 98.7637V103.262C216.598 103.982 216.634 104.615 216.707 105.162C216.789 105.709 216.908 106.178 217.062 106.57C217.227 106.953 217.418 107.268 217.637 107.514C217.865 107.751 218.124 107.924 218.416 108.033C218.717 108.143 219.045 108.197 219.4 108.197C219.838 108.197 220.225 108.111 220.562 107.938C220.909 107.755 221.201 107.473 221.438 107.09C221.684 106.698 221.866 106.188 221.984 105.559C222.103 104.93 222.162 104.164 222.162 103.262ZM242.191 99.2969V102.742C242.191 104.237 242.032 105.527 241.713 106.611C241.394 107.687 240.934 108.571 240.332 109.264C239.74 109.947 239.033 110.453 238.213 110.781C237.393 111.109 236.481 111.273 235.479 111.273C234.676 111.273 233.929 111.173 233.236 110.973C232.544 110.763 231.919 110.439 231.363 110.002C230.816 109.564 230.342 109.013 229.941 108.348C229.549 107.673 229.249 106.871 229.039 105.941C228.829 105.012 228.725 103.945 228.725 102.742V99.2969C228.725 97.8021 228.884 96.5215 229.203 95.4551C229.531 94.3796 229.992 93.5 230.584 92.8164C231.186 92.1328 231.896 91.6315 232.717 91.3125C233.537 90.9844 234.449 90.8203 235.451 90.8203C236.253 90.8203 236.996 90.9251 237.68 91.1348C238.372 91.3353 238.997 91.6497 239.553 92.0781C240.109 92.5065 240.583 93.0579 240.975 93.7324C241.367 94.3978 241.667 95.1953 241.877 96.125C242.087 97.0456 242.191 98.1029 242.191 99.2969ZM238.24 103.262V98.7637C238.24 98.0436 238.199 97.4147 238.117 96.877C238.044 96.3392 237.93 95.8835 237.775 95.5098C237.62 95.127 237.429 94.8171 237.201 94.5801C236.973 94.3431 236.714 94.1699 236.422 94.0605C236.13 93.9512 235.807 93.8965 235.451 93.8965C235.005 93.8965 234.608 93.9831 234.262 94.1562C233.924 94.3294 233.637 94.6074 233.4 94.9902C233.163 95.3639 232.981 95.8652 232.854 96.4941C232.735 97.1139 232.676 97.8704 232.676 98.7637V103.262C232.676 103.982 232.712 104.615 232.785 105.162C232.867 105.709 232.986 106.178 233.141 106.57C233.305 106.953 233.496 107.268 233.715 107.514C233.943 107.751 234.202 107.924 234.494 108.033C234.795 108.143 235.123 108.197 235.479 108.197C235.916 108.197 236.303 108.111 236.641 107.938C236.987 107.755 237.279 107.473 237.516 107.09C237.762 106.698 237.944 106.188 238.062 105.559C238.181 104.93 238.24 104.164 238.24 103.262Z" fill="white"/> */}
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2364_1056"
            x1="209.997"
            y1="95.1716"
            x2="269.516"
            y2="142.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2364_1056"
            x1="198.749"
            y1="109.732"
            x2="281.537"
            y2="83.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2364_1056"
            x1="134.792"
            y1="53.1903"
            x2="182.823"
            y2="91.7057"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2364_1056"
            x1="159.423"
            y1="52.5792"
            x2="164.242"
            y2="52.1791"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2364_1056"
            x1="134.708"
            y1="10.7233"
            x2="139.908"
            y2="30.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2364_1056"
            x1="153.402"
            y1="62.495"
            x2="201.433"
            y2="101.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2364_1056"
            x1="178.033"
            y1="61.8839"
            x2="182.852"
            y2="61.4838"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2364_1056"
            x1="153.318"
            y1="20.028"
            x2="158.518"
            y2="39.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2364_1056"
            x1="171.23"
            y1="71.4093"
            x2="219.261"
            y2="109.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2364_1056"
            x1="195.861"
            y1="70.7982"
            x2="200.68"
            y2="70.3981"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2364_1056"
            x1="171.146"
            y1="28.9423"
            x2="176.346"
            y2="48.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2364_1056"
            x1="186.829"
            y1="81.8092"
            x2="234.86"
            y2="120.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2364_1056"
            x1="211.461"
            y1="81.1981"
            x2="216.28"
            y2="80.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2364_1056"
            x1="186.745"
            y1="39.3422"
            x2="191.946"
            y2="58.9395"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2364_1056"
            x1="204.657"
            y1="90.7233"
            x2="252.688"
            y2="129.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2364_1056"
            x1="229.289"
            y1="90.1121"
            x2="234.108"
            y2="89.7121"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2364_1056"
            x1="204.574"
            y1="48.2562"
            x2="209.774"
            y2="67.8536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_2364_1056"
            x1="93.9392"
            y1="85.0246"
            x2="153.458"
            y2="132.752"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_2364_1056"
            x1="82.6906"
            y1="99.5849"
            x2="165.479"
            y2="73.728"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_2364_1056"
            x1="18.7336"
            y1="43.0433"
            x2="66.7647"
            y2="81.5588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_2364_1056"
            x1="43.3647"
            y1="42.4322"
            x2="48.1836"
            y2="42.0321"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_2364_1056"
            x1="18.6495"
            y1="0.576314"
            x2="23.8498"
            y2="20.1737"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_2364_1056"
            x1="37.344"
            y1="52.348"
            x2="85.375"
            y2="90.8635"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_2364_1056"
            x1="61.975"
            y1="51.7369"
            x2="66.7939"
            y2="51.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_2364_1056"
            x1="37.2599"
            y1="9.881"
            x2="42.4602"
            y2="29.4783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_2364_1056"
            x1="55.1718"
            y1="61.2623"
            x2="103.203"
            y2="99.7778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_2364_1056"
            x1="79.8027"
            y1="60.6512"
            x2="84.6215"
            y2="60.2511"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_2364_1056"
            x1="55.0875"
            y1="18.7953"
            x2="60.2878"
            y2="38.3927"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint28_linear_2364_1056"
            x1="70.7707"
            y1="71.6622"
            x2="118.802"
            y2="110.178"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint29_linear_2364_1056"
            x1="95.403"
            y1="71.0511"
            x2="100.222"
            y2="70.651"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint30_linear_2364_1056"
            x1="70.6871"
            y1="29.1952"
            x2="75.8874"
            y2="48.7926"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint31_linear_2364_1056"
            x1="88.5991"
            y1="80.5763"
            x2="136.63"
            y2="119.092"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint32_linear_2364_1056"
            x1="113.231"
            y1="79.9652"
            x2="118.05"
            y2="79.5651"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint33_linear_2364_1056"
            x1="88.5157"
            y1="38.1093"
            x2="93.716"
            y2="57.7066"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint34_linear_2364_1056"
            x1="189.939"
            y1="153.025"
            x2="249.458"
            y2="200.752"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint35_linear_2364_1056"
            x1="178.691"
            y1="167.585"
            x2="261.479"
            y2="141.728"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint36_linear_2364_1056"
            x1="114.734"
            y1="111.043"
            x2="162.765"
            y2="149.559"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint37_linear_2364_1056"
            x1="139.365"
            y1="110.432"
            x2="144.184"
            y2="110.032"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint38_linear_2364_1056"
            x1="114.65"
            y1="68.5763"
            x2="119.85"
            y2="88.1737"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint39_linear_2364_1056"
            x1="133.344"
            y1="120.348"
            x2="181.375"
            y2="158.863"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint40_linear_2364_1056"
            x1="157.975"
            y1="119.737"
            x2="162.794"
            y2="119.337"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint41_linear_2364_1056"
            x1="133.26"
            y1="77.881"
            x2="138.46"
            y2="97.4783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint42_linear_2364_1056"
            x1="151.172"
            y1="129.262"
            x2="199.203"
            y2="167.778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint43_linear_2364_1056"
            x1="175.803"
            y1="128.651"
            x2="180.622"
            y2="128.251"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint44_linear_2364_1056"
            x1="151.088"
            y1="86.7953"
            x2="156.288"
            y2="106.393"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint45_linear_2364_1056"
            x1="166.771"
            y1="139.662"
            x2="214.802"
            y2="178.178"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint46_linear_2364_1056"
            x1="191.403"
            y1="139.051"
            x2="196.222"
            y2="138.651"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint47_linear_2364_1056"
            x1="166.687"
            y1="97.1952"
            x2="171.887"
            y2="116.793"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint48_linear_2364_1056"
            x1="184.599"
            y1="148.576"
            x2="232.63"
            y2="187.092"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint49_linear_2364_1056"
            x1="209.231"
            y1="147.965"
            x2="214.05"
            y2="147.565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint50_linear_2364_1056"
            x1="184.516"
            y1="106.109"
            x2="189.716"
            y2="125.707"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint51_linear_2364_1056"
            x1="73.9973"
            y1="143.172"
            x2="133.516"
            y2="190.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FCFFFE" />
            <stop offset="1" stopColor="#D8E6DD" />
          </linearGradient>
          <linearGradient
            id="paint52_linear_2364_1056"
            x1="62.7487"
            y1="157.732"
            x2="145.537"
            y2="131.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ECF1EF" />
            <stop offset="1" stopColor="#E5F0EB" />
          </linearGradient>
          <linearGradient
            id="paint53_linear_2364_1056"
            x1="-1.20828"
            y1="101.19"
            x2="46.8228"
            y2="139.706"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint54_linear_2364_1056"
            x1="23.4228"
            y1="100.579"
            x2="28.2417"
            y2="100.179"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint55_linear_2364_1056"
            x1="-1.29236"
            y1="58.7233"
            x2="3.90794"
            y2="78.3206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint56_linear_2364_1056"
            x1="17.4021"
            y1="110.495"
            x2="65.4331"
            y2="149.01"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint57_linear_2364_1056"
            x1="42.0331"
            y1="109.884"
            x2="46.852"
            y2="109.484"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint58_linear_2364_1056"
            x1="17.318"
            y1="68.028"
            x2="22.5183"
            y2="87.6253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint59_linear_2364_1056"
            x1="35.23"
            y1="119.409"
            x2="83.261"
            y2="157.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint60_linear_2364_1056"
            x1="59.8608"
            y1="118.798"
            x2="64.6796"
            y2="118.398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint61_linear_2364_1056"
            x1="35.1456"
            y1="76.9423"
            x2="40.3459"
            y2="96.5396"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint62_linear_2364_1056"
            x1="50.8288"
            y1="129.809"
            x2="98.8599"
            y2="168.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint63_linear_2364_1056"
            x1="75.4611"
            y1="129.198"
            x2="80.28"
            y2="128.798"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint64_linear_2364_1056"
            x1="50.7452"
            y1="87.3422"
            x2="55.9455"
            y2="106.94"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint65_linear_2364_1056"
            x1="68.6572"
            y1="138.723"
            x2="116.688"
            y2="177.239"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#B7CDC4" />
          </linearGradient>
          <linearGradient
            id="paint66_linear_2364_1056"
            x1="93.2895"
            y1="138.112"
            x2="98.1084"
            y2="137.712"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7CDC4" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint67_linear_2364_1056"
            x1="68.5739"
            y1="96.2562"
            x2="73.7742"
            y2="115.854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4E2DC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <clipPath id="clip0_2364_1056">
            <rect width="270" height="200" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    basic: (
      <svg
        width="178"
        height="119"
        viewBox="0 0 178 119"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M23.099 8.51292C23.099 6.01942 25.4015 3.5 28.1284 3.5H163.85C165.363 3.5 166.614 4.03151 167.486 4.90658C168.359 5.78204 168.88 7.02956 168.88 8.51292V95.7173C168.88 97.4304 168.404 98.6636 167.584 99.4705C166.762 100.279 165.523 100.73 163.85 100.73H28.1284C26.4254 100.73 25.1845 100.202 24.3676 99.3495C23.5472 98.4929 23.099 97.2502 23.099 95.7173V8.51292Z"
            stroke="#ADBAB5"
          />
          <path
            d="M23.099 8.32282C23.099 5.94099 25.3851 3.5 28.1284 3.5H163.85C165.368 3.5 166.621 4.01532 167.492 4.85917C168.363 5.70221 168.88 6.90028 168.88 8.32282V12.6617H23.099V8.32282Z"
            stroke="#ADBAB5"
          />
          <circle cx="159.219" cy="8.64544" r="1.12908" stroke="#ADBAB5" />
          <circle cx="154.505" cy="8.64544" r="1.12908" stroke="#ADBAB5" />
          <circle cx="163.735" cy="8.64544" r="1.12908" stroke="#ADBAB5" />
          <rect
            x="33.2609"
            y="30.5979"
            width="9.16175"
            height="8.03266"
            stroke="#ADBAB5"
          />
          <path
            d="M43.4227 22.6943H50.3089C50.0511 26.3915 46.9625 29.3249 43.4227 29.5799V22.6943Z"
            stroke="#ADBAB5"
          />
          <circle cx="48.0035" cy="36.3081" r="2.32271" stroke="#ADBAB5" />
          <path
            d="M34.2664 50.9214H49.3208C49.886 50.9214 50.3262 51.3674 50.3262 51.8958V90.723C50.3262 91.2514 49.886 91.6974 49.3208 91.6974H34.2664C33.7012 91.6974 33.2609 91.2514 33.2609 90.723V51.8958C33.2609 51.3674 33.7012 50.9214 34.2664 50.9214Z"
            stroke="#ADBAB5"
          />
          <path
            d="M60.233 50.9214H155.456C156.02 50.9214 156.46 51.3668 156.46 51.8958V90.723C156.46 91.252 156.02 91.6974 155.456 91.6974H60.233C59.6695 91.6974 59.2295 91.252 59.2295 90.723V51.8958C59.2295 51.3668 59.6695 50.9214 60.233 50.9214Z"
            stroke="#ADBAB5"
          />
          <path
            d="M60.233 21.5654H155.456C156.036 21.5654 156.46 22.0047 156.46 22.4916V37.7045C156.46 38.1915 156.036 38.6308 155.456 38.6308H60.233C59.6536 38.6308 59.2295 38.1915 59.2295 37.7045V22.4916C59.2295 22.0047 59.6536 21.5654 60.233 21.5654Z"
            stroke="#ADBAB5"
          />
          <circle cx="70.6898" cy="30.5643" r="6.19516" stroke="#ADBAB5" />
          <circle cx="70.6902" cy="29.3779" r="1.87298" stroke="#ADBAB5" />
          <circle cx="106.097" cy="113.139" r="4.52674" stroke="#ADBAB5" />
          <circle cx="11.3427" cy="46.032" r="5.28075" stroke="#ADBAB5" />
          <circle cx="3.29985" cy="31.4544" r="2.76738" stroke="#ADBAB5" />
          <path
            d="M176.977 3.30473C176.977 4.10627 176.726 4.81366 176.344 5.31026C175.963 5.80632 175.47 6.07211 174.963 6.07211C174.457 6.07211 173.964 5.80632 173.582 5.31026C173.2 4.81366 172.95 4.10627 172.95 3.30473C172.95 2.5032 173.2 1.7958 173.582 1.2992C173.964 0.803142 174.457 0.537354 174.963 0.537354C175.47 0.537354 175.963 0.803142 176.344 1.2992C176.726 1.7958 176.977 2.5032 176.977 3.30473Z"
            stroke="#ADBAB5"
          />
        </g>
      </svg>
    ),
    advanced: (
      <svg
        width="190"
        height="133"
        viewBox="0 0 190 133"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M20.0988 5.51292C20.0988 3.01942 22.4013 0.5 25.1282 0.5H160.85C162.363 0.5 163.614 1.03151 164.486 1.90658C165.358 2.78204 165.88 4.02956 165.88 5.51292V92.7173C165.88 94.4304 165.404 95.6636 164.584 96.4705C163.762 97.2787 162.523 97.7302 160.85 97.7302H25.1282C23.4252 97.7302 22.1843 97.2025 21.3674 96.3495C20.5471 95.4929 20.0988 94.2502 20.0988 92.7173V5.51292Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <path
            d="M20.0988 5.32282C20.0988 2.94099 22.3849 0.5 25.1282 0.5H160.85C162.368 0.5 163.621 1.01532 164.492 1.85917C165.362 2.70221 165.88 3.90028 165.88 5.32282V9.66175H20.0988V5.32282Z"
            stroke="#ADBAB5"
          />
          <circle cx="156.219" cy="5.64544" r="1.12908" stroke="#ADBAB5" />
          <circle cx="151.505" cy="5.64544" r="1.12908" stroke="#ADBAB5" />
          <circle cx="160.734" cy="5.64544" r="1.12908" stroke="#ADBAB5" />
          <rect
            x="30.2608"
            y="27.5979"
            width="9.16175"
            height="8.03266"
            stroke="#ADBAB5"
          />
          <path
            d="M40.4225 26.5799V19.6943H47.3087C47.051 23.3915 43.9624 26.3249 40.4225 26.5799Z"
            stroke="#ADBAB5"
          />
          <circle cx="45.0033" cy="33.3081" r="2.32271" stroke="#ADBAB5" />
          <path
            d="M30.2608 48.8958C30.2608 48.3674 30.7011 47.9214 31.2662 47.9214H46.3207C46.8858 47.9214 47.3261 48.3674 47.3261 48.8958V87.723C47.3261 88.2514 46.8858 88.6974 46.3207 88.6974H31.2662C30.7011 88.6974 30.2608 88.2514 30.2608 87.723V48.8958Z"
            stroke="#ADBAB5"
          />
          <path
            d="M56.2293 48.8958C56.2293 48.3668 56.6694 47.9214 57.2328 47.9214H152.456C153.019 47.9214 153.46 48.3668 153.46 48.8958V87.723C153.46 88.252 153.019 88.6974 152.456 88.6974H57.2328C56.6694 88.6974 56.2293 88.252 56.2293 87.723V48.8958Z"
            stroke="#ADBAB5"
          />
          <path
            d="M56.2293 19.4916C56.2293 19.0047 56.6534 18.5654 57.2328 18.5654H152.456C153.035 18.5654 153.46 19.0047 153.46 19.4916V34.7045C153.46 35.1915 153.035 35.6308 152.456 35.6308H57.2328C56.6534 35.6308 56.2293 35.1915 56.2293 34.7045V19.4916Z"
            stroke="#ADBAB5"
          />
          <circle cx="67.6897" cy="27.5643" r="6.19516" stroke="#ADBAB5" />
          <mask
            id="mask0_1049_2963"
            maskUnits="userSpaceOnUse"
            x="61"
            y="21"
            width="13"
            height="13"
          >
            <circle cx="67.6892" cy="27.5643" r="5.69516" fill="#35BE70" />
          </mask>
          <g mask="url(#mask0_1049_2963)">
            <circle
              cx="67.6897"
              cy="34.2367"
              r="4.24597"
              fill="white"
              stroke="#ADBAB5"
            />
          </g>
          <circle
            cx="67.69"
            cy="26.3779"
            r="1.87298"
            fill="white"
            stroke="#ADBAB5"
          />
          <path
            d="M1 78.4171C1 74.3957 3.26203 71.8823 7.28342 71.8823H74.3904C79.1658 71.8823 80.9251 74.3957 80.9251 78.4171V82.4385V125.166C80.9251 129.187 78.9144 131.701 74.3904 131.701H7.28342C3.51337 131.701 1 129.438 1 125.417V82.4385V78.4171Z"
            fill="white"
          />
          <path
            d="M1 82.4385L1 125.417C1 129.438 3.51337 131.701 7.28342 131.701H74.3904C78.9144 131.701 80.9251 129.187 80.9251 125.166V82.4385M1 82.4385V78.4171C1 74.3957 3.26203 71.8823 7.28342 71.8823H74.3904C79.1658 71.8823 80.9251 74.3957 80.9251 78.4171V82.4385M1 82.4385H80.9251"
            stroke="#ADBAB5"
          />
          <path
            d="M7.28342 71.8823C3.26203 71.8823 1 74.3957 1 78.4171V82.4385H80.9251V78.4171C80.9251 74.3957 79.1658 71.8823 74.3904 71.8823H7.28342Z"
            stroke="#ADBAB5"
          />
          <circle cx="68.3585" cy="77.4118" r="1.00535" stroke="#ADBAB5" />
          <circle cx="71.8771" cy="77.4118" r="1.00535" stroke="#ADBAB5" />
          <circle cx="75.3961" cy="77.4118" r="1.00535" stroke="#ADBAB5" />
          <path
            d="M10.548 90.4811C10.548 89.3692 11.4495 88.4678 12.5614 88.4678H69.8662C70.9782 88.4678 71.8796 89.3692 71.8796 90.4811V120.139C71.8796 121.251 70.9782 122.152 69.8662 122.152H12.5614C11.4495 122.152 10.548 121.251 10.548 120.139V90.4811Z"
            stroke="#ADBAB5"
          />
          <path
            d="M18.5907 97.5185C18.5907 96.9618 19.042 96.5105 19.5987 96.5105H24.1228C24.6795 96.5105 25.1308 96.9618 25.1308 97.5185V102.043C25.1308 102.599 24.6795 103.051 24.1228 103.051H19.5987C19.042 103.051 18.5907 102.599 18.5907 102.043V97.5185Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <path
            d="M18.5907 108.578C18.5907 108.021 19.042 107.57 19.5987 107.57H24.1228C24.6795 107.57 25.1308 108.021 25.1308 108.578V113.102C25.1308 113.658 24.6795 114.11 24.1228 114.11H19.5987C19.042 114.11 18.5907 113.658 18.5907 113.102V108.578Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <path
            d="M34.6763 105.31C34.6763 100.45 38.616 96.5105 43.4758 96.5105H55.54C60.3998 96.5105 64.3394 100.45 64.3394 105.31C64.3394 110.17 60.3998 114.109 55.54 114.109H43.4758C38.616 114.109 34.6763 110.17 34.6763 105.31Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle cx="55.0377" cy="105.31" r="6.28342" fill="#ADBAB5" />
          <path
            d="M100.529 36.6952C100.529 33.6414 103.005 31.1658 106.059 31.1658H183.471C186.524 31.1658 189 33.6414 189 36.6952V41.7219V115.112C189 118.166 186.524 120.642 183.471 120.642H106.059C103.005 120.642 100.529 118.166 100.529 115.112V41.7219V36.6952Z"
            fill="white"
          />
          <path
            d="M100.529 41.7219V115.112C100.529 118.166 103.005 120.642 106.059 120.642H183.471C186.524 120.642 189 118.166 189 115.112V41.7219M100.529 41.7219V36.6952C100.529 33.6414 103.005 31.1658 106.059 31.1658H183.471C186.524 31.1658 189 33.6414 189 36.6952V41.7219M100.529 41.7219H189"
            stroke="#ADBAB5"
          />
          <path
            d="M112.591 53.7861C112.591 52.6741 113.492 51.7727 114.604 51.7727H175.93C177.042 51.7727 177.944 52.6741 177.944 53.7861V87.4652C177.944 88.5772 177.042 89.4786 175.93 89.4786H114.604C113.492 89.4786 112.591 88.5772 112.591 87.4652V53.7861Z"
            stroke="#ADBAB5"
          />
          <path
            d="M117.116 60.0697C117.116 59.3741 117.679 58.8103 118.375 58.8103H172.161C172.857 58.8103 173.42 59.3741 173.42 60.0697C173.42 60.7652 172.857 61.329 172.161 61.329H118.375C117.679 61.329 117.116 60.7652 117.116 60.0697Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle cx="129.935" cy="60.0696" r="4.27273" fill="#ADBAB5" />
          <circle cx="129.935" cy="60.0697" r="1.25668" fill="white" />
          <path
            d="M117.116 71.1285C117.116 70.433 117.679 69.8691 118.375 69.8691H172.161C172.857 69.8691 173.42 70.433 173.42 71.1285C173.42 71.824 172.857 72.3879 172.161 72.3879H118.375C117.679 72.3879 117.116 71.824 117.116 71.1285Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle cx="165.123" cy="71.1284" r="4.27273" fill="#ADBAB5" />
          <circle cx="165.123" cy="71.1285" r="1.25668" fill="white" />
          <path
            d="M117.116 82.1873C117.116 81.4918 117.679 80.928 118.375 80.928H172.161C172.857 80.928 173.42 81.4918 173.42 82.1873C173.42 82.8829 172.857 83.4467 172.161 83.4467H118.375C117.679 83.4467 117.116 82.8829 117.116 82.1873Z"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle cx="155.07" cy="82.1873" r="4.27273" fill="#ADBAB5" />
          <circle cx="155.07" cy="82.1873" r="1.25668" fill="white" />
          <path
            d="M113.094 99.0268C113.094 97.9148 113.995 97.0134 115.107 97.0134H175.93C177.042 97.0134 177.944 97.9148 177.944 99.0268V107.572C177.944 108.684 177.042 109.586 175.93 109.586H115.107C113.995 109.586 113.094 108.684 113.094 107.572V99.0268Z"
            stroke="#ADBAB5"
          />
          <path
            d="M183.471 31.1658H106.059C103.005 31.1658 100.529 33.6414 100.529 36.6952V41.7219H189V36.6952C189 33.6414 186.524 31.1658 183.471 31.1658Z"
            stroke="#ADBAB5"
          />
          <circle cx="176.433" cy="36.6953" r="1.00535" stroke="#ADBAB5" />
          <circle cx="179.952" cy="36.6953" r="1.00535" stroke="#ADBAB5" />
          <circle cx="183.471" cy="36.6953" r="1.00535" stroke="#ADBAB5" />
          <circle
            cx="113.097"
            cy="120.139"
            r="4.52674"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle
            cx="18.3427"
            cy="53.032"
            r="5.28075"
            fill="white"
            stroke="#ADBAB5"
          />
          <circle
            cx="10.2999"
            cy="38.4544"
            r="2.76738"
            fill="white"
            stroke="#ADBAB5"
          />
          <path
            d="M183.977 10.3047C183.977 11.1063 183.726 11.8137 183.344 12.3103C182.963 12.8063 182.47 13.0721 181.963 13.0721C181.457 13.0721 180.964 12.8063 180.582 12.3103C180.2 11.8137 179.95 11.1063 179.95 10.3047C179.95 9.5032 180.2 8.7958 180.582 8.2992C180.964 7.80314 181.457 7.53735 181.963 7.53735C182.47 7.53735 182.963 7.80314 183.344 8.2992C183.726 8.7958 183.977 9.5032 183.977 10.3047Z"
            stroke="#ADBAB5"
          />
        </g>
      </svg>
    ),
    // footer
    facebook: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="512" height="512" rx="256" />
        <path
          d="M316.75,216.812h-44.531v-32.5c0-9.969,10.312-12.281,15.125-12.281c4.781,0,28.767,0,28.767,0v-43.859L283.141,128
		c-44.983,0-55.25,32.703-55.25,53.672v35.141H195.25V262h32.641c0,58.016,0,122,0,122h44.328c0,0,0-64.641,0-122h37.656
		L316.75,216.812z"
        />
      </svg>
    ),
    youTube: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="512" height="512" rx="256" />
        <path d="M257.9,143.3c35.6,1.3,71.1,2.3,106.5,3.8c24.3,1.1,38.5,13.7,42.4,38.4c2.3,14.4,3.5,29.1,4,43.7   c0.9,27.5,0.8,55-2.7,82.3c-1.4,11-4,21.7-11.1,30.6c-8.9,11-21.4,14-34.8,14.7c-56.4,3.1-112.9,3.9-169.3,1.6   c-16.5-0.7-32.9-1.6-49.3-3.4c-15.9-1.7-26.8-10.6-32.1-26.1c-4.7-13.6-5.3-27.7-6.2-41.8c-1.8-31.3-1.6-62.6,2-93.8   c0.9-8.1,3.3-16.4,6.6-23.9c6.9-16,21-21.6,37.2-22.3C186.8,145.6,222.4,144.5,257.9,143.3z M226.2,291.6   c27.8-14.4,54.8-28.4,82.6-42.8c-28.1-14.7-55.1-28.7-82.6-43.1C226.2,234.5,226.2,262.6,226.2,291.6z" />
      </svg>
    ),
    telegram: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.05368 19.7889C14.8841 17.2487 18.7719 15.574 20.7172 14.7649C26.2715 12.4547 27.4256 12.0534 28.1778 12.0402C28.3433 12.0373 28.7132 12.0783 28.9528 12.2727C29.1551 12.4369 29.2108 12.6587 29.2375 12.8143C29.2641 12.97 29.2973 13.3246 29.2709 13.6017C28.9699 16.7641 27.6676 24.4386 27.005 27.9806C26.7246 29.4794 26.1726 29.9819 25.6382 30.0311C24.4767 30.138 23.5948 29.2635 22.4699 28.5261C20.7096 27.3723 19.7152 26.654 18.0066 25.528C16.0319 24.2268 17.312 23.5116 18.4373 22.3428C18.7318 22.0369 23.8492 17.3823 23.9482 16.96C23.9606 16.9072 23.9721 16.7104 23.8551 16.6065C23.7382 16.5025 23.5656 16.5381 23.4411 16.5663C23.2645 16.6064 20.4525 18.465 15.0049 22.1423C14.2067 22.6904 13.4838 22.9574 12.836 22.9434C12.1219 22.928 10.7483 22.5397 9.72709 22.2077C8.47459 21.8006 7.47913 21.5853 7.56581 20.8939C7.61096 20.5337 8.10692 20.1654 9.05368 19.7889Z"
        />
      </svg>
    ),
    skype: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" />
        <path d="M20.0524 27.7325C15.7843 27.7325 13.8343 25.5582 13.8343 23.9635C13.8337 23.5831 13.9898 23.2192 14.266 22.9575C14.5421 22.6958 14.9138 22.5593 15.2936 22.5803C17.121 22.5803 16.643 25.3213 20.0524 25.3213C21.7952 25.3213 22.8189 24.2723 22.8189 23.2867C22.8189 22.6945 22.4805 22.0177 21.3299 21.747L17.5229 20.7867C14.4646 20.0084 13.9316 18.3079 13.9316 16.7301C13.9316 13.4561 16.9264 12.2717 19.7775 12.2717C22.4043 12.2717 25.5261 13.7226 25.5261 15.6853C25.5261 16.5313 24.8197 16.9839 23.9991 16.9839C22.4382 16.9839 22.7004 14.7928 19.5617 14.7928C18.0009 14.7928 17.1802 15.5246 17.1802 16.5482C17.1802 17.5719 18.3943 17.9188 19.4602 18.1514L22.269 18.7859C25.3484 19.4797 26.1691 21.2859 26.1691 23.016C26.1691 25.6767 24.109 27.7325 20.0482 27.7325H20.0524ZM31.8373 22.1023C31.9592 21.4039 32.0201 20.6962 32.0192 19.9873C32.0341 16.426 30.4694 13.0415 27.7467 10.7459C25.024 8.45037 21.4237 7.48009 17.9163 8.09664C16.8382 7.47593 15.6155 7.15056 14.3715 7.15334C11.8181 7.16894 9.46444 8.53744 8.18773 10.7488C6.91103 12.9602 6.90277 15.6828 8.16604 17.9019C7.46114 21.775 8.6959 25.748 11.472 28.5393C14.2482 31.3306 18.2144 32.587 22.0913 31.9033C23.1681 32.5234 24.3893 32.8488 25.6318 32.8466C28.184 32.8301 30.5362 31.4622 31.8126 29.2522C33.089 27.0421 33.0984 24.3211 31.8373 22.1023Z" />
        <defs>
          <linearGradient
            id="paint0_linear_233_1179"
            x1="32.1863"
            y1="7.15332"
            x2="4.98896"
            y2="30.2097"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#4BC776" />
            <stop offset="1" stopColor="#3CB368" />
          </linearGradient>
        </defs>
      </svg>
    ),
    gmail: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" />
        <g clipPath="url(#clip0_233_1172)">
          <path d="M20.9064 20.9581C20.6909 21.1074 20.4368 21.1821 20.1827 21.1821C19.9286 21.1821 19.6745 21.1074 19.459 20.9581L9.16873 13.8215L6.72127 12.1241L6.72119 28.512C6.72127 29.1512 7.26912 29.6694 7.94496 29.6694L32.4205 29.6693C33.0964 29.6693 33.6443 29.1511 33.6443 28.512V12.124L31.1966 13.8215L20.9064 20.9581Z" />
          <path d="M20.1818 19.3701L32.0187 11.1607L8.34473 11.1606L20.1818 19.3701Z" />
        </g>
        <defs>
          <clipPath id="clip0_233_1172">
            <rect
              width="26.6667"
              height="20"
              fill="white"
              transform="translate(7 10)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    whatsapp: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 48 48"
      >
        <rect width="48" height="48" rx="24" />
        <g transform="translate(8.000000, 8.000000)">
          <path d="M27.281 4.65c-2.994-3-6.975-4.65-11.219-4.65-8.738 0-15.85 7.112-15.85 15.856 0 2.794 0.731 5.525 2.119 7.925l-2.25 8.219 8.406-2.206c2.319 1.262 4.925 1.931 7.575 1.931h0.006c0 0 0 0 0 0 8.738 0 15.856-7.113 15.856-15.856 0-4.238-1.65-8.219-4.644-11.219zM16.069 29.050v0c-2.369 0-4.688-0.637-6.713-1.837l-0.481-0.288-4.987 1.306 1.331-4.863-0.313-0.5c-1.325-2.094-2.019-4.519-2.019-7.012 0-7.269 5.912-13.181 13.188-13.181 3.519 0 6.831 1.375 9.319 3.862 2.488 2.494 3.856 5.8 3.856 9.325-0.006 7.275-5.919 13.188-13.181 13.188zM23.294 19.175c-0.394-0.2-2.344-1.156-2.706-1.288s-0.625-0.2-0.894 0.2c-0.262 0.394-1.025 1.288-1.256 1.556-0.231 0.262-0.462 0.3-0.856 0.1s-1.675-0.619-3.188-1.969c-1.175-1.050-1.975-2.35-2.206-2.744s-0.025-0.613 0.175-0.806c0.181-0.175 0.394-0.463 0.594-0.694s0.262-0.394 0.394-0.662c0.131-0.262 0.069-0.494-0.031-0.694s-0.894-2.15-1.219-2.944c-0.319-0.775-0.65-0.669-0.894-0.681-0.231-0.012-0.494-0.012-0.756-0.012s-0.694 0.1-1.056 0.494c-0.363 0.394-1.387 1.356-1.387 3.306s1.419 3.831 1.619 4.1c0.2 0.262 2.794 4.269 6.769 5.981 0.944 0.406 1.681 0.65 2.256 0.837 0.95 0.3 1.813 0.256 2.494 0.156 0.762-0.113 2.344-0.956 2.675-1.881s0.331-1.719 0.231-1.881c-0.094-0.175-0.356-0.275-0.756-0.475z"></path>
        </g>
      </svg>
    ),
    messanger: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64282 19.5979C6.64282 12.1547 12.4765 6.6416 19.9998 6.6416C27.5232 6.6416 33.3569 12.1581 33.3569 19.6013C33.3569 27.0445 27.5232 32.5576 19.9998 32.5576C18.6474 32.5576 17.3518 32.3772 16.133 32.0433C15.8959 31.9799 15.6421 31.9966 15.4184 32.0968L12.767 33.2655C12.0725 33.5727 11.2911 33.0785 11.2677 32.3205L11.1942 29.9429C11.1875 29.6491 11.054 29.3753 10.8369 29.1816C8.23899 26.8575 6.64282 23.4915 6.64282 19.5979ZM15.902 17.1636L11.9784 23.3879C11.6011 23.9857 12.3357 24.6569 12.8967 24.2294L17.1108 21.0304C17.3947 20.8134 17.7887 20.8134 18.0759 21.0271L21.1981 23.3679C22.1364 24.0692 23.4721 23.8254 24.0966 22.8336L28.0235 16.6126C28.3975 16.0149 27.6629 15.3403 27.1019 15.7678L22.8877 18.9668C22.6039 19.1838 22.2099 19.1838 21.9227 18.9701L18.8005 16.6293C17.8622 15.928 16.5265 16.1718 15.902 17.1636Z"
        />
        <defs>
          <linearGradient
            id="paint0_linear_233_1183"
            x1="32.7397"
            y1="6.6416"
            x2="4.43468"
            y2="30.7674"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#4BC776" />
            <stop offset="1" stopColor="#3CB368" />
          </linearGradient>
        </defs>
      </svg>
    ),
    // support
    supportTelegram: (
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="52" rx="26" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7702 25.7254C19.3497 22.4231 24.4039 20.2461 26.9328 19.1942C34.1533 16.191 35.6536 15.6693 36.6315 15.652C36.8466 15.6483 37.3275 15.7016 37.639 15.9543C37.9021 16.1678 37.9745 16.4561 38.0091 16.6584C38.0437 16.8608 38.0868 17.3218 38.0526 17.682C37.6613 21.7932 35.9682 31.77 35.1069 36.3746C34.7424 38.323 34.0248 38.9763 33.33 39.0402C31.8202 39.1792 30.6736 38.0424 29.2112 37.0838C26.9229 35.5838 25.6301 34.65 23.4089 33.1862C20.8419 31.4946 22.506 30.5649 23.9689 29.0454C24.3518 28.6478 31.0043 22.5968 31.1331 22.0479C31.1492 21.9792 31.1641 21.7233 31.0121 21.5882C30.8601 21.4531 30.6357 21.4993 30.4738 21.536C30.2442 21.5881 26.5886 24.0044 19.5068 28.7848C18.4692 29.4973 17.5293 29.8445 16.6872 29.8263C15.7589 29.8062 13.9731 29.3014 12.6456 28.8698C11.0174 28.3406 9.72325 28.0607 9.83594 27.1618C9.89464 26.6937 10.5394 26.2148 11.7702 25.7254Z"
          fill="#35BE70"
        />
      </svg>
    ),
    supportSkype: (
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="52" rx="26" fill="white" />
        <path
          d="M26.0681 36.0522C20.5196 36.0522 17.9845 33.2257 17.9845 31.1525C17.9837 30.658 18.1867 30.1849 18.5457 29.8447C18.9046 29.5045 19.3878 29.3271 19.8817 29.3544C22.2572 29.3544 21.6359 32.9177 26.0681 32.9177C28.3337 32.9177 29.6645 31.554 29.6645 30.2727C29.6645 29.5028 29.2245 28.623 27.7288 28.271L22.7797 27.0228C18.8038 26.0109 18.111 23.8003 18.111 21.7492C18.111 17.4929 22.0043 15.9532 25.7106 15.9532C29.1256 15.9532 33.1838 17.8394 33.1838 20.3909C33.1838 21.4907 32.2655 22.0791 31.1987 22.0791C29.1695 22.0791 29.5105 19.2306 25.4302 19.2306C23.4011 19.2306 22.3342 20.1819 22.3342 21.5127C22.3342 22.8435 23.9125 23.2944 25.2982 23.5969L28.9496 24.4217C32.9529 25.3236 34.0197 27.6716 34.0197 29.9208C34.0197 33.3797 31.3417 36.0522 26.0626 36.0522H26.0681ZM41.3884 28.733C41.5469 27.8251 41.626 26.9051 41.6249 25.9834C41.6443 21.3539 39.6101 16.9539 36.0706 13.9697C32.5312 10.9855 27.8508 9.72412 23.2911 10.5256C21.8896 9.71871 20.3001 9.29573 18.6829 9.29934C15.3634 9.31962 12.3037 11.0987 10.644 13.9735C8.98427 16.8483 8.97353 20.3876 10.6158 23.2724C9.69941 28.3075 11.3046 33.4724 14.9136 37.1011C18.5225 40.7298 23.6786 42.3631 28.7186 41.4742C30.1184 42.2805 31.706 42.7034 33.3213 42.7005C36.6391 42.6792 39.6969 40.9009 41.3563 38.0278C43.0157 35.1547 43.0279 31.6174 41.3884 28.733Z"
          fill="url(#paint0_linear_233_4494)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_233_4494"
            x1="41.8421"
            y1="9.29932"
            x2="6.48558"
            y2="39.2726"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#4BC776" />
            <stop offset="1" stopColor="#3CB368" />
          </linearGradient>
        </defs>
      </svg>
    ),
    supportGmail: (
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="52" rx="26" fill="white" />
        <g clipPath="url(#clip0_233_4499)">
          <path
            d="M27.2929 28.2113C27.0513 28.3788 26.7663 28.4625 26.4815 28.4625C26.1965 28.4625 25.9116 28.3788 25.67 28.2113L14.132 20.2094L11.3878 18.3062L11.3877 36.6811C11.3878 37.3978 12.0021 37.9789 12.7598 37.9789L40.203 37.9788C40.9609 37.9788 41.5752 37.3977 41.5752 36.6811V18.3062L38.8308 20.2094L27.2929 28.2113Z"
            fill="#35BE70"
          />
          <path
            d="M26.4804 26.4309L39.7525 17.2262L13.208 17.2261L26.4804 26.4309Z"
            fill="#35BE70"
          />
        </g>
        <defs>
          <clipPath id="clip0_233_4499">
            <rect
              width="29.9"
              height="22.425"
              fill="white"
              transform="translate(11.7002 15.9248)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    supportWhatsapp: (
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="52" height="52" rx="26" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.63574 25.4775C8.63574 15.8013 16.2195 8.63428 25.9999 8.63428C35.7802 8.63428 43.364 15.8057 43.364 25.4818C43.364 35.158 35.7802 42.325 25.9999 42.325C24.2418 42.325 22.5574 42.0906 20.973 41.6565C20.6647 41.574 20.3348 41.5957 20.044 41.726L16.5972 43.2453C15.6943 43.6447 14.6785 43.0022 14.6481 42.0168L14.5526 38.926C14.5439 38.544 14.3702 38.188 14.0881 37.9363C10.7108 34.9149 8.63574 30.5391 8.63574 25.4775ZM20.6727 22.3128L15.572 30.4045C15.0815 31.1816 16.0365 32.0541 16.7658 31.4985L22.2442 27.3398C22.6132 27.0576 23.1254 27.0576 23.4987 27.3354L27.5576 30.3785C28.7774 31.2901 30.5138 30.9732 31.3256 29.6839L36.4306 21.5966C36.9168 20.8195 35.9618 19.9426 35.2325 20.4983L29.7541 24.657C29.3852 24.9392 28.8729 24.9392 28.4996 24.6613L24.4407 21.6183C23.2209 20.7067 21.4845 21.0236 20.6727 22.3128Z"
          fill="url(#paint0_linear_233_4505)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_233_4505"
            x1="42.5617"
            y1="8.63428"
            x2="5.76516"
            y2="39.9978"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#4BC776" />
            <stop offset="1" stopColor="#3CB368" />
          </linearGradient>
        </defs>
      </svg>
    ),
    hiddenPas: (
      <svg width="22" height="18" viewBox="0 0 22 18">
        <path
          d="M5.6875 3.90625C7.09375 2.84375 8.84375 2 11 2C13.5 2 15.5312 3.15625 17 4.53125C18.4688 5.875 19.4375 7.5 19.9062 8.625C20 8.875 20 9.15625 19.9062 9.40625C19.5 10.4062 18.6562 11.8438 17.4062 13.0938L20.6875 15.6875C21.0312 15.9375 21.0938 16.4062 20.8125 16.7188C20.5625 17.0625 20.0938 17.125 19.7812 16.8438L1.28125 2.34375C0.9375 2.09375 0.875 1.625 1.15625 1.3125C1.40625 0.96875 1.875 0.90625 2.1875 1.1875L5.6875 3.90625ZM7.96875 5.6875L10.7812 7.90625C10.9062 7.625 11 7.34375 11 7C11 6.65625 10.875 6.3125 10.7188 6.03125C10.8125 6.03125 10.9062 6 11 6C12.6562 6 14 7.34375 14 9C14 9.4375 13.9062 9.84375 13.7188 10.2188L14.9375 11.1562C15.2812 10.5312 15.5 9.78125 15.5 9C15.5 6.53125 13.4688 4.5 11 4.5C9.8125 4.5 8.75 4.96875 7.96875 5.6875ZM11 16C8.46875 16 6.4375 14.875 4.96875 13.5C3.5 12.125 2.53125 10.5 2.0625 9.40625C1.96875 9.15625 1.96875 8.875 2.0625 8.625C2.375 7.90625 2.875 7 3.59375 6.0625L6.53125 8.375C6.5 8.59375 6.5 8.8125 6.5 9C6.5 11.5 8.5 13.5 11 13.5C11.5625 13.5 12.125 13.4062 12.6562 13.1875L14.9375 15C13.7812 15.625 12.4688 16 11 16Z"
          fill="currentColor"
        />
      </svg>
    ),
    showPas: (
      <svg width="22" height="18" viewBox="0 0 20 14">
        <path
          d="M9.71875 4.03125C9.8125 4.03125 9.90625 4 10 4C11.6562 4 13 5.34375 13 7C13 8.65625 11.6562 10 10 10C8.3125 10 7 8.65625 7 7C7 6.9375 7 6.84375 7 6.75C7.28125 6.90625 7.625 7 8 7C9.09375 7 10 6.125 10 5C10 4.65625 9.875 4.3125 9.71875 4.03125ZM16 2.53125C17.4688 3.875 18.4375 5.5 18.9062 6.625C19 6.875 19 7.15625 18.9062 7.40625C18.4375 8.5 17.4688 10.125 16 11.5C14.5312 12.875 12.5 14 10 14C7.46875 14 5.4375 12.875 3.96875 11.5C2.5 10.125 1.53125 8.5 1.0625 7.40625C0.96875 7.15625 0.96875 6.875 1.0625 6.625C1.53125 5.5 2.5 3.875 3.96875 2.53125C5.4375 1.15625 7.46875 0 10 0C12.5 0 14.5312 1.15625 16 2.53125ZM10 2.5C7.5 2.5 5.5 4.53125 5.5 7C5.5 9.5 7.5 11.5 10 11.5C12.4688 11.5 14.5 9.5 14.5 7C14.5 4.53125 12.4688 2.5 10 2.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    arrowDown: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
      </svg>
    ),
    search: (
      <svg width="24" height="24" viewBox="0 0 24 24" focusable="false">
        <path
          d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    ),
    // APP ICONS
    appLogo: (
      <svg width="120" height="120" viewBox="0 0 120 120" fill="currentColor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.6247 112.5L0.62997 10.8103C0.62997 10.8103 -1.20982 7.51904 1.39874 7.51904H68.9945C68.9945 7.51904 71.6556 7.75858 69.8355 10.8037C68.0154 13.8488 47.6989 49.2187 47.6102 49.373C47.6102 49.373 47.5774 49.4583 47.4788 49.4616C47.3803 49.4616 47.3474 49.3762 47.3474 49.3762L38.1715 32.3361C38.1715 32.3361 36.3383 29.4386 38.0335 29.4386H46.6706L52.1539 21.6093C52.1539 21.6093 53.9936 18.131 49.3383 18.131H18.7782L65.0685 100.769L65.2032 104.828L59.6247 112.5Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.2026 91.0563L77.2818 83.3713V79.7519L66.4172 61.9669L66.3712 58.5838L82.719 32.3394C82.719 32.3394 84.1251 29.4419 81.6742 29.4419H70.8984L53.335 59.8143L72.2026 91.0563Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.2727 70.6133L78.98 62.0128L79.3348 57.5633L100.18 21.6093C100.18 21.6093 102.02 18.131 98.6756 18.131H79.4629C79.4629 18.131 76.7952 18.2853 78.98 14.5478L81.1615 10.807L82.9552 7.52564H117.484C117.484 7.52564 121.719 6.99077 119.196 10.807C116.673 14.6232 84.2727 70.6133 84.2727 70.6133V70.6133Z"
        />
      </svg>
    ),
    speedLimit: (
      <svg
        width="17"
        height="12"
        viewBox="0 0 17 12"
        fill="currentColor"
        strokeWidth="0.3"
      >
        <path d="M8.5 2.5657C7.96875 2.5657 7.55556 2.96659 7.55556 3.42094C7.55556 3.902 7.96875 4.27617 8.5 4.27617C9.00174 4.27617 9.44444 3.902 9.44444 3.42094C9.44444 2.96659 9.00174 2.5657 8.5 2.5657ZM2.83333 7.6971C2.83333 8.17817 3.24653 8.55234 3.77778 8.55234C4.27951 8.55234 4.72222 8.17817 4.72222 7.6971C4.72222 7.24276 4.27951 6.84187 3.77778 6.84187C3.24653 6.84187 2.83333 7.24276 2.83333 7.6971ZM8.5 0C3.80729 0 0 3.44766 0 7.6971C0 9.11359 0.413194 10.4499 1.15104 11.5724C1.29861 11.8396 1.62326 12 1.94792 12H15.0226C15.3472 12 15.6719 11.8396 15.849 11.5724C16.5573 10.4499 17 9.11359 17 7.6971C17 3.44766 13.1927 0 8.5 0ZM8.5 10.6904C7.82118 10.6904 7.31944 10.2361 7.31944 9.62138C7.31944 9.03341 7.82118 8.55234 8.5 8.55234C9.14931 8.55234 9.68056 9.03341 9.68056 9.62138C9.68056 10.2361 9.14931 10.6904 8.5 10.6904ZM14.7569 10.6904H10.8021C10.9792 10.3697 11.0972 10.0223 11.0972 9.62138C11.0972 8.33853 9.91667 7.26949 8.5 7.26949C8.26389 7.26949 8.05729 7.32294 7.85069 7.34967L5.54861 4.14254C5.3125 3.84855 4.89931 3.76837 4.54514 3.95546C4.22049 4.16926 4.13194 4.54343 4.33854 4.86414L6.61111 7.99109C6.1684 8.41871 5.90278 9.00668 5.90278 9.62138C5.90278 10.0223 5.99132 10.3697 6.19792 10.6904H2.21354C1.68229 9.78174 1.41667 8.76615 1.41667 7.6971C1.41667 4.16926 4.57465 1.28285 8.5 1.28285C12.3958 1.28285 15.5833 4.16926 15.5833 7.6971C15.5833 8.76615 15.2882 9.78174 14.7569 10.6904ZM12.75 4.70379C12.75 4.24944 12.3073 3.84855 11.8056 3.84855C11.2743 3.84855 10.8611 4.24944 10.8611 4.70379C10.8611 5.18485 11.2743 5.55902 11.8056 5.55902C12.3073 5.55902 12.75 5.18485 12.75 4.70379ZM12.2778 7.6971C12.2778 8.17817 12.691 8.55234 13.2222 8.55234C13.724 8.55234 14.1667 8.17817 14.1667 7.6971C14.1667 7.24276 13.724 6.84187 13.2222 6.84187C12.691 6.84187 12.2778 7.24276 12.2778 7.6971Z" />
      </svg>
    )
  };

  if (icons.hasOwnProperty(tag)) {
    const icon = icons[tag];
    const cloneProps = { ...rest };
    if (Object.keys(cloneProps).length) {
      return cloneElement(icon, cloneProps);
    }
    return icon;
  }
  return "";
};
